//----------------------
// <auto-generated>
//     Split from WebApiController.ts
//     Regenerate with: node scripts/splitWebApiController.js
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming


export interface AccountingEventExportResult {
    exportId: number;
    status: string;
    stream: string;
    format: string | null;
    createdAt: string;
    completedAt: string | null;
    rowCount: number | null;
    downloadUrl: string | null;
    expiresAt: string | null;
    dataThrough: string | null;
    errorMessage: string | null;
    periodStart: string | null;
    periodEnd: string | null;
    isScheduled: boolean;
}

export interface CreateAccountingEventExportInput {
    stream: string;
    createDateFrom: string | null;
    createDateTo: string | null;
    effectiveDateFrom: string | null;
    effectiveDateTo: string | null;
    entityId: number | null;
}

export interface AccountingEventExportScheduleResult {
    stream: string;
    frequencyId: string;
    timezone: string;
    enabled: boolean;
}

export interface AccountingEventPreviewResult {
    downloadUrl: string;
    rowCount: number;
    isTruncated: boolean;
}

export interface AccountTaxRate {
    id: number;
    countryCode: string;
    stateProvince: string | null;
    zipCode: string | null;
    taxRate: number;
}

export interface BatchUpsertAccountTaxRatesRequest {
    rules: AccountTaxRateUpsertItem[];
}

export interface AccountTaxRateUpsertItem {
    countryCode: string;
    stateProvince: string | null;
    zipCode: string | null;
    taxRate: number;
}

export interface ImportAccountTaxRatesResponse {
    upsertedCount: number;
    skipCount: number;
    errors: string[];
}

export interface ActivityLog {
    activityLogId: number;
    entityId: number;
    entityType: ActionOutboxEntityType;
    actionDate: string;
    initiatedBy: ActivityLogInitiatedByUser;
    initiatedByImpersonated: ActivityLogInitiatedByUser | null;
    actionType: ActionType;
    auditActionType: AuditActionType | null;
    actionTypeDisplay: string;
    additionalInfo: ActivityLogAdditionalInformationDictionaryOfActivityLogValueChange;
    event: Event | null;
    performer: Performer | null;
    venue: Venue | null;
    tagName: string | null;
}

export enum ActionOutboxEntityType {
    Sale = "Sale",
    Listing = "Listing",
    Purchase = "Purchase",
    SellerSupportCase = "SellerSupportCase",
    Document = "Document",
    SellerEvent = "SellerEvent",
    InboundEmail = "InboundEmail",
    TicketGroup = "TicketGroup",
}

export interface ActivityLogInitiatedByUser {
    userId: string;
    username: string | null;
}

export enum ActionType {
    SaleConfirm = "SaleConfirm",
    SaleReject = "SaleReject",
    SaleUploadBarcodes = "SaleUploadBarcodes",
    SaleUploadTicketUrls = "SaleUploadTicketUrls",
    SaleUploadProofOfTransfer = "SaleUploadProofOfTransfer",
    SaleUploadEtickets = "SaleUploadEtickets",
    SaleMarketplaceInsert = "SaleMarketplaceInsert",
    SaleMarketplaceUpdate = "SaleMarketplaceUpdate",
    SaleBroadcastConfirmSale = "SaleBroadcastConfirmSale",
    SaleBroadcastRejectSale = "SaleBroadcastRejectSale",
    SaleBroadcastUploadBarcodes = "SaleBroadcastUploadBarcodes",
    SaleBroadcastUploadETickets = "SaleBroadcastUploadETickets",
    SaleBroadcastUploadTransferProof = "SaleBroadcastUploadTransferProof",
    SaleBroadcastUploadTransferUrls = "SaleBroadcastUploadTransferUrls",
    SaleViewed = "SaleViewed",
    SaleDeallocate = "SaleDeallocate",
    SaleMarketplaceUpdateTicketType = "SaleMarketplaceUpdateTicketType",
    SaleHoldTickets = "SaleHoldTickets",
    SaleHoldExpire = "SaleHoldExpire",
    SaleHoldCreate = "SaleHoldCreate",
    SaleUploadTransferProofId = "SaleUploadTransferProofId",
    SaleBroadcastUploadTransferProofId = "SaleBroadcastUploadTransferProofId",
    SaleUpdateTicketType = "SaleUpdateTicketType",
    SaleTicketMasterBarcodeTransfer = "SaleTicketMasterBarcodeTransfer",
    SaleCostUpdate = "SaleCostUpdate",
    SaleCostInsert = "SaleCostInsert",
    SaleCostDelete = "SaleCostDelete",
    SaleBroadcastUpdateTicketType = "SaleBroadcastUpdateTicketType",
    SaleConfirmTransferWithoutProof = "SaleConfirmTransferWithoutProof",
    SaleResetFulfillment = "SaleResetFulfillment",
    SaleTotalProceedsUpdate = "SaleTotalProceedsUpdate",
    SaleDocumentUploadActivity = "SaleDocumentUploadActivity",
    SaleFulfillWithoutArtifacts = "SaleFulfillWithoutArtifacts",
    SaleNoFulfillUpdate = "SaleNoFulfillUpdate",
    SaleTicketsAllocatedAction = "SaleTicketsAllocatedAction",
    SaleCommissionsUpdate = "SaleCommissionsUpdate",
    SaleRemoveTicketUserDocuments = "SaleRemoveTicketUserDocuments",
    SaleUpdatePaymentState = "SaleUpdatePaymentState",
    SaleRequestAutoPoTransfer = "SaleRequestAutoPoTransfer",
    ListingInsert = "ListingInsert",
    ListingUpdateUnitNetProceeds = "ListingUpdateUnitNetProceeds",
    ListingUpdateAllInPrice = "ListingUpdateAllInPrice",
    ListingUpdateDeliveryType = "ListingUpdateDeliveryType",
    ListingUpdateSplitType = "ListingUpdateSplitType",
    ListingUpdateInHandDate = "ListingUpdateInHandDate",
    ListingUpdateHideSeats = "ListingUpdateHideSeats",
    ListingSplit = "ListingSplit",
    ListingMerge = "ListingMerge",
    ListingBroadcast = "ListingBroadcast",
    ListingUnbroadcast = "ListingUnbroadcast",
    ListingMarketplaceInsert = "ListingMarketplaceInsert",
    ListingMarketplaceUpdate = "ListingMarketplaceUpdate",
    ListingMarketplaceDelete = "ListingMarketplaceDelete",
    ListingUpdatePricerUserId = "ListingUpdatePricerUserId",
    BroadcastMarketplaceListing = "BroadcastMarketplaceListing",
    UnbroadcastMarketplaceListing = "UnbroadcastMarketplaceListing",
    ListingBroadcastMergeListing = "ListingBroadcastMergeListing",
    ListingBroadcastSplitListing = "ListingBroadcastSplitListing",
    ListingBroadcastUpdateInHandDate = "ListingBroadcastUpdateInHandDate",
    ListingBroadcastUpdateAllInPrice = "ListingBroadcastUpdateAllInPrice",
    ListingBroadcastUpdateUnitNetProceeds = "ListingBroadcastUpdateUnitNetProceeds",
    ListingBroadcastUpdateSplitType = "ListingBroadcastUpdateSplitType",
    ListingBroadcastUpdateDeliveryType = "ListingBroadcastUpdateDeliveryType",
    ListingViewed = "ListingViewed",
    ListingDelete = "ListingDelete",
    ListingUpdateQuantity = "ListingUpdateQuantity",
    ListingBroadcastUpdateQuantity = "ListingBroadcastUpdateQuantity",
    ListingUpdateListingNotes = "ListingUpdateListingNotes",
    ListingBroadcastUpdateListingNotes = "ListingBroadcastUpdateListingNotes",
    ListingUpdateSeating = "ListingUpdateSeating",
    ListingBroadcastUpdateSeating = "ListingBroadcastUpdateSeating",
    ListingPreDeliverBarcodes = "ListingPreDeliverBarcodes",
    ListingPreDeliverETickets = "ListingPreDeliverETickets",
    ListingRebroadcast = "ListingRebroadcast",
    ListingSyncUpdate = "ListingSyncUpdate",
    ListingUpdateNetProceedsFloor = "ListingUpdateNetProceedsFloor",
    ListingAutoPricingConfig = "ListingAutoPricingConfig",
    ListingAutoPricingResultUpdate = "ListingAutoPricingResultUpdate",
    ListingPreDeliverTicketExternalIds = "ListingPreDeliverTicketExternalIds",
    ListingPreDeliverTicketUrls = "ListingPreDeliverTicketUrls",
    ListingMarketplaceSeatingOverrideUpdate = "ListingMarketplaceSeatingOverrideUpdate",
    ListingRemoveTicketBarcodes = "ListingRemoveTicketBarcodes",
    ListingRemoveTicketUserDocuments = "ListingRemoveTicketUserDocuments",
    ListingUploadVerificationDocumentAction = "ListingUploadVerificationDocumentAction",
    ListingCompsViewed = "ListingCompsViewed",
    ListingOfflineSaleAdded = "ListingOfflineSaleAdded",
    ListingDocumentViewed = "ListingDocumentViewed",
    ListingDocumentDownloaded = "ListingDocumentDownloaded",
    ListingBroadcastUploadVerificationDocument = "ListingBroadcastUploadVerificationDocument",
    ListingBroadcastUpdateHideSeats = "ListingBroadcastUpdateHideSeats",
    ListingDocumentUploadActivity = "ListingDocumentUploadActivity",
    ListingUpdateUnitCost = "ListingUpdateUnitCost",
    ListingUpdateInternalNotes = "ListingUpdateInternalNotes",
    ListingNoFulfillUpdate = "ListingNoFulfillUpdate",
    ListingUpdateAdminHold = "ListingUpdateAdminHold",
    ListingListingGroupUpdate = "ListingListingGroupUpdate",
    ListingSaleConfirm = "ListingSaleConfirm",
    ListingSaleDeallocate = "ListingSaleDeallocate",
    ListingSaleMarketplaceInsert = "ListingSaleMarketplaceInsert",
    ListingUpdateTopTicketType = "ListingUpdateTopTicketType",
    ListingUpdateDuplicateAttribute = "ListingUpdateDuplicateAttribute",
    ListingUpdateEventId = "ListingUpdateEventId",
    SellerSupportCaseCreate = "SellerSupportCaseCreate",
    SellerSupportCaseReply = "SellerSupportCaseReply",
    PurchaseInsert = "PurchaseInsert",
    PurchaseTicketGroupsMerge = "PurchaseTicketGroupsMerge",
    PurchasePaymentsMerge = "PurchasePaymentsMerge",
    PurchaseCostsMerge = "PurchaseCostsMerge",
    PurchaseUpdate = "PurchaseUpdate",
    PurchaseTicketGroupUpdate = "PurchaseTicketGroupUpdate",
    PurchaseTicketGroupInsert = "PurchaseTicketGroupInsert",
    PurchaseTicketGroupDelete = "PurchaseTicketGroupDelete",
    PurchasePaymentUpdate = "PurchasePaymentUpdate",
    PurchasePaymentInsert = "PurchasePaymentInsert",
    PurchasePaymentDelete = "PurchasePaymentDelete",
    PurchaseCostUpdate = "PurchaseCostUpdate",
    PurchaseCostInsert = "PurchaseCostInsert",
    PurchaseCostDelete = "PurchaseCostDelete",
    PurchaseCancel = "PurchaseCancel",
    PurchaseVoid = "PurchaseVoid",
    PurchaseResetListings = "PurchaseResetListings",
    PurchaseOrderQualityStateUpdate = "PurchaseOrderQualityStateUpdate",
    SaleDocumentUpload = "SaleDocumentUpload",
    ListingDocumentUpload = "ListingDocumentUpload",
    InboundEmailReprocess = "InboundEmailReprocess",
}

export enum AuditActionType {
    TagCreate = "TagCreate",
    TagUpdate = "TagUpdate",
    TagDelete = "TagDelete",
    TagTypeCreate = "TagTypeCreate",
    TagTypeUpdate = "TagTypeUpdate",
    SaleInternalNotesUpdate = "SaleInternalNotesUpdate",
    SaleInternalNotesInsert = "SaleInternalNotesInsert",
    ListingSellerEventUpdate = "ListingSellerEventUpdate",
    PurchaseCommissionUpdate = "PurchaseCommissionUpdate",
    PurchaseCommissionInsert = "PurchaseCommissionInsert",
    PurchaseInternalNotesUpdate = "PurchaseInternalNotesUpdate",
    PurchaseInternalNotesInsert = "PurchaseInternalNotesInsert",
}

export interface ActivityLogAdditionalInformationDictionaryOfActivityLogValueChange {

    [key: string]: ActivityLogValueChange | any;
}

export interface ActivityLogValueChange {
    oldValue: string | null;
    newValue: string | null;
    message: ActivityLogMessage | null;
}

export interface ActivityLogMessage {
    errorCode: string | null;
    message: string | null;
    state: MarketplaceOperationResultState;
}

export enum MarketplaceOperationResultState {
    Succeeded = "Succeeded",
    FailedWithRetryableError = "FailedWithRetryableError",
    FailedWithNonRetryableError = "FailedWithNonRetryableError",
    FailedAndRequiresSellerAction = "FailedAndRequiresSellerAction",
    NotImplemented = "NotImplemented",
    Skipped = "Skipped",
}

export interface CatalogEntity {
    viagId: number | null;
    name: string;
    shortName: string | null;
}

export interface Event extends CatalogEntity {
    rowVer: number | null;
    posIds: string[];
    posId: string | null;
    virtId: string;
    oldVirtIds: string[] | null;
    mpId: string | null;
    dates: DateTimeRange;
    datesUtc: DateTimeRange;
    onSaleDate: string | null;
    rawOnSaleDate: string | null;
    rawPreSaleDate: string | null;
    evType: string | null;
    evStat: ApiEventStatus | null;
    perfId: number | null;
    venId: number;
    venCfgId: number | null;
    genre: TopLevelCategory;
    mapRejRsnId: number | null;
    mapRejDftTxt: string | null;
    origStartDate: string | null;
    origStartDateUtc: string | null;
}

export interface DateTimeRange {
    start: string | null;
    end: string | null;
}

export enum ApiEventStatus {
    Normal = "Normal",
    Postponed = "Postponed",
    Cancelled = "Cancelled",
    Rescheduled = "Rescheduled",
    Relocated = "Relocated",
    RelocatedAndRescheduled = "RelocatedAndRescheduled",
    Draft = "Draft",
    Deleted = "Deleted",
    Contingent = "Contingent",
}

export enum TopLevelCategory {
    Theatre = "Theatre",
    Sports = "Sports",
    Concert = "Concert",
    Festival = "Festival",
}

export interface Performer extends CatalogEntity {
    categ: TopLevelCategory[];
    genreId: number | null;
    grName: string | null;
}

export interface Venue extends CatalogEntity {
    city: string | null;
    state: string | null;
    ctryCode: string | null;
    pstlCode: string | null;
    cap: number | null;
    excludeSearch: boolean;
}

export interface ActivityLogQuery {
    userId: string | null;
    includeUserOnly: boolean | null;
    impersonatedUserId: string | null;
    entityId: number | null;
    entityType: ActionOutboxEntityType | null;
    actionTypes: ActionType[] | null;
    auditActionTypes: AuditActionType[] | null;
    take: number | null;
    skip: number | null;
    tagName: string | null;
}

export enum DocumentType {
    ETicket = "ETicket",
    TicketTransfer = "TicketTransfer",
    AirBill = "AirBill",
    PKPass = "PKPass",
    GoogleWallet = "GoogleWallet",
    ListingVerification = "ListingVerification",
    QRCode = "QRCode",
}

export interface StateProvince {
    id: number;
    name: string;
    countryName: string;
    cId: number | null;
}

export interface City {
    id: number;
    name: string;
    stateProvinceName: string | null;
    countryName: string;
    cId: number | null;
}

export interface ReactAppContext {
    stage: string;
    appName: string;
    isNativeApp: boolean;
    cobrandId: CoBrandId;
    environment: string;
    features: FeatureDetail[];
    isDevelopment: boolean;
    version: string;
    sponsoredListingsAllowedCountryCodes: string[];
}

export enum CoBrandId {
    Viagogo = "Viagogo",
    TicketUtil = "TicketUtil",
    Starburst = "Starburst",
    ReachPro = "ReachPro",
    StubHub = "StubHub",
}

export interface FeatureDetail {
    id: Feature;
    state: FeatureState;
}

export enum Feature {
    AutoPricing = "AutoPricing",
    HomePageActivityLog = "HomePageActivityLog",
    OneTicketTransferApi = "OneTicketTransferApi",
    AdvanceAutopricingModes = "AdvanceAutopricingModes",
    CompListingMode_ParentListing = "CompListingMode_ParentListing",
    ExportInventory = "ExportInventory",
    ListingIdForCompListings = "ListingIdForCompListings",
    InventoryEventRecentTransactions = "InventoryEventRecentTransactions",
    ScaledSeatScore = "ScaledSeatScore",
    SeatSaver = "SeatSaver",
    ConfirmTransferWithoutProof = "ConfirmTransferWithoutProof",
    UpdatedVenueMapPrompt = "UpdatedVenueMapPrompt",
    ReportSnapshot = "ReportSnapshot",
    DisplayBuildVersion = "DisplayBuildVersion",
    PricedAtZeroFilter = "PricedAtZeroFilter",
    PriceByWebsitePrice = "PriceByWebsitePrice",
    ExcludeFanInventory = "ExcludeFanInventory",
    ArAgingReport = "ArAgingReport",
    InventoryEventPageV2 = "InventoryEventPageV2",
    DynamicPricingBySTR = "DynamicPricingBySTR",
    GroupingDrip = "GroupingDrip",
    SaleSkyboxNotesSection = "SaleSkyboxNotesSection",
    EnableDisableMarketplaces = "EnableDisableMarketplaces",
    AutoCompAndGroup = "AutoCompAndGroup",
    ExcludeFullySoldInGroup = "ExcludeFullySoldInGroup",
    ReportingV2 = "ReportingV2",
    AutoFulfillSetting = "AutoFulfillSetting",
    SponsoredListings = "SponsoredListings",
    VenueMapRectSelect = "VenueMapRectSelect",
    FulfillmentProviders = "FulfillmentProviders",
    AutoGroupAndCompV2 = "AutoGroupAndCompV2",
    ListingGroupingMethods = "ListingGroupingMethods",
    PricingV2DemandDashboard = "PricingV2DemandDashboard",
    PricingABTest = "PricingABTest",
    EnableNativeSyncToggle = "EnableNativeSyncToggle",
    BulkUpdateIndividualTicketGroup = "BulkUpdateIndividualTicketGroup",
    AutoCompRankOverrides = "AutoCompRankOverrides",
    UpgradedGroupListingView = "UpgradedGroupListingView",
    UpcomingOnSalesPage = "UpcomingOnSalesPage",
    RemoveUiGateOnUnmap = "RemoveUiGateOnUnmap",
    SortListingsInGroup = "SortListingsInGroup",
    ReorderListingInGroup = "ReorderListingInGroup",
    BackfillDeliveryStrategyInventoryEventToSales = "BackfillDeliveryStrategyInventoryEventToSales",
    BackfillDeliveryStrategyPurchaseEventToSales = "BackfillDeliveryStrategyPurchaseEventToSales",
    BackfillDeliveryStrategyVendorAccountToSales = "BackfillDeliveryStrategyVendorAccountToSales",
    FullPageEventViewEntitySelection = "FullPageEventViewEntitySelection",
    CompQuantitiesFilter = "CompQuantitiesFilter",
    DefaultNotToMergeHoldListings = "DefaultNotToMergeHoldListings",
    CustomDeliveryType = "CustomDeliveryType",
    ListingNotesAdditionalInfo = "ListingNotesAdditionalInfo",
    BulkEditsToListingGroups = "BulkEditsToListingGroups",
    ExcludeDefects = "ExcludeDefects",
    FufillmentMismatchDisplay = "FufillmentMismatchDisplay",
    EventMultiScreen = "EventMultiScreen",
    DefaultFilterRows = "DefaultFilterRows",
    ReconcileOrphanTickets = "ReconcileOrphanTickets",
    SelectDeliveryStrategyInSeatSaver = "SelectDeliveryStrategyInSeatSaver",
    ListingGroupCompUi = "ListingGroupCompUi",
    YourListingsInComps = "YourListingsInComps",
    NewListingDefaultToSpeculativeRowId = "NewListingDefaultToSpeculativeRowId",
    RightNowStatsInMap = "RightNowStatsInMap",
    ConsignmentDeal = "ConsignmentDeal",
    FilterByCurrencyCodeMulti = "FilterByCurrencyCodeMulti",
    FilterByPaymentCurrencyCodeMulti = "FilterByPaymentCurrencyCodeMulti",
    AttemptFulfillWhenToggleOnAutoFulfill = "AttemptFulfillWhenToggleOnAutoFulfill",
    SaleDetailDisplayTicketUrl = "SaleDetailDisplayTicketUrl",
    PreventInitialBroadcastForXDays = "PreventInitialBroadcastForXDays",
    AutoCompPersistAllConfigChanges = "AutoCompPersistAllConfigChanges",
    ManageMarketplacePayment = "ManageMarketplacePayment",
    HideAutoCompOnlyBulkEditOption = "HideAutoCompOnlyBulkEditOption",
    PreventDraftPOinUI = "PreventDraftPOinUI",
    AllowSeatScoreCompListingMode = "AllowSeatScoreCompListingMode",
    DemandDashLastDaySupplyMetrics = "DemandDashLastDaySupplyMetrics",
    GroupingWizard = "GroupingWizard",
    IntelligiblePricePreviewForListingGroup = "IntelligiblePricePreviewForListingGroup",
    MoveToGroup = "MoveToGroup",
    QuickFloorToolbar = "QuickFloorToolbar",
    AutoPricingBulkEditToDrawerWithPreview = "AutoPricingBulkEditToDrawerWithPreview",
    CancelSaleKeepTickets = "CancelSaleKeepTickets",
    ConvertSaleCurrency = "ConvertSaleCurrency",
    MultiTicketGroupTable = "MultiTicketGroupTable",
    EventDiscoveryPage = "EventDiscoveryPage",
    SeatTraitsColumn = "SeatTraitsColumn",
    BlockEventDiscoveryData = "BlockEventDiscoveryData",
    CompListingDisplayUpdate = "CompListingDisplayUpdate",
    CatalogMetricsV2 = "CatalogMetricsV2",
    ReportV2CommissionsReport = "ReportV2CommissionsReport",
    KnowledgePortalPageTestData = "KnowledgePortalPageTestData",
    SearchView_ReadOnlyDB = "SearchView_ReadOnlyDB",
    HomePageNotifications = "HomePageNotifications",
    EventsDetailedViewGrouping = "EventsDetailedViewGrouping",
    GlobalReportV1RedirectV2 = "GlobalReportV1RedirectV2",
    BlockInventorySummaryStats = "BlockInventorySummaryStats",
    HideNavAndFilterBars = "HideNavAndFilterBars",
    ReportSinglePagedV1V2 = "ReportSinglePagedV1V2",
    BackfillListingTicketTypeOverrideToSale = "BackfillListingTicketTypeOverrideToSale",
    SeatTraitsColumnSales = "SeatTraitsColumnSales",
    AccessibilityMode = "AccessibilityMode",
    DisplayMarketplaceSeatingOverride = "DisplayMarketplaceSeatingOverride",
    BulkCreatePurchase = "BulkCreatePurchase",
    RemoveEventAccordian = "RemoveEventAccordian",
    UnsoldTicketsFilter = "UnsoldTicketsFilter",
    MarketplaceSaleAvoidIdPrefill = "MarketplaceSaleAvoidIdPrefill",
    EditMarketplaceSaleId_Offline = "EditMarketplaceSaleId_Offline",
    EditMarketplaceSaleId_Marketplace = "EditMarketplaceSaleId_Marketplace",
    OnSaleEventDetailsView = "OnSaleEventDetailsView",
    GlobalReportV1RedirectV2_ActiveInventory = "GlobalReportV1RedirectV2_ActiveInventory",
    GlobalReportV1RedirectV2_DailySales = "GlobalReportV1RedirectV2_DailySales",
    GlobalReportV1RedirectV2_EventPandL = "GlobalReportV1RedirectV2_EventPandL",
    GlobalReportV1RedirectV2_MarketplacePerformance = "GlobalReportV1RedirectV2_MarketplacePerformance",
    GlobalReportV1RedirectV2_PerformerPandL = "GlobalReportV1RedirectV2_PerformerPandL",
    GlobalReportV1RedirectV2_SoldInventory = "GlobalReportV1RedirectV2_SoldInventory",
    GlobalReportV1RedirectV2_CommissionReport = "GlobalReportV1RedirectV2_CommissionReport",
    ExcludeToIncludeFanInv = "ExcludeToIncludeFanInv",
    HideEventDiscoveryDemandData = "HideEventDiscoveryDemandData",
    ReportSnapshotBackgroundExport = "ReportSnapshotBackgroundExport",
    UseGrpcCache = "UseGrpcCache",
    BackfillCancelledProceeds = "BackfillCancelledProceeds",
    AvoidRowVersionUpdateForSectionalUpdate = "AvoidRowVersionUpdateForSectionalUpdate",
    EditRevealSyncDate = "EditRevealSyncDate",
    ReportsSummaryFetchAll = "ReportsSummaryFetchAll",
    PurchaseLineItemReport = "PurchaseLineItemReport",
    CompareGrpcCacheWithLiveCounts = "CompareGrpcCacheWithLiveCounts",
    AllowAddCostOnCancelledPO = "AllowAddCostOnCancelledPO",
    RatioToReportCustomCol = "RatioToReportCustomCol",
    AvgCntForReports = "AvgCntForReports",
    UseGrpcCache_ListingCounts = "UseGrpcCache_ListingCounts",
    UseGrpcCache_SaleCounts = "UseGrpcCache_SaleCounts",
    UseGrpcCache_PurchaseCounts = "UseGrpcCache_PurchaseCounts",
    RowOffsetOnManualSections = "RowOffsetOnManualSections",
    EventDiscoveryTransactionPrice = "EventDiscoveryTransactionPrice",
    CostChangeReports = "CostChangeReports",
    AutoLinkSaleLineItemSetting = "AutoLinkSaleLineItemSetting",
    SelectedSectionScoreRecommendations = "SelectedSectionScoreRecommendations",
    PersistentTagCreate = "PersistentTagCreate",
    FavoritePaymentMethods = "FavoritePaymentMethods",
    EventPricingTeam = "EventPricingTeam",
    AutoSplitDiscontinuousListingSetting = "AutoSplitDiscontinuousListingSetting",
    PricingSettingStrategyWithFallback = "PricingSettingStrategyWithFallback",
    CompareGrpcCacheWithLiveMetrics = "CompareGrpcCacheWithLiveMetrics",
    EventDiscoveryNotifications = "EventDiscoveryNotifications",
    RowIdFilterWithRowRange = "RowIdFilterWithRowRange",
    TagsUiV3 = "TagsUiV3",
    SellerEventAlertMutes = "SellerEventAlertMutes",
    RemovePriceIncreaseRoadbump = "RemovePriceIncreaseRoadbump",
    TableFooterColumnVirtualized = "TableFooterColumnVirtualized",
    SelectedSectionRecsByConfigVenueType = "SelectedSectionRecsByConfigVenueType",
    TableTotals_Inventory = "TableTotals_Inventory",
    TableTotals_Payments = "TableTotals_Payments",
    TableTotals_Events = "TableTotals_Events",
    UseGrpcCache_AllowStaleData = "UseGrpcCache_AllowStaleData",
    SurfacePricingStates = "SurfacePricingStates",
    EnableSelectionByDefaultSetting = "EnableSelectionByDefaultSetting",
    ManualPriceStaggers = "ManualPriceStaggers",
    RecentSalesTableV3 = "RecentSalesTableV3",
    SetCeilingOnPricingOnePager = "SetCeilingOnPricingOnePager",
    SalesTableV2 = "SalesTableV2",
    AutoCleanupBrowserData = "AutoCleanupBrowserData",
    PurchaseInternalIdColumnDisplay = "PurchaseInternalIdColumnDisplay",
    ListingTableV2 = "ListingTableV2",
    UseGrpcCache_BatchEventIds = "UseGrpcCache_BatchEventIds",
    BulkEditAutoPricingPriceAgainstMySection = "BulkEditAutoPricingPriceAgainstMySection",
    ReducedBroadcastStatusPullingFrequency = "ReducedBroadcastStatusPullingFrequency",
    SurfaceFirstListingInGroup = "SurfaceFirstListingInGroup",
    StubHubListingFilterWithPurchaseQuantities = "StubHubListingFilterWithPurchaseQuantities",
    ShowEventTagOnEventTile = "ShowEventTagOnEventTile",
    InventoryStatsInStubhubSidePanel = "InventoryStatsInStubhubSidePanel",
    AdvancedSearchV2 = "AdvancedSearchV2",
    TicketGroupReport = "TicketGroupReport",
    BulkEditListingPricingBasedOffUnitCost = "BulkEditListingPricingBasedOffUnitCost",
    ReachProSupport = "ReachProSupport",
    PurchaseTableV2 = "PurchaseTableV2",
    CleanUpOutdatedPricingState = "CleanUpOutdatedPricingState",
    RefetchCatalogAndEntityOnNavigate_All = "RefetchCatalogAndEntityOnNavigate_All",
    RefetchCatalogAndEntityOnNavigate_Purchase = "RefetchCatalogAndEntityOnNavigate_Purchase",
    RefetchCatalogAndEntityOnNavigate_Sales = "RefetchCatalogAndEntityOnNavigate_Sales",
    RefetchCatalogAndEntityOnNavigate_Inventory = "RefetchCatalogAndEntityOnNavigate_Inventory",
    MinimalFiltersForMetrics_Inventory = "MinimalFiltersForMetrics_Inventory",
    UserSettingOnTableSorting = "UserSettingOnTableSorting",
    DataExportFormatDateAsAccountTimeZone = "DataExportFormatDateAsAccountTimeZone",
    MinMaxInCustomColumn = "MinMaxInCustomColumn",
    TableRowSelectionV2 = "TableRowSelectionV2",
    EventDiscoveryInInventoryView = "EventDiscoveryInInventoryView",
    CompanionModeInInsightView = "CompanionModeInInsightView",
    FrontendTelemetryContext = "FrontendTelemetryContext",
    GlobalReportV1RedirectV2_PurchasedInventory = "GlobalReportV1RedirectV2_PurchasedInventory",
    GlobalReportV1RedirectV2_CanceledInventory = "GlobalReportV1RedirectV2_CanceledInventory",
    GlobalReportV1RedirectV2_All = "GlobalReportV1RedirectV2_All",
    ReplaceUnsoldWithAvailableTickets = "ReplaceUnsoldWithAvailableTickets",
    CreateSaleInvoice = "CreateSaleInvoice",
    ShouldAutoCleanupBrowserCache = "ShouldAutoCleanupBrowserCache",
    ReportV2RealtimeOption = "ReportV2RealtimeOption",
    InsightsViewTableFilters = "InsightsViewTableFilters",
    GroupListingsAcrossEvents = "GroupListingsAcrossEvents",
    POCreationInternalNotesColumn = "POCreationInternalNotesColumn",
    CompListingsSeatNumbers = "CompListingsSeatNumbers",
    NoScrollDependencyOnVirtuoso = "NoScrollDependencyOnVirtuoso",
    RecentSalesV2PurchasedByColumn = "RecentSalesV2PurchasedByColumn",
    AdvancedSearchV2_Purchase = "AdvancedSearchV2_Purchase",
    AdvancedSearchV2_Sales = "AdvancedSearchV2_Sales",
    AdvancedSearchV2_Inventory = "AdvancedSearchV2_Inventory",
    UserTeams = "UserTeams",
    PurchaseDefaultDateFilterLast365Days = "PurchaseDefaultDateFilterLast365Days",
    DonateListing = "DonateListing",
    GroupedVirtuosoRowWrapperFix = "GroupedVirtuosoRowWrapperFix",
    ShowGigsbergInBroadcastTableForIntlEvents = "ShowGigsbergInBroadcastTableForIntlEvents",
    SponsoredListingsV2_SpecificZonesTargeting = "SponsoredListingsV2_SpecificZonesTargeting",
    SponsoredListingsV2_First3RowsOnly = "SponsoredListingsV2_First3RowsOnly",
    NumberInputWithLeadingZero = "NumberInputWithLeadingZero",
    BulkUploadOfflineMarketplacePaymentLine = "BulkUploadOfflineMarketplacePaymentLine",
    CreatePOTicketGroupsInChunk = "CreatePOTicketGroupsInChunk",
    MarketOrders = "MarketOrders",
    ReworkListingPriceForm = "ReworkListingPriceForm",
    SpoilTicketsInSale = "SpoilTicketsInSale",
    PricedByColumn = "PricedByColumn",
    AddTotalCostPurchaseUpload = "AddTotalCostPurchaseUpload",
    SponsoredListingsV2_MultiCampaignsSupport = "SponsoredListingsV2_MultiCampaignsSupport",
    CustomPurchaseColumns = "CustomPurchaseColumns",
    SelectGroupAfterCreation = "SelectGroupAfterCreation",
    DropdownPortalClickFix = "DropdownPortalClickFix",
    MultiColumnSort = "MultiColumnSort",
    ReportsAIAssistant = "ReportsAIAssistant",
    RetailTab = "RetailTab",
    SponsoredListingsV2_StatsRollup = "SponsoredListingsV2_StatsRollup",
    SponsoredListingsV2_SeriesCharts = "SponsoredListingsV2_SeriesCharts",
    OnePagerWithNarrowContent = "OnePagerWithNarrowContent",
    ExpandGroupFromClick = "ExpandGroupFromClick",
    GroupQuantityTwoPlus = "GroupQuantityTwoPlus",
    AutoBroadcastWhenPricing = "AutoBroadcastWhenPricing",
    AvoidRefetchListingGroupSettingsAfterUpdate = "AvoidRefetchListingGroupSettingsAfterUpdate",
    QuickGroupBypassPreview = "QuickGroupBypassPreview",
    HideHiddenByFilter = "HideHiddenByFilter",
    FaceValueColumnPurchases = "FaceValueColumnPurchases",
    RetailSale = "RetailSale",
    AccountingAuditExport = "AccountingAuditExport",
    CouponBalance = "CouponBalance",
    SaleMultiCurrency = "SaleMultiCurrency",
    VendorTeamsPermission = "VendorTeamsPermission",
    EnterToConfirmBulk = "EnterToConfirmBulk",
    AccountingFeedUI = "AccountingFeedUI",
    CustomTabs = "CustomTabs",
    BulkPriceCalcRequestCancellation = "BulkPriceCalcRequestCancellation",
    SalesGroupView = "SalesGroupView",
    PlaceholderEventGroup = "PlaceholderEventGroup",
    SplitListingWithSeatTraitsRetained = "SplitListingWithSeatTraitsRetained",
    RetailTaxRate = "RetailTaxRate",
    SponsoredListingsV2_TargetRoas = "SponsoredListingsV2_TargetRoas",
    TotalCostEntryBoxFilter = "TotalCostEntryBoxFilter",
    BoostRules = "BoostRules",
    ExportSponsoredListingsSpend = "ExportSponsoredListingsSpend",
    RecentSalesTiles = "RecentSalesTiles",
    IncrementalRevenue = "IncrementalRevenue",
    BoostCredits = "BoostCredits",
    CleanPaymentDisplay = "CleanPaymentDisplay",
    CustomExternalPaymentTypes = "CustomExternalPaymentTypes",
    InvTagsInPOBulkUpload = "InvTagsInPOBulkUpload",
    UpdatePurchaseCreationSort = "UpdatePurchaseCreationSort",
    SaleLineItemReportExtendedColumnsFilters = "SaleLineItemReportExtendedColumnsFilters",
    ReEvaluatePredeliveryStateAndTopTicketType = "ReEvaluatePredeliveryStateAndTopTicketType",
    SelectedSectionSettingsDefaultWithZoneMap = "SelectedSectionSettingsDefaultWithZoneMap",
    BlockPricingCompListingEndpoint = "BlockPricingCompListingEndpoint",
    BlockPricingCalculationEndpoint = "BlockPricingCalculationEndpoint",
    BlockEventDashboardEndpoint = "BlockEventDashboardEndpoint",
    AlwaysGetEventLevelSettingsFromAutoPricer = "AlwaysGetEventLevelSettingsFromAutoPricer",
    WriteAutopriceConfigUpdateToSbt = "WriteAutopriceConfigUpdateToSbt",
    SetAsDefaultAllNewEvents = "SetAsDefaultAllNewEvents",
    AccountLevelFeatureCheck = "AccountLevelFeatureCheck",
    UpdateSaleStatusOnSiteCreation = "UpdateSaleStatusOnSiteCreation",
    BulkReturnTicket = "BulkReturnTicket",
    ExternalPosAndProcessorAuthEncryption = "ExternalPosAndProcessorAuthEncryption",
    FulfillmentRulesEventLevel = "FulfillmentRulesEventLevel",
    BackfillSalesFulfillerToEvent = "BackfillSalesFulfillerToEvent",
    RightHolderMarkAsFulfill = "RightHolderMarkAsFulfill",
    IncludeFanInventoryBroadcast = "IncludeFanInventoryBroadcast",
    GetListingAutoPricingSettingsReadListingPropsFromPricer = "GetListingAutoPricingSettingsReadListingPropsFromPricer",
    EnableMasterUiViewForConsignors = "EnableMasterUiViewForConsignors",
    FulfillmentRulesVenueLevel = "FulfillmentRulesVenueLevel",
    GetPurchasePerformanceImprovement = "GetPurchasePerformanceImprovement",
    ImprovePerfForUpdateListingSectionalApis = "ImprovePerfForUpdateListingSectionalApis",
    UserManagementMasterUiForConsignor = "UserManagementMasterUiForConsignor",
    MemorizeLastBroadcastListingMarketplace = "MemorizeLastBroadcastListingMarketplace",
    RemoveViewPricedListingsPerm = "RemoveViewPricedListingsPerm",
    GranularListingGroupSettingOverride = "GranularListingGroupSettingOverride",
    DefaultToMyRowOnSectionSelection = "DefaultToMyRowOnSectionSelection",
    DefaultGroupPricingSettings = "DefaultGroupPricingSettings",
    AutoPricingEmptySelectedSectionsNoComps = "AutoPricingEmptySelectedSectionsNoComps",
    ShowAmpSectionRecs = "ShowAmpSectionRecs",
    ShowConcertsSectionBehindStageSectionRecs = "ShowConcertsSectionBehindStageSectionRecs",
    ShowSportsOrConcerts360SectionRecs = "ShowSportsOrConcerts360SectionRecs",
    CleanUpPricingSettingsInListingHistory = "CleanUpPricingSettingsInListingHistory",
    UseListingGroupDefaultsFromPricer = "UseListingGroupDefaultsFromPricer",
    FixUpdateFloorAndCeilingIssues = "FixUpdateFloorAndCeilingIssues",
    EventVenueConfigIdFromEventService = "EventVenueConfigIdFromEventService",
    CalibrateTgUnitCostOnBackend = "CalibrateTgUnitCostOnBackend",
    AutoPricingCompRowOffsetMode = "AutoPricingCompRowOffsetMode",
    AutoPricingPausePriceUpdates = "AutoPricingPausePriceUpdates",
    AddCountryCodeInActionOutboxPayload = "AddCountryCodeInActionOutboxPayload",
    ExportCsvFilterColumns = "ExportCsvFilterColumns",
    AutoPricingCompFailureAction = "AutoPricingCompFailureAction",
    LinkProceedWithSaleLineItem = "LinkProceedWithSaleLineItem",
    AutoPricingWebsitePriceUndercuts = "AutoPricingWebsitePriceUndercuts",
    AutoPricingImprovedPricePreivewForVeloCB = "AutoPricingImprovedPricePreivewForVeloCB",
    UseGrpcCacheV2ListingsGetCount = "UseGrpcCacheV2ListingsGetCount",
    UseGrpcCacheV2ListingsGetMetrics = "UseGrpcCacheV2ListingsGetMetrics",
    TagMappingToDefaultBuyer = "TagMappingToDefaultBuyer",
    UseGrpcCacheV2EventsFilter = "UseGrpcCacheV2EventsFilter",
    PurchaseOverPayLogicBehindSetting = "PurchaseOverPayLogicBehindSetting",
    UseGrpcCacheV2SalesGetCount = "UseGrpcCacheV2SalesGetCount",
    UseGrpcCacheV2SalesGetMetrics = "UseGrpcCacheV2SalesGetMetrics",
    UseGrpcCacheV2PurchasesGetCount = "UseGrpcCacheV2PurchasesGetCount",
    UseGrpcCacheV2PurchasesGetMetrics = "UseGrpcCacheV2PurchasesGetMetrics",
    BulkSetPurchaseOrderCost = "BulkSetPurchaseOrderCost",
    EnableNativeSyncForTicketVault = "EnableNativeSyncForTicketVault",
    BulkUploadPurchaseListingPrivateNotes = "BulkUploadPurchaseListingPrivateNotes",
    OtherPurchaseOrderCostType = "OtherPurchaseOrderCostType",
    FullyLoadedUnitCost_UseStoredValue = "FullyLoadedUnitCost_UseStoredValue",
    SubGenreFilterExpansion = "SubGenreFilterExpansion",
    AdjustPurchaseFxRate = "AdjustPurchaseFxRate",
    PurchaseOrderFXConversion = "PurchaseOrderFXConversion",
    PurchaseOrderFXConversionDisplay = "PurchaseOrderFXConversionDisplay",
    BulkAutoPricingIncludePurchaseData = "BulkAutoPricingIncludePurchaseData",
    SyncUpdateListingPriceFromPricer = "SyncUpdateListingPriceFromPricer",
    SkipSeatScoreFetch = "SkipSeatScoreFetch",
    BulkCancelTGsTimeView = "BulkCancelTGsTimeView",
    DoNotTruncSMPWalletNote = "DoNotTruncSMPWalletNote",
    SetFloorToPercentOfMarketPriceDefault = "SetFloorToPercentOfMarketPriceDefault",
    FixTaxPaidFeature = "FixTaxPaidFeature",
    BlockVenueMapEndpoint = "BlockVenueMapEndpoint",
    BlockEventSearchEndpoint = "BlockEventSearchEndpoint",
    BlockListingUpdateEndpoint = "BlockListingUpdateEndpoint",
    BlockSaleMetricsEndpoint = "BlockSaleMetricsEndpoint",
    BulkUnwasteTickets = "BulkUnwasteTickets",
    UpdateSeatSaverSalesMarketFulfillmentToPendingIfIneligible = "UpdateSeatSaverSalesMarketFulfillmentToPendingIfIneligible",
    BulkUpdateTicketGroupFV = "BulkUpdateTicketGroupFV",
    B2BPurchase = "B2BPurchase",
    AdminHubSignalR = "AdminHubSignalR",
    InventorySalesPacingColumns = "InventorySalesPacingColumns",
    BuyerFilterForSales = "BuyerFilterForSales",
    YourBroadcastListingsInAllComps = "YourBroadcastListingsInAllComps",
    BulkUpdateTGSeating = "BulkUpdateTGSeating",
    EnableOffice = "EnableOffice",
    MobileSortSalesAndTicketProceeds = "MobileSortSalesAndTicketProceeds",
    UnbroadcastOnRescheduleSetting = "UnbroadcastOnRescheduleSetting",
    BuyerCreditRollout = "BuyerCreditRollout",
    ListingNoteWithRawContent = "ListingNoteWithRawContent",
    SalesReportTotalCostFilter = "SalesReportTotalCostFilter",
    BulkUploadSeatSaversEventMapping = "BulkUploadSeatSaversEventMapping",
    InventoryUnfulfilledPercentColumn = "InventoryUnfulfilledPercentColumn",
    BulkPurchasePaymentMethodSelector = "BulkPurchasePaymentMethodSelector",
    HideUnbroadcastableMarketplaces = "HideUnbroadcastableMarketplaces",
    InventoryPendingSourcingColumn = "InventoryPendingSourcingColumn",
    AutoPoManagedTransfer = "AutoPoManagedTransfer",
    ReportsSubgenreMapping = "ReportsSubgenreMapping",
    ShowEventOriginalStartDate = "ShowEventOriginalStartDate",
    ExtApiTvpBarcodeExternalIdUrlVal = "ExtApiTvpBarcodeExternalIdUrlVal",
    BatchInboundEmailContentBlobs = "BatchInboundEmailContentBlobs",
    IhdTimezoneFix = "IhdTimezoneFix",
    ConsignmentMultiAccountQueries = "ConsignmentMultiAccountQueries",
}

export enum FeatureState {
    Disabled = "Disabled",
    Restricted = "Restricted",
    GeneralAvailability = "GeneralAvailability",
    LimitedAvailability = "LimitedAvailability",
    InDevelopment = "InDevelopment",
}

export interface ReportingPagedResultOfReportingCampaignReport {
    totalItems: number;
    page: number;
    pageSize: number;
    items: ReportingCampaignReport[];
}

export interface ReportingCampaignReport {
    campaignId: number | null;
    eventIds: number[] | null;
    currentMetrics: ReportingPerformanceMetrics | null;
    totalMetrics: ReportingPerformanceMetrics | null;
}

export interface ReportingPerformanceMetrics {
    eventImpressions: number | null;
    participatingImpressions: number | null;
    adImpressions: number | null;
    platformAdSalesCount: number | null;
    platformAdSalesProceeds: number | null;
    adSalesCount: number | null;
    adSalesProceeds: number | null;
    clicks: number | null;
    adSpendUSD: number | null;
    potentialSales: number | null;
    potentialSalesProceeds: number | null;
    incrementalSellerProceedsUSD: number | null;
}

export interface ReportingPagedResultOfReportingFlightReport {
    totalItems: number;
    page: number;
    pageSize: number;
    items: ReportingFlightReport[];
}

export interface ReportingFlightReport {
    campaignId: number | null;
    flightId: number | null;
    startDate: string | null;
    endDate: string | null;
    metrics: ReportingPerformanceMetrics | null;
}

export interface ReportingEventCampaignMetrics {
    campaigns: ReportingCampaignReport[] | null;
}

export interface GetCampaignMetricsByEventIdsRequest {
    eventIds: number[];
    startDate: string;
    endDate: string;
}

export interface ReportingCampaignMetricsResult {
    campaigns: ReportingCampaignReport[] | null;
}

export interface GetCampaignMetricsByIdsRequest {
    campaignIds: number[];
    startDate: string;
    endDate: string;
}

export interface ReportingFlightMetricsResult {
    flights: ReportingFlightReport[] | null;
}

export interface GetFlightsMetricsByCampaignIdsRequest {
    campaignFlights: CampaignFlightsRequest[];
    startDate: string;
    endDate: string;
}

export interface CampaignFlightsRequest {
    campaignId: number;
    flightIds: number[];
}

export interface ReportingEventSectionReport {
    eventId: number;
    sections: ReportingSectionReport[] | null;
}

export interface ReportingSectionReport {
    sectionId: number;
    metrics: ReportingPerformanceMetrics | null;
}

export interface GetSectionMetricsByEventIdsRequest {
    eventIds: number[];
    startDate: string;
    endDate: string;
    sectionIds: number[];
}

export interface AdyenSessionResponse {
    sessionId: string;
    sessionData: string;
    clientKey: string;
    environment: string;
}

export interface AdyenSessionRequest {
    salesGroupId: string | null;
    saleId: number | null;
    amount: number;
    currencyCode: string;
    buyerEmail: string | null;
    returnUrl: string;
    reference: string | null;
    countryCode: string | null;
    lineItemCoverages: SaleLineItemCoverage[] | null;
}

export interface SaleLineItemCoverage {
    marketplacePaymentLineId: number;
    amountToPay: number;
}

export interface AdyenPaymentStatusResponse {
    resultCode: string;
    pspReference: string | null;
    saleId: number | null;
    settled: boolean;
}

export interface AdyenPaymentResultInput {
    resultCode: string;
    pspReference: string | null;
    sessionResult: string | null;
    merchantReference: string | null;
    lineItemCoverages: SaleLineItemCoverage[] | null;
}

export interface SubmitStoredPaymentRequest {
    salesGroupId: string | null;
    saleId: number | null;
    storedPaymentMethodId: string;
    amount: number;
    currencyCode: string;
    buyerEmail: string | null;
    reference: string | null;
    lineItemCoverages: SaleLineItemCoverage[] | null;
}

export interface AdyenRefundResponse {
    pspReference: string | null;
    status: string;
    merchantReference: string | null;
}

export interface AutoCampaignRuleModel {
    autoCampaignRuleId: number;
    ruleState: AutoCampaignRuleState;
    ruleName: string;
    campaignPriority: number;
    conditions: AutoCampaignRuleConditionModel[];
    campaignConfig: AutoCampaignConfigModel;
    lastUpdatedDateTime: string | null;
}

export enum AutoCampaignRuleState {
    Unknown = "Unknown",
    Enabled = "Enabled",
    Disabled = "Disabled",
    Deleted = "Deleted",
}

export interface AutoCampaignRuleConditionModel {
    conditionType: AutoCampaignConditionType;
    conditionOperator: AutoCampaignConditionOperator;
    integerValue: number | null;
    decimalValue: number | null;
    guidValue: string | null;
}

export enum AutoCampaignConditionType {
    Unknown = "Unknown",
    UnsoldUnitCost = "UnsoldUnitCost",
    UnsoldTickets = "UnsoldTickets",
    SellThroughRate = "SellThroughRate",
    TimeBeforeEventStart = "TimeBeforeEventStart",
    TimeAfterEventStart = "TimeAfterEventStart",
    TimeBeforeEventEnd = "TimeBeforeEventEnd",
    TimeBeforeOnSale = "TimeBeforeOnSale",
    TimeAfterOnSale = "TimeAfterOnSale",
    DisallowedPosEventId = "DisallowedPosEventId",
    TimeAfterEventEnd = "TimeAfterEventEnd",
}

export enum AutoCampaignConditionOperator {
    Unknown = "Unknown",
    Equals = "Equals",
    LessThan = "LessThan",
    GreaterThan = "GreaterThan",
    NotEqual = "NotEqual",
}

export interface AutoCampaignConfigModel {
    defaultCampaignCurrencyCode: string | null;
    defaultDailyBudgetAbsolute: number | null;
    defaultDailyBudgetPercentUnsoldCost: number | null;
    defaultBidTypeId: number;
    defaultBidStrategyId: number | null;
    defaultBidROAS: number | null;
    defaultMaxCampaignBudget: number | null;
}

export interface CreateAutoCampaignRuleRequest {
    ruleName: string;
    campaignPriority: number;
    conditions: AutoCampaignRuleConditionModel[];
    campaignConfig: AutoCampaignConfigModel;
}

export interface PreviewCreateAutoCampaignRuleResponse {
    campaignsToBeCreated: number;
}

export interface UpdateAutoCampaignRuleRequest extends CreateAutoCampaignRuleRequest {
    autoCampaignRuleId: number;
    ruleState: AutoCampaignRuleState;
}

export interface SetAutoCampaignRuleStateRequest {
    autoCampaignRuleId: number;
    ruleState: AutoCampaignRuleState;
    tearDownCampaignsOnStateChange: boolean;
}

export interface PreviewSetAutoCampaignRuleStateResponse {
    affectedCampaignCount: number;
}

export interface PreviewSetAutoCampaignRuleStateRequest {
    autoCampaignRuleId: number;
    ruleState: AutoCampaignRuleState;
}

export interface UpdateAutoCampaignPrioritiesRequest {
    ordering: AutoCampaignPriorityOrder[];
}

export interface AutoCampaignPriorityOrder {
    autoCampaignRuleId: number;
    campaignPriority: number;
}

export interface AutoPoInboundEmail {
    inboundEmailId: number;
    subject: string | null;
    fromEmailAddress: string | null;
    toEmailAddress: string | null;
    receiveDate: string | null;
    createDate: string;
    purchaseOrderVendorId: number | null;
    partialPurchaseOrderId: number | null;
    purchaseOrderId: number | null;
    saleId: number | null;
    classificationType: AutoPoInboundEmailClassificationType | null;
}

export enum AutoPoInboundEmailClassificationType {
    NewPurchaseOrder = "NewPurchaseOrder",
    ExistingPurchaseOrder = "ExistingPurchaseOrder",
    Junk = "Junk",
    OneTimePass = "OneTimePass",
    Password = "Password",
    TicketsAvailable = "TicketsAvailable",
    PurchaseCancelled = "PurchaseCancelled",
    EventCancelled = "EventCancelled",
    EventPostponed = "EventPostponed",
    EnjoyTheEvent = "EnjoyTheEvent",
    TransferSent = "TransferSent",
    TransferAccepted = "TransferAccepted",
    TransferExpired = "TransferExpired",
    NewSale = "NewSale",
    ConfirmationDeadline = "ConfirmationDeadline",
    ShippingDeadline = "ShippingDeadline",
    SaleCancelled = "SaleCancelled",
    OtherMarketplaceContact = "OtherMarketplaceContact",
}

export interface AutoPoInboundEmailQuery {
    inboundEmailIds: number[] | null;
}

export interface AutoPoPartialPurchaseOrderInboundEmail {
    inboundEmailId: number;
    subject: string | null;
    fromEmailAddress: string | null;
    toEmailAddress: string | null;
    purchaseOrderVendorId: number | null;
    receiveDate: string | null;
    createDate: string;
    partialPurchaseOrderId: number | null;
    orderId: string | null;
    quantity: number | null;
    faceValue: number | null;
    purchaseOrderDate: string | null;
    totalCount: number;
}

export interface AutoPoInboundEmailPartialPurchaseOrderQuery {
    classificationTypes: AutoPoInboundEmailClassificationType[] | null;
    includeUnclassified: boolean | null;
    subjectSearchText: string | null;
    fromEmailAddress: string | null;
    toEmailAddress: string | null;
    textBodySearchText: string | null;
    classificationTypeUpdateDateFrom: string | null;
    classificationTypeUpdateDateTo: string | null;
}

export interface AutoPoPartialPurchaseOrder {
    partialPurchaseOrderId: number;
    orderId: string;
    eventName: string;
    eventDateTime: string | null;
    venueName: string;
    section: string;
    row: string;
    seatFrom: string;
    seatTo: string;
    quantity: number | null;
    faceValue: number | null;
    purchaseOrderDate: string | null;
}

export interface AutoPoInboundEmailThreadEmail {
    inboundEmailId: number;
    classificationType: AutoPoInboundEmailClassificationType | null;
    subject: string | null;
    fromEmailAddress: string | null;
    toEmailAddress: string | null;
    receiveDate: string | null;
    htmlBody: string | null;
    textBody: string | null;
    purchaseOrderId: number | null;
    saleId: number | null;
    partialPurchaseOrderId: number | null;
    orderId: string | null;
    quantity: number | null;
    faceValue: number | null;
    purchaseOrderDate: string | null;
    purchaseOrderVendorId: number | null;
    attachments: AutoPoInboundEmailAttachment[] | null;
}

export interface AutoPoInboundEmailAttachment {
    attachmentFileName: string;
    downloadUri: string;
}

export interface ValueTupleOfStringAndString {
    item1: string;
    item2: string;
}

export interface AutoPoSellerAccountCountryRestriction {
    country: string;
    isEnabled: boolean | null;
}

export interface AutoPoSellerAccountVendorRestriction {
    vendorId: number;
    isIncluded: boolean;
}

export interface RedeemCouponResult {
    status: string;
    couponValue: number | null;
    couponValueCurrency: string | null;
    expirationDate: string | null;
    nonCashPrize: string | null;
}

export interface RedeemCouponInput {
    couponCode: string;
}

export interface AccountCouponsResult {
    unexpiredTotal: number;
    expiredTotal: number;
    currency: string | null;
    nextExpirationDate: string | null;
    currentUserHasRedeemed: boolean;
    redeemedCount: number;
    nonCashPrize: string | null;
}

export interface BulkEditPreviewWithDetails {
    error: string | null;
    hasMergedListings: boolean;
    allItemsCount: number;
    preview: BulkEditPreview;
    sales: Sale[] | null;
    listings: Listing[] | null;
    purchases: PurchaseOrder[] | null;
    ticketGroups: PurchaseOrderTicketGroup[] | null;
}

export interface BulkEditPreview {
    bulkEditCountPreview: { [key in keyof typeof ActionOutboxEntityType]?: BulkEditCountPreview; };
    consigneeOwnership: { [key in keyof typeof ActionOutboxEntityType]?: { [key: string]: number[]; }; } | null;
}

export interface BulkEditCountPreview {
    entityType: ActionOutboxEntityType;
    totalCount: number;
    idsAffected: number[];
}

export interface EntityWithTickets {
    id: number;
    accId: string | null;
    posEvId: string;
    viagEvId: number | null;
    viagEvMapId: string | null;
    viagVirtId: string;
    rowVer: number;
    insertBy: string | null;
    currency: string;
    inHandAt: string | null;
    seating: Seating;
    ticketCnt: number;
    seatTraits: ListingNote[] | null;
    privNotes: string | null;
}

export interface MarketplaceEntityWithTickets extends EntityWithTickets {
    mkp: Marketplace | null;
    idOnMkp: string | null;
    officeId: number | null;
}

export interface Sale extends MarketplaceEntityWithTickets {
    entityType: ActionOutboxEntityType;
    listingId: number | null;
    originatedFromListingId: number | null;
    saleDate: string;
    ttlNetProcs: UiMoney | null;
    soldTktCost: UiMoney | null;
    spoiledTktCost: UiMoney | null;
    pandL: UiMoney | null;
    margin: number | null;
    charges: UiMoney | null;
    credits: UiMoney | null;
    totalPmt: UiMoney | null;
    totalConvertedPmt: UiMoney | null;
    pmtState: PointOfSalePaymentState | null;
    mkpPmtState: MarketplacePaymentState | null;
    mkpFulfState: MarketplaceFulfillmentState | null;
    fulfillState: PointOfSaleFulfillmentState;
    fulfillDate: string | null;
    actions: SaleActionType[];
    status: PointOfSaleSaleStatus;
    isSeatSaver: boolean;
    adCmpFlightId: number | null;
    qtySold: number;
    ticketType: TicketType | null;
    fulfillerId: string | null;
    tags: Tag[] | null;
    holdExpiredOn: string | null;
    isNoFulfill: boolean | null;
    mkpContrState: MarketplaceContractState | null;
    isFulfillVerMis: boolean;
    owners: SaleOwnershipInfo | null;
    pmtRcv: boolean | null;
    pmtRefId: string | null;
    pmtAmtRcv: number | null;
    lastPmtDate: string | null;
    pmtCurcy: string | null;
    poDate: string | null;
    poId: number | null;
    poVendOrdId: string | null;
    poVendAccEmail: string | null;
    disAutoSource: boolean;
    origBy: string | null;
    comNotes: SaleCommentNote[] | null;
    isUnprocessedOrdFromPro: boolean | null;
    isWastageSale: boolean | null;
    qtyWasted: number;
    cancellationReason: SaleCancellationReason | null;
    hasMarketplaceProblem: boolean | null;
    origCurcy: string | null;
    convRate: number | null;
    convRateOvr: number | null;
    convDate: string | null;
    internalNotesPreview: string | null;
    isInternalNotesPreviewTruncated: boolean | null;
    salesGroupId: string | null;
}

export interface UiMoney {
    amt: number;
    disp: string | null;
    currency: string | null;
    dec: number;
}

export enum PointOfSalePaymentState {
    Unpaid = "Unpaid",
    Queued = "Queued",
    Paid = "Paid",
    PartiallyPaid = "PartiallyPaid",
    PendingReversal = "PendingReversal",
    Reversed = "Reversed",
}

export enum MarketplacePaymentState {
    Ineligible = "Ineligible",
    Unpaid = "Unpaid",
    Queued = "Queued",
    Paid = "Paid",
    PartiallyPaid = "PartiallyPaid",
    PendingReversal = "PendingReversal",
    Reversed = "Reversed",
}

export enum MarketplaceFulfillmentState {
    Ineligible = "Ineligible",
    Pending = "Pending",
    Processing = "Processing",
    PendingPickup = "PendingPickup",
    InTransit = "InTransit",
    Fulfilled = "Fulfilled",
    Failed = "Failed",
    PendingReshipment = "PendingReshipment",
}

export enum PointOfSaleFulfillmentState {
    Ineligible = "Ineligible",
    Pending = "Pending",
    Processing = "Processing",
    PendingPickup = "PendingPickup",
    InTransit = "InTransit",
    Fulfilled = "Fulfilled",
    Failed = "Failed",
    Resetted = "Resetted",
}

export enum SaleActionType {
    Confirm = "Confirm",
    Fulfill = "Fulfill",
    Reject = "Reject",
    Deallocate = "Deallocate",
    ExpireHold = "ExpireHold",
    Refulfill = "Refulfill",
    EditOffline = "EditOffline",
    Allocate = "Allocate",
    ResetFulfillment = "ResetFulfillment",
    RejectAllocation = "RejectAllocation",
    ConfirmAllocation = "ConfirmAllocation",
    MarkAsFulfilled = "MarkAsFulfilled",
    DownloadUserDocuments = "DownloadUserDocuments",
    Unwaste = "Unwaste",
    EditMarketplaceSale = "EditMarketplaceSale",
    SpoilTickets = "SpoilTickets",
    UnspoilTickets = "UnspoilTickets",
    UpdateConversionRateOverride = "UpdateConversionRateOverride",
}

export enum PointOfSaleSaleStatus {
    PendingConfirmation = "PendingConfirmation",
    PendingFulfillment = "PendingFulfillment",
    ProcessingFulfillment = "ProcessingFulfillment",
    Fulfilled = "Fulfilled",
    FulfillmentFailed = "FulfillmentFailed",
    PendingRejection = "PendingRejection",
    Rejected = "Rejected",
    Hold = "Hold",
    CancelledHold = "CancelledHold",
    PendingAllocation = "PendingAllocation",
    ProvisionalAllocation = "ProvisionalAllocation",
    PendingReshipment = "PendingReshipment",
    Wasted = "Wasted",
}

export enum TicketType {
    Custom = "Custom",
    Paper = "Paper",
    ETicket = "ETicket",
    ETicketUrl = "ETicketUrl",
    Transfer = "Transfer",
    Barcode = "Barcode",
    Season = "Season",
    QRCode = "QRCode",
    SMPWallet = "SMPWallet",
}

export interface Tag {
    key: string;
    value: string;
    valueType: TagsValueType | null;
    singleValueOnly: boolean | null;
    includeInReport: boolean | null;
    ordinal: number | null;
    persistentTagId: number | null;
    saleTagValueInheritModeId: TagValueInheritMode | null;
    sourceEntityId: number | null;
}

export enum TagsValueType {
    String = "String",
    Decimal = "Decimal",
    Int = "Int",
    Boolean = "Boolean",
    Json = "Json",
    Url = "Url",
    Marketplace = "Marketplace",
    Date = "Date",
    POSUser = "POSUser",
    Vendor = "Vendor",
    UserGroup = "UserGroup",
}

export enum TagValueInheritMode {
    SyncLiveValue = "SyncLiveValue",
    CopyValueOnCreate = "CopyValueOnCreate",
    DoNotInherit = "DoNotInherit",
}

export enum MarketplaceContractState {
    Provisional = "Provisional",
    CancelledProvisional = "CancelledProvisional",
    Contracted = "Contracted",
    MarketplaceDispute = "MarketplaceDispute",
    Complete = "Complete",
    CancelledUnknownFault = "CancelledUnknownFault",
    CancelledSellerFault = "CancelledSellerFault",
    CancelledMutual = "CancelledMutual",
    CancelledMarketplaceFault = "CancelledMarketplaceFault",
}

export interface SaleOwnershipInfo {
    fulfillerId: string | null;
    buyerIds: string[];
    pricerIds: string[];
    poInsertBys: string[];
    poIds: number[];
}

export interface SaleCommentNote {
    date: string | null;
    email: string | null;
    text: string | null;
}

export enum SaleCancellationReason {
    EventCancellation = "EventCancellation",
    SellerFault = "SellerFault",
    MarketplaceFault = "MarketplaceFault",
    NoFault = "NoFault",
    Other = "Other",
}

export enum Marketplace {
    StubHub = "StubHub",
    VividSeats = "VividSeats",
    SeatGeek = "SeatGeek",
    TickPick = "TickPick",
    Ticketmaster = "Ticketmaster",
    Offline = "Offline",
    AXS = "AXS",
    FanXchange = "FanXchange",
    Gametime = "Gametime",
    TicketEvolution = "TicketEvolution",
    TicketNetwork = "TicketNetwork",
    Automatiq = "Automatiq",
    Lyte = "Lyte",
    GoTickets = "GoTickets",
    B2BSales = "B2BSales",
    TicketNetworkMercury = "TicketNetworkMercury",
    Wastage = "Wastage",
    ReachPro = "ReachPro",
    Donation = "Donation",
    Gigsberg = "Gigsberg",
    Retail = "Retail",
    SellBack = "SellBack",
    Tixstock = "Tixstock",
    StubHubInternational = "StubHubInternational",
    Veritix = "Veritix",
    TicketClub = "TicketClub",
    TicketCity = "TicketCity",
    TicketSmarter = "TicketSmarter",
    SeatWave = "SeatWave",
    First15Events = "First15Events",
    GetMeIn = "GetMeIn",
    Ebay = "Ebay",
    ScoreBig = "ScoreBig",
    Razorgator = "Razorgator",
    HelloTickets = "HelloTickets",
    TixStop = "TixStop",
    Ticombo = "Ticombo",
    StubXchange = "StubXchange",
    Xchange24EUR = "Xchange24EUR",
    Ticketbis = "Ticketbis",
    Rukkus = "Rukkus",
    TicketIQ = "TicketIQ",
    Headout = "Headout",
    Yoonew = "Yoonew",
    Tixers = "Tixers",
    FlipTix = "FlipTix",
    ChargedFm = "ChargedFm",
    GameHedge = "GameHedge",
    OleOle = "OleOle",
}

export interface Seating {
    section: string;
    sectionId: number | null;
    row: string | null;
    rowId: number | null;
    seatFr: string | null;
    seatTo: string | null;
    ticketIds: number[] | null;
    listingIds: number[] | null;
}

export interface ListingNote {
    listingNoteId: number;
    listingNoteText: string;
    listingNoteUntranslated: string;
    sellerAccountId: string | null;
    stubhubListingNoteId: number | null;
    type: ListingNoteType | null;
}

export enum ListingNoteType {
    Defect = "Defect",
    RestrictionOnUse = "Restriction on Use",
    Perk = "Perk",
    Information = "Information",
    ConnectedSeller = "ConnectedSeller",
    InternallyGenerated = "InternallyGenerated",
}

export interface Listing extends MarketplaceEntityWithTickets {
    rowId: number | null;
    entityType: ActionOutboxEntityType;
    dataIsLoaded: { [key in keyof typeof ListingDetailDataField]?: boolean; };
    unitCst: UiMoney | null;
    status: ListingStatus;
    isUSEvent: boolean | null;
    brdcstStatus: ListingBroadcastStatus | null;
    isSeatSaver: boolean;
    isAdminHold: boolean;
    adminHoldExpiredOn: string | null;
    adminHoldNotes: string | null;
    vldPurQty: number[];
    availQty: number;
    maxDispQty: number;
    manMaxDispQty: number | null;
    soldQty: number | null;
    wastedQty: number | null;
    unsoldQty: number;
    preDelivState: PreDeliveryState;
    delivType: DeliveryType;
    topPriTktType: TicketType | null;
    isUndeliv: boolean;
    isNoFulfill: boolean | null;
    enableNativeSync: boolean | null;
    actions: ListingActionType[];
    isCurUserPo: boolean;
    poBys: string[] | null;
    poId: number | null;
    poOrderId: string | null;
    poDate: string | null;
    poVendAccEmail: string | null;
    poCreatedBys: string[] | null;
    isDeleted: boolean;
    mkpListings: MarketplaceListing[] | null;
    qcState: QualityControlState | null;
    pendProofState: PendingProofState | null;
    dupListingId: number | null;
    ignoreDup: boolean | null;
    mkpVis: number | null;
    sectionType: VenueMapSectionType | null;
    orgSeatFr: string | null;
    orgSeatTo: string | null;
    internalNotesPreview: string | null;
    isInternalNotesPreviewTruncated: boolean | null;
    noteIds: string | null;
    ltGrpId: string | null;
    ltGrpParentId: number | null;
    ltGrpPrior: number | null;
    ltGrpActive: boolean | null;
    isLtGrp: boolean;
    isFull: boolean;
    ltGrpUndercut: ListingGroupUndercutSetting | null;
    tags: Tag[] | null;
    splitType: SplitType;
    hideSeats: boolean;
    pricerId: string | null;
    listPrice: number;
    allInPrice: number;
    faceValue: UiMoney | null;
    lastPrcUpdOn: string | null;
    isAutoPrc: boolean | null;
    procsFloor: number | null;
    procsCeil: number | null;
    undMode: AutoPricingUndercutMode | null;
    undAbsAmt: number | null;
    undRelAmt: number | null;
    undNewPrice: number | null;
    compMode: AutoPricingCompListingMode | null;
    compFloor: number | null;
    compCeil: number | null;
    isCompQtyScrAdj: boolean | null;
    compQtyScrAdjJson: string | null;
    isCompForSameZone: boolean | null;
    isCompSelectedSections: boolean | null;
    compExclFanInv: boolean | null;
    compExclDefects: boolean | null;
    compSectionSettings: SelectedSectionSettings | null;
    cirBrRelCeil: number | null;
    cirBrRelFloor: number | null;
    cirBrMaxDiscVelocPercent: number | null;
    cirBrMaxDiscVelocTicksInHrs: number | null;
    cirBrMinCompCount: number | null;
    outMode: AutoPricingOutlierMode | null;
    outlStdDev: number | null;
    outKthLowestLim: number | null;
    outKthLowestLimRelSpc: number | null;
    outKthLowestLimAbsSpc: number | null;
    autoPrcResult: AutoPricingResultType | null;
    autoPrcConstraintType: AutoPricingConstraintType | null;
    cirBrSuppRowVer: number | null;
    tktTypeRules: TicketTypeOverride | null;
    shownQuantity: number | null;
    wastedCost: UiMoney | null;
    unsoldCost: UiMoney | null;
    soldCost: UiMoney | null;
    totalCst: UiMoney | null;
    unsoldProceeds: number | null;
}

export enum ListingDetailDataField {
    Basic = "Basic",
    Tickets = "Tickets",
    Pricing = "Pricing",
    AutoPricing = "AutoPricing",
    Sales = "Sales",
    Purchase = "Purchase",
    Tags = "Tags",
    InternalNotes = "InternalNotes",
}

export enum ListingStatus {
    Disabled = "Disabled",
    FullySold = "Fully Sold",
    DelistingPending = "Delisting Pending",
    DelistingFailed = "Delist Failed",
    Delisted = "Delisted",
    ListingPending = "Listing Pending",
    ListingFailed = "List Failed",
    Listed = "Listed",
}

export enum ListingBroadcastStatus {
    Unknown = "Unknown",
    Broadcast = "Broadcast",
    BroadcastFailed = "BroadcastFailed",
    BroadcastWithError = "BroadcastWithError",
    Unbroadcast = "Unbroadcast",
    UnbroadcastFailed = "UnbroadcastFailed",
    UnbroadcastWithError = "UnbroadcastWithError",
}

export enum PreDeliveryState {
    NotPreDelivered = "No",
    PreDelivered = "Yes",
    PartiallyPreDelivered = "Partial",
}

export enum DeliveryType {
    InApp = "In-app",
    PDF = "PDF",
    Paper = "Paper",
    MemberCard = "Member Card",
    Wallet = "Wallet",
    Custom = "Custom",
}

export enum ListingActionType {
    Broadcast = "Broadcast",
    Unbroadcast = "Unbroadcast",
    Split = "Split",
    SplitToOriginal = "SplitToOriginal",
    AddOfflineSale = "AddOfflineSale",
    AddMarketplaceSale = "AddMarketplaceSale",
    PredeliverBarcodes = "PredeliverBarcodes",
    PredeliverETickets = "PredeliverETickets",
    PredeliverQRCode = "PredeliverQRCode",
    PredeliverExternalIds = "PredeliverExternalIds",
    PredeliverTicketUrls = "PredeliverTicketUrls",
    RedeliverBarcodes = "RedeliverBarcodes",
    RedeliverETickets = "RedeliverETickets",
    RedeliverQRCode = "RedeliverQRCode",
    RedeliverExternalIds = "RedeliverExternalIds",
    RedeliverTicketUrls = "RedeliverTicketUrls",
    DownloadUserDocuments = "DownloadUserDocuments",
    FullySoldNoAction = "FullySoldNoAction",
    AddAdminHold = "AddAdminHold",
    RemoveAdminHold = "RemoveAdminHold",
    Waste = "Waste",
    Donate = "Donate",
    ChangeOffice = "ChangeOffice",
}

export interface MarketplaceListing {
    mkpListingId: string | null;
    mkp: Marketplace;
    status: ListingStatus;
    markup: number | null;
    sellerAccountDefaultMarkup: number | null;
    sellerFee: number | null;
    netProcs: number | null;
    webPrice: number | null;
    isPriceByMkp: boolean;
    overrideSection: string | null;
    overrideRow: string | null;
    overrideSeats: string | null;
    overrideRowId: number | null;
    overrideSectionId: number | null;
    isEnabled: boolean;
    availQty: number | null;
    currency: string;
    errMsgs: string[] | null;
    errCodes: BroadcastErrorCode[] | null;
    pendProofState: PendingProofState | null;
    brdcstStatus: ListingBroadcastStatus | null;
}

export enum BroadcastErrorCode {
    Unknown = "Unknown",
    UpdatePrice = "UpdatePrice",
    UpdateTicketType = "UpdateTicketType",
    UpdateSplitType = "UpdateSplitType",
    UpdateInHandDate = "UpdateInHandDate",
    SplitListing = "SplitListing",
    MergeListing = "MergeListing",
    BroadcastListing = "BroadcastListing",
    UnbroadcastListing = "UnbroadcastListing",
    UpdateQuantity = "UpdateQuantity",
    HideSeats = "HideSeats",
    UpdateListingNotes = "UpdateListingNotes",
    UpdateSeating = "UpdateSeating",
    MarketplaceResaleRestricted = "MarketplaceResaleRestricted",
    MarketplaceManifestMismatch = "MarketplaceManifestMismatch",
    MarketplacePriceBelowFloor = "MarketplacePriceBelowFloor",
}

export enum PendingProofState {
    PendingProof = "PendingProof",
    PendingReview = "PendingReview",
    Approved = "Approved",
}

export enum QualityControlState {
    Pending = "Pending",
    Approved = "Approved",
    Rejected = "Rejected",
}

export enum VenueMapSectionType {
    ForcedRow = "ForcedRow",
    OptionalRow = "OptionalRow",
    NoRow = "NoRow",
    GeneralAdmission = "GeneralAdmission",
    NoRowPairs = "NoRowPairs",
    OptionalRowPairs = "OptionalRowPairs",
    ForcedRowPairs = "ForcedRowPairs",
    GeneralAdmissionWithQueueNumber = "GeneralAdmissionWithQueueNumber",
    GeneralAdmissionStanding = "GeneralAdmissionStanding",
    GeneralAdmissionSeating = "GeneralAdmissionSeating",
}

export interface ListingGroupUndercutSetting {
    undAbsAmt: number | null;
    undRelAmt: number | null;
    actRankUndAbsAmt: number | null;
    actRankUndRelAmt: number | null;
}

export enum SplitType {
    Any = "Any",
    None = "None",
    AvoidOne = "Avoid One",
    AvoidOneAndThree = "Avoid One and Three",
    Pairs = "Pairs",
}

export enum AutoPricingUndercutMode {
    Simple = "Simple",
    RowExtrapolation = "RowExtrapolation",
    Deal = "Deal",
    AverageOfCheapestListings = "AverageOfCheapestListings",
}

export enum AutoPricingCompListingMode {
    QualityScore = "QualityScore",
    SameSection = "SameSection",
    SameZone = "SameZone",
    SameEvent = "SameEvent",
    ParentListing = "ParentListing",
}

export interface SelectedSectionSettings {
    sectionIdFilter: number[] | null;
    rowIdFilter: number[] | null;
    sectionRowIdFilter: { [key: string]: string; } | null;
    sectionIdFilterFromZoneMap: boolean;
    includeBetterZones: boolean;
    rowOffset: number | null;
    sectionFilterMode: SectionFilterMode | null;
}

export enum SectionFilterMode {
    Custom = "Custom",
    SameSection = "SameSection",
    SameZone = "SameZone",
    AllSections = "AllSections",
}

export enum AutoPricingOutlierMode {
    StandardDeviations = "StandardDeviations",
    SkipLogic = "SkipLogic",
    KthLowest = "KthLowest",
}

export enum AutoPricingResultType {
    None = "None",
    PriceSuccess = "PriceSuccess",
    PriceBelowFloor = "PriceBelowFloor",
    InsufficientComparables = "InsufficientComparables",
    PriceBelowMaxAllowedDrop = "PriceBelowMaxAllowedDrop",
    PriceAboveCeiling = "PriceAboveCeiling",
    MissingUnitCost = "MissingUnitCost",
    MissingSeatScore = "MissingSeatScore",
    MissingZone = "MissingZone",
    CannotCalculateUndercut = "CannotCalculateUndercut",
    EffectiveCeilingBelowFloor = "EffectiveCeilingBelowFloor",
    PriceHitHardFloor = "PriceHitHardFloor",
    PriceHitRelativeFloor = "PriceHitRelativeFloor",
    PriceHitMaxAllowedDrop = "PriceHitMaxAllowedDrop",
    ConfigRowMissing = "ConfigRowMissing",
    SectionUnmapped = "SectionUnmapped",
    AllPriceUpdatesPaused = "AllPriceUpdatesPaused",
    PriceDecreasesPaused = "PriceDecreasesPaused",
}

export enum AutoPricingConstraintType {
    None = "None",
    HardConstraint = "HardConstraint",
    SoftConstraint = "SoftConstraint",
}

export interface TicketTypeOverride {
    overrides: TicketTypeOverrideForDeliveryType[];
}

export interface TicketTypeOverrideForDeliveryType {
    deliveryType: DeliveryType;
    ticketTypePriorities: TicketTypePriority[];
}

export interface TicketTypePriority {
    priority: number;
    ticketType: TicketType;
    isBlocked: boolean;
}

export interface PurchaseOrder {
    id: number;
    entityType: ActionOutboxEntityType;
    accId: string | null;
    buyerId: string | null;
    insertBy: string | null;
    commissions: Commission[] | null;
    vendor: PurchaseVendor | null;
    secVendor: PurchaseVendor | null;
    vendAcc: PurchaseVendorAccount | null;
    secVendAcc: PurchaseVendorAccount | null;
    tags: Tag[] | null;
    vendOrdId: string | null;
    poState: PurchaseOrderState;
    poDate: string | null;
    tktGrpCnt: number;
    currency: string;
    pmtStat: PurchasePaymentStatus | null;
    pmtMethod: PurchasePaymentMethodType | null;
    privNotes: string | null;
    qcState: QualityControlState | null;
    isAutoPo: boolean | null;
    rowVer: number;
    isCommissionsLocked: boolean | null;
    originalCurrencyCode: string | null;
    conversionRate: number | null;
    conversionDate: string | null;
    officeId: number | null;
    pmtMtdFullDisp: PurchasePaymentMethod[] | null;
    ticketCnt: number;
    totalPmt: UiMoney | null;
    totalConvertedPmt: UiMoney | null;
    outsBal: UiMoney | null;
    pmtConvRate: number | null;
    delivType: DeliveryType | null;
    totalCst: UiMoney | null;
    unitCst: UiMoney | null;
    unitFullyLoadedCst: UiMoney | null;
    viagVirtId: string | null;
}

export interface Commission {
    buyerUserId: string;
    commissionPercentage: number;
}

export interface PurchaseVendor {
    id: number;
    name: string;
    isGlobal: boolean | null;
    vendAccCounts: number | null;
    delivType: DeliveryType | null;
    isNoFulfill: boolean | null;
    tktTypeRules: TicketTypeOverride | null;
}

export interface PurchaseVendorAccount {
    id: string;
    vendorId: number;
    name: string;
    email: string;
    password: string | null;
    dftPayMethodId: number | null;
    dftBuyerId: string | null;
}

export enum PurchaseOrderState {
    Active = "Active",
    Cancelled = "Cancelled",
    Void = "Void",
    Drafted = "Drafted",
}

export enum PurchasePaymentStatus {
    Unpaid = "Unpaid",
    PartiallyPaid = "Partially Paid",
    Paid = "Paid",
    Failed = "Failed",
    RefundNeeded = "RefundNeeded",
    Refunded = "Refunded",
    PartiallyRefunded = "PartiallyRefunded",
}

export enum PurchasePaymentMethodType {
    PayPal = "PayPal",
    ECheck = "eCheck",
    Check = "Check",
    MoneyOrder = "Money Order",
    Card = "Credit Card",
    Cash = "Cash",
    Credit = "Credit",
    COD = "COD",
    BankTransfer = "Bank Transfer",
    DebitCard = "Debit Card",
    CreditMemo = "Credit Balance",
    DebitNote = "Debit Note",
    Other = "Other",
}

export interface PurchasePaymentMethod {
    id: number;
    display: string;
    name: string;
    type: PurchasePaymentMethodType;
    glCode: string | null;
}

export interface PurchaseOrderTicketGroup extends PurchaseOrder {
    ticketGroupItems: IPurchaseOrderTicketGroupItem[] | null;
    isTktGrp: boolean | null;
    faceValCst: UiMoney | null;
    canGetDocArts: boolean | null;
    tgId: number | null;
    tickets: Ticket[];
    isMultEv: boolean | null;
    seating: Seating | null;
    seatTraits: ListingNote[] | null;
    perfId: number | null;
    venId: number | null;
    entityCatalogData: EntityCatalogData | null;
}

export interface IPurchaseOrderTicketGroupItem {
    isTktGrp: boolean | null;
    canGetDocArts: boolean | null;
    tgId: number | null;
    viagVirtId: string;
    perfId: number | null;
    venId: number | null;
    isMultEv: boolean | null;
    seating: Seating | null;
    ticketCnt: number;
    tickets: Ticket[];
    seatTraits: ListingNote[] | null;
    delivType: DeliveryType | null;
    totalCst: UiMoney | null;
    unitCst: UiMoney | null;
    faceValCst: UiMoney | null;
    entityCatalogData: EntityCatalogData | null;
}

export interface Ticket {
    id: number;
    tgId: number;
    ord: number;
    lstOrd: number | null;
    row: string | null;
    seat: string;
    barcode: string | null;
    ticketUrl: string | null;
    externalTicketId: string | null;
    eTicket: UserDocumentLinks | null;
    qrCode: UserDocumentLinks | null;
    holdId: number | null;
    spoiledSaleId: number | null;
    saleId: number | null;
    listingId: number | null;
    poId: number | null;
    unitCost: UiMoney | null;
    isWasted: boolean | null;
}

export interface UserDocument {
    entityId: number | null;
    documentId: string;
    pageNumber: number | null;
    pageId: string | null;
    documentType: DocumentType | null;
}

export interface UserDocumentLinks extends UserDocument {
    documentUri: string;
    pageUri: string;
}

export interface EntityCatalogData {
    eventDateTime: string | null;
    eventName: string | null;
    eventShortName: string | null;
    eventStatus: ApiEventStatus | null;
    eventGenre: TopLevelCategory | null;
    eventSubGenre: number | null;
    venueId: number | null;
    venueName: string | null;
    venueCity: string | null;
    venueCityId: number | null;
    venueStateProvince: string | null;
    venueStateProvinceId: number | null;
    venueCountry: string | null;
    venueCountryCode: string | null;
    performerId: number | null;
    performerName: string | null;
}

export interface EntityWithTicketsQuery {
    entityIds: number[] | null;
    marketplaceEntityIds: string[] | null;
    eventOrMappingIds: string[] | null;
    eventIdsOverride: number[] | null;
    oldPosEventIds: string[] | null;
    performerIds: number[] | null;
    venueIds: number[] | null;
    countryCodes: string[] | null;
    stateProvinceIds: number[] | null;
    cityIds: number[] | null;
    purchaseOrderId: number | null;
    purchaseOrderIds: number[] | null;
    saleIds: number[] | null;
    listingIds: number[] | null;
    purchaseVendorId: number | null;
    vendorAccessControlProviderId: number | null;
    purchaseVendorAccountIds: string[] | null;
    purchaseVendorOrderId: string | null;
    purchaseBuyerId: string | null;
    purchaseOrderCreatedBy: string | null;
    purchaseCommissionUserId: string | null;
    purchaseDates: DateTimeRangeWithRelative | null;
    inHandDates: DateTimeRangeWithRelative | null;
    eventTimeFrameFilter: EventTimeFrameFilter | null;
    sections: string[] | null;
    rows: string[] | null;
    sectionContains: string | null;
    sectionEquals: string | null;
    sectionNotContains: string | null;
    rowContains: string | null;
    rowEquals: string | null;
    rowNotContains: string | null;
    isSeatSaver: boolean | null;
    eventDates: DateTimeRangeWithRelative | null;
    eventNotReviewedSinceDate: DateTimeRangeWithRelative | null;
    isMapped: boolean | null;
    isMappingRejected: boolean | null;
    searchText: string | null;
    isBoosted: boolean | null;
    sortBy: EventSort | null;
    isSortDescending: boolean | null;
    tagName: string | null;
    tagValue: string | null;
    tagValues: string[] | null;
    tagOperation: string | null;
    eventTagName: string | null;
    eventTagValue: string | null;
    eventTagValues: string[] | null;
    eventTagOperation: string | null;
    lastSaleDates: DateTimeRangeWithRelative | null;
    noSaleDates: DateTimeRangeWithRelative | null;
    numberOfTicketsHeld: NumericRange | null;
    percentUnfulfilled: NumericRange | null;
    topLevelCategories: TopLevelCategory[] | null;
    parentCategories: number[] | null;
    internalNotes: string | null;
    internalNotesContains: string | null;
    internalNotesEquals: string | null;
    internalNotesNotContains: string | null;
    timezoneOffsetMins: number | null;
    currencyCode: string | null;
    currencyCodes: string[] | null;
    officeIds: number[] | null;
    eventStatuses: ApiEventStatus[] | null;
    searchConfigId: string | null;
    purchaseVendorIds: number[] | null;
    purchaseBuyerIds: string[] | null;
    purchaseOrderCreatedBys: string[] | null;
    purchaseCommissionUserIds: string[] | null;
}

export interface ListingQuery extends EntityWithTicketsQuery {
    pricerSellerUserId: string | null;
    isPredelivered: boolean | null;
    preDeliveryStates: PreDeliveryState[] | null;
    isListed: boolean | null;
    deliveryType: DeliveryType | null;
    eventHasUnsoldTickets: boolean | null;
    hasUnsoldTickets: boolean | null;
    hasBroadcastError: boolean | null;
    isAutoPricingEnabled: boolean | null;
    isPricedAboveZero: boolean | null;
    lastPriceUpdateDates: DateTimeRangeWithRelative | null;
    lastPriceNoUpdateDates: DateTimeRangeWithRelative | null;
    autoPricingResultTypes: AutoPricingResultType[] | null;
    isSeatingUnmapped: boolean | null;
    isAdminHold: boolean | null;
    isDuplicate: boolean | null;
    hasListingGroupId: boolean | null;
    isPricedByMarketplace: boolean | null;
    isPendingProof: boolean | null;
    purchaseCancellationDates: DateTimeRangeWithRelative | null;
    purchaseCancelledOnly: boolean | null;
    isNoFulfill: boolean | null;
    unitCostHigh: number | null;
    unitCostLow: number | null;
    ticketType: TicketType | null;
    viewMode: InventoryViewMode | null;
    eventUnpricedStatus: EventUnpricedStatus | null;
}

export interface DateTimeRangeWithRelative extends DateTimeRange {
    relativeStartSecs: number | null;
    relativeEndSecs: number | null;
    roundingMode: RelativeTimeRoundingMode | null;
}

export enum RelativeTimeRoundingMode {
    Day = "Day",
    Week = "Week",
    Month = "Month",
    Year = "Year",
}

export enum InventoryViewMode {
    TileView = "Tile View",
    MetricView = "Metric View",
    FlattenedView = "Flattened View",
}

export enum EventUnpricedStatus {
    AllUnpriced = "All",
    NoneUnpriced = "None",
    AnyUnpriced = "Any",
}

export enum EventTimeFrameFilter {
    Future = "Future Events",
    Past = "Past Events",
}

export enum EventSort {
    Date = "Sort by Date",
    MainDisplay = "Sort by Title",
}

export interface NumericRange {
    start: number | null;
    end: number | null;
}

export interface BulkEditProgress {
    updateKey: string;
    method: string;
    step: BulkEditStep;
    successCount: number;
    failureCount: number;
    warningCount: number;
    totalCount: number;
    status: string | null;
    error: string | null;
    warning: string | null;
    successPercent: number | null;
    failurePercent: number | null;
    warningPercent: number | null;
    countsByEntity: { [key in keyof typeof ActionOutboxEntityType]?: BulkEditCount; };
    retryableEntities: BulkEditPreview | null;
}

export enum BulkEditStep {
    Disabled = "Disabled",
    Initializing = "Initializing",
    InProgress = "InProgress",
    Done = "Done",
    Cancelled = "Cancelled",
    DoneWithRetryableEntities = "DoneWithRetryableEntities",
}

export interface BulkEditCount {
    totalCount: number;
    successCount: number;
    failureCount: number;
    warningCount: number;
    entityType: ActionOutboxEntityType;
    ttlCnt: number;
    succCnt: number;
    failCnt: number;
    warnCnt: number;
}

export enum ListingPriceAdjustmentType {
    CurrentPrice = "CurrentPrice",
    UnitCost = "UnitCost",
}

export enum PricingFloorCeilingAdjustmentType {
    MarketPrice = "MarketPrice",
    UnitCost = "UnitCost",
    CurrentFloor = "CurrentFloor",
}

export interface ValueTupleOfBulkEditPreviewAndListingDetailsUpdateInput {
    item1: BulkEditPreview;
    item2: ListingDetailsUpdateInput;
}

export interface ListingDetailsPricingUpdates {
    netProceedsFloor: number | null;
    netProceedsCeiling: number | null;
    skipPriceProtection: boolean | null;
    skipAutoPricing: boolean | null;
    autoPricingEnabled: boolean | null;
    undercutMode: AutoPricingUndercutMode | null;
    skipUndercut: boolean | null;
    undercutAbsoluteAmount: number | null;
    undercutRelativeAmount: number | null;
    undercutReferenceListingPosition: number | null;
    compListingMode: AutoPricingCompListingMode | null;
    skipCompListing: boolean | null;
    compListingFloor: number | null;
    compListingCeiling: number | null;
    compListingQuantityScoreAdjustmentEnabled: boolean | null;
    compListingQuantityScoreAdjustmentOverrides: { [key: string]: number; } | null;
    compListingQuantityScoreAdjustmentOverrideJson: string | null;
    compListingOnlyForSameZoneEnabled: boolean | null;
    compListingOnlyForSelectedSectionsEnabled: boolean | null;
    compListingExcludeFanInventory: boolean | null;
    compListingExcludeDefects: boolean | null;
    compListingIncludeUnmappedInventory: boolean | null;
    compListingSelectedSectionSettings: SelectedSectionSettings | null;
    compListingQuantityFilters: CompListingQuantity | null;
    skipAdvancePricing: boolean | null;
    circuitBreakerRelativeCeiling: number | null;
    circuitBreakerRelativeFloor: number | null;
    circuitBreakerMaxDiscountVelocityPercent: number | null;
    circuitBreakerMaxDiscountVelocityTicksInHours: number | null;
    circuitBreakerMinCompListingCount: number | null;
    velocityCircuitBreakerStateRowVersion: number | null;
    outlierMode: AutoPricingOutlierMode | null;
    outlierStandardDeviations: number | null;
    outlierKthLowestLimit: number | null;
    outlierKthLowestLimitRelativeSpacing: number | null;
    outlierKthLowestLimitAbsoluteSpacing: number | null;
    currencyCode: string | null;
}

export interface ListingDetailsUpdateInput extends ListingDetailsPricingUpdates {
    id: number;
    rowVersion: number | null;
    adminHoldExpirationDate: string | null;
    adminHoldNotes: string | null;
    marketplaceSeatOverrides: ListingMarketplaceSeatingOverride[];
    splitType: SplitType | null;
    hideSeatsFromMarketplace: boolean | null;
    faceValue: number | null;
    inHandDate: string | null;
    daysBeforeEvent: number | null;
    section: string | null;
    sectionId: number | null;
    row: string | null;
    rowId: number | null;
    internalNotes: string | null;
    ticketTypeRules: TicketTypeOverride | null;
    manualMaxDisplayQuantity: number | null;
    isNoFulfill: boolean | null;
    enableNativeSync: boolean | null;
    seatTraits: ListingNote[] | null;
    delivType: DeliveryType | null;
    updateSalesOfListings: boolean | null;
    pricerSellerUserId: string | null;
    listPrice: number | null;
    allInPrice: number | null;
    buyerUserId: string | null;
    marketplacePriceUpdates: ListingMarketplacePriceUpdateInput[];
    tags: Tag[] | null;
}

export interface ListingMarketplaceSeatingOverride {
    marketplace: Marketplace;
    overrideSection: string | null;
    overrideRow: string | null;
    overrideSeats: string | null;
    overrideRowId: number | null;
    overrideSectionId: number | null;
}

export interface ListingMarketplacePriceUpdateInput {
    listPrice: number | null;
    allInPrice: number | null;
    priceByMarketplace: boolean;
    marketplace: Marketplace;
    markup: number | null;
}

export interface CompListingQuantity {
    exactQuantities: number[];
    greaterThanOrEqualToQuantity: number | null;
}

export interface ValueTupleOfBulkEditPreviewAndListingDetailsAutoPricingSectionUpdatesV2 {
    item1: BulkEditPreview;
    item2: ListingDetailsAutoPricingSectionUpdatesV2;
}

export interface ListingDetailsAutoPricingSectionUpdatesV2 {
    id: number;
    rowVersion: number | null;
    currencyCode: string | null;
    netProceedsFloor: PosFieldOfNullableDecimal | null;
    netProceedsCeiling: PosFieldOfNullableDecimal | null;
    netProceedsFloorAdjustmentType: PricingFloorCeilingAdjustmentType | null;
    netProceedsFloorAdjustmentAmount: number | null;
    netProceedsFloorAdjustmentRelative: boolean | null;
    autoPricingEnabled: PosFieldOfNullableBoolean | null;
    undercutMode: PosFieldOfNullableAutoPricingUndercutMode | null;
    undercutAbsoluteAmount: PosFieldOfNullableDecimal | null;
    undercutRelativeAmount: PosFieldOfNullableDecimal | null;
    undercutReferenceListingPosition: PosFieldOfNullableInteger | null;
    compListingMode: PosFieldOfNullableAutoPricingCompListingMode | null;
    compListingFloor: PosFieldOfNullableDecimal | null;
    compListingCeiling: PosFieldOfNullableDecimal | null;
    compListingQuantityScoreAdjustmentEnabled: PosFieldOfNullableBoolean | null;
    compListingQuantityScoreAdjustmentOverrideJson: PosFieldOfString | null;
    compListingOnlyForSameZoneEnabled: PosFieldOfNullableBoolean | null;
    compListingOnlyForSelectedSectionsEnabled: PosFieldOfNullableBoolean | null;
    compListingExcludeFanInventory: PosFieldOfNullableBoolean | null;
    compListingExcludeDefects: PosFieldOfNullableBoolean | null;
    compListingIncludeUnmappedInventory: PosFieldOfNullableBoolean | null;
    compListingSelectedSectionSettings: PosFieldOfSelectedSectionSettings | null;
    includeExistingSelectedSections: boolean | null;
    venueZoneMapName: string | null;
    deriveCompsFromVenueZoneConfig: boolean | null;
    includeBetterZones: boolean | null;
    rowCompOffset: number | null;
    useDefaultQuantityFilters: boolean | null;
    circuitBreakerRelativeCeiling: PosFieldOfNullableDecimal | null;
    circuitBreakerRelativeFloor: PosFieldOfNullableDecimal | null;
    circuitBreakerMaxDiscountVelocityPercent: PosFieldOfNullableDecimal | null;
    circuitBreakerMaxDiscountVelocityTicksInHours: PosFieldOfNullableLong | null;
    circuitBreakerMinCompListingCount: PosFieldOfNullableInteger | null;
    outlierMode: PosFieldOfNullableAutoPricingOutlierMode | null;
    outlierStandardDeviations: PosFieldOfNullableDecimal | null;
    outlierKthLowestLimit: PosFieldOfNullableInteger | null;
    outlierKthLowestLimitRelativeSpacing: PosFieldOfNullableDecimal | null;
    outlierKthLowestLimitAbsoluteSpacing: PosFieldOfNullableDecimal | null;
    previewMarketPrices: { [key: string]: number; } | null;
}

export interface PosFieldOfNullableDecimal {
    value: number | null;
    hasChanged: boolean;
}

export interface PosFieldOfNullableBoolean {
    value: boolean | null;
    hasChanged: boolean;
}

export interface PosFieldOfNullableAutoPricingUndercutMode {
    value: AutoPricingUndercutMode | null;
    hasChanged: boolean;
}

export interface PosFieldOfNullableInteger {
    value: number | null;
    hasChanged: boolean;
}

export interface PosFieldOfNullableAutoPricingCompListingMode {
    value: AutoPricingCompListingMode | null;
    hasChanged: boolean;
}

export interface PosFieldOfString {
    value: string | null;
    hasChanged: boolean;
}

export interface PosFieldOfSelectedSectionSettings {
    value: SelectedSectionSettings | null;
    hasChanged: boolean;
}

export interface PosFieldOfNullableLong {
    value: number | null;
    hasChanged: boolean;
}

export interface PosFieldOfNullableAutoPricingOutlierMode {
    value: AutoPricingOutlierMode | null;
    hasChanged: boolean;
}

export interface BulkListingPriceCalculationResult {
    listingPriceCalculations: BulkListingPriceCalculation[];
    compListings: CompListing[];
    sellerCompListings: CompListing[];
    sellerAccountPosListingIds: number[];
}

export interface BaseListingPriceCalculation {
    listingId: number;
    websitePrice: UiMoney | null;
    autoPricingResultType: AutoPricingResultType | null;
    autoPricingConstraintType: AutoPricingConstraintType | null;
    errorMessage: string | null;
    underCutChosenListingId: number | null;
    cmpFlr: UiMoney | null;
    cmpCeil: UiMoney | null;
    udrAbs: number | null;
    udrRel: number | null;
    udrAbsPrm: number | null;
    udrRelPrm: number | null;
    newPrcInclFanInv: number | null;
    udrRefLstIds: number[] | null;
    udrRefPrc: UiMoney | null;
    sellerAccountPosListingIds: number[];
}

export interface BulkListingPriceCalculation extends BaseListingPriceCalculation {
    compStubHubListingIds: number[];
    outlierStubHubListingIds: number[];
    sellerCompStubHubListingIds: number[];
}

export interface CompListing {
    listingId: number;
    availableTickets: number | null;
    rowId: number | null;
    section: string | null;
    row: string | null;
    seatFrom: string | null;
    seatTo: string | null;
    sellerNetProceeds: UiMoney | null;
    sellerNetProceedsInUSD: UiMoney | null;
    sellerAllInPrice: UiMoney | null;
    currencyCode: string | null;
    listingNotes: ListingNote[] | null;
    isWithoutOutlier: boolean | null;
    isAnchor: boolean | null;
    isSellerCompListing: boolean | null;
    isFanInventory: boolean | null;
    validPurchaseQuantities: number[];
}

export interface ValueTupleOfInt64OfAndListingPriceCalculationsInEventInput {
    item1: number[];
    item2: ListingPriceCalculationsInEventInput;
}

export interface ListingPriceCalculationsInEventInput {
    compListingSetting: CompListingSettingUpdate;
    underCutSetting: UnderCutSettingUpdate;
    outlierSetting: OutlierSettingUpdate;
    netProceedsFloor: PosFieldOfNetProceedsFloorAdjustment | null;
    netProceedsCeiling: PosFieldOfUiMoney | null;
    rankPremium: PosFieldOfRankPremiumAdjustment | null;
    velocityCircuitBreakerStateMaxRowVersion: number | null;
}

export interface CompListingSettingUpdate {
    mode: PosFieldOfNullableAutoPricingCompListingMode | null;
    selectedSectionSettings: PosFieldOfSelectedSectionSettings | null;
    includeExistingSelectedSectionSettings: PosFieldOfNullableBoolean | null;
    onlyForSelectedSectionsEnabled: PosFieldOfNullableBoolean | null;
    quantityFilters: PosFieldOfCompListingQuantity | null;
    excludeFanInventory: PosFieldOfNullableBoolean | null;
    excludeDefects: PosFieldOfNullableBoolean | null;
    includeUnmappedInventory: PosFieldOfNullableBoolean | null;
}

export interface PosFieldOfCompListingQuantity {
    value: CompListingQuantity | null;
    hasChanged: boolean;
}

export interface UnderCutSettingUpdate {
    mode: PosFieldOfNullableAutoPricingUndercutMode | null;
    underCutAbsoluteAmount: PosFieldOfUiMoney | null;
    underCutRelativeAmount: PosFieldOfNullableDecimal | null;
    referenceListingPosition: PosFieldOfNullableInteger | null;
}

export interface PosFieldOfUiMoney {
    value: UiMoney | null;
    hasChanged: boolean;
}

export interface OutlierSettingUpdate {
    mode: PosFieldOfNullableAutoPricingOutlierMode | null;
    standardDeviations: PosFieldOfNullableDecimal | null;
    outlierLimit: PosFieldOfNullableInteger | null;
    absoluteOutlierSpacing: PosFieldOfUiMoney | null;
    relativeOutlierSpacing: PosFieldOfNullableDecimal | null;
}

export interface PosFieldOfNetProceedsFloorAdjustment {
    value: NetProceedsFloorAdjustment | null;
    hasChanged: boolean;
}

export interface NetProceedsFloorAdjustment {
    relativeAdjustmentType: PricingFloorCeilingAdjustmentType | null;
    absoluteAmount: UiMoney | null;
    relativeAmount: UiMoney | null;
    relativePercentage: number | null;
}

export interface PosFieldOfRankPremiumAdjustment {
    value: RankPremiumAdjustment | null;
    hasChanged: boolean;
}

export interface RankPremiumAdjustment {
    absoluteAmount: UiMoney | null;
    relativePercentage: number | null;
}

export interface ValueTupleOfBulkEditPreviewAndListingPricesUpdateInput {
    item1: BulkEditPreview;
    item2: ListingPricesUpdateInput;
}

export interface ListingPricesUpdateInput {
    id: number;
    listPrice: number | null;
    allInPrice: number | null;
    netProceedsFloor: number | null;
    netProceedsCeiling: number | null;
    autoPricingEnabled: boolean | null;
    marketplacePriceUpdates: ListingMarketplacePriceUpdateInput[];
}

export interface ValueTupleOfBulkEditPreviewAndISetOfMarketplaceAndISetOfMarketplace {
    item1: BulkEditPreview;
    item2: Marketplace[];
    item3: Marketplace[];
}

export interface ValueTupleOfBulkEditPreviewAndDeliveryTypeAndIListOfTicketTypePriority {
    item1: BulkEditPreview;
    item2: DeliveryType;
    item3: TicketTypePriority[];
}

export interface MergeListingGroupInputList {
    mergeListingGroupInputs: MergeListingGroupInput[];
}

export interface MergeListingGroupInput {
    listingGroupId: string;
    name: string;
    viagogoEventId: number | null;
    viagogoMappingId: string | null;
    desiredActiveListings: number | null;
    minActiveListings: number | null;
    maxActiveListings: number | null;
    targetPercentage: number | null;
    deprioritizedQuantities: string[] | null;
    listingGroupItems: ListingGroupItemInput[];
    groupUndercutSetting: ListingGroupUndercutSetting | null;
    marketplaceSettings: ListingGroupListingMarketplaceSettings | null;
    groupingMethods: ListingGroupingMethods | null;
    inheritListingGroupSettings: boolean | null;
    maintainPriceStagger: boolean | null;
}

export interface ListingGroupItemInput {
    listingId: number;
    priority: number;
    groupId: string | null;
    undercutSetting: ListingGroupUndercutSetting | null;
}

export interface ListingGroupListingMarketplaceSettings {
    listingMarketplaceSettings: { [key: string]: ListingMarketplaceSetting; } | null;
}

export interface ListingMarketplaceSetting {
    listingBroadcastStateId: number;
}

export interface ListingGroupingMethods {
    groupingMethods: ListingGroupingMethod[];
}

export interface ListingGroupingMethod {
    groupingOrder: number;
    groupingType: GroupingType;
    groupingValue: string | null;
    numberOfBucket: number | null;
    bucketType: BucketType | null;
}

export enum GroupingType {
    None = "None",
    Zone = "Zone",
    Section = "Section",
    Row = "Row",
    SeatScore = "SeatScore",
    Quantity = "Quantity",
    UnitCost = "UnitCost",
    Custom = "Custom",
}

export enum BucketType {
    None = "None",
    Clusters = "Clusters",
    SameSize = "SameSize",
}

export interface ValueTupleOfBulkEditPreviewAndIListOfCommission {
    item1: BulkEditPreview;
    item2: Commission[];
}

export interface ValueTupleOfBulkEditPreviewAndIListOfListingNote {
    item1: BulkEditPreview;
    item2: ListingNote[];
}

export interface TicketBarcodeResponse {
    ticketId: number;
    barcode: string | null;
    section: string | null;
    row: string | null;
    seat: string | null;
}

export interface TicketBarcode {
    ticketId: number;
    barcode: string;
    section: string | null;
    row: string | null;
    seat: string | null;
}

export interface ImportFileResult {
    startedInBackground: boolean;
    success: boolean;
    successCount: number;
    failureCount: number;
    warningCount: number;
    totalCount: number;
    errors: string[];
    warnings: string[];
    errorRows: number[];
}

export interface ValueTupleOfBulkEditPreviewAndIDictionaryOfLongAndListOfInteger {
    item1: BulkEditPreview;
    item2: { [key: string]: number[]; };
}

export interface BulkEditListingGroupSettingsInput {
    viagogoEventId: number | null;
    desiredActiveListings: number | null;
    deprioritizedQuantities: string[] | null;
    groupUndercutSetting: ListingGroupUndercutSetting | null;
    marketplaceSettings: ListingGroupListingMarketplaceSettings | null;
    autoPricingInputs: AutoPricingInputs | null;
    listingGroupListingIds: number[] | null;
}

export interface AutoPricingInputs {
    autoPriceFrequency: number | null;
    scoreModel: ScoreModel | null;
    venueZoneConfigType: VenueZoneConfigType | null;
    venueZoneOverrideId: number | null;
    autoPricingDefaultQuantityFiltersJson: string | null;
    undercutMode: AutoPricingUndercutMode | null;
    undercutAbsoluteAmount: number | null;
    undercutRelativeAmount: number | null;
    undercutReferenceListingPosition: number | null;
    compListingMode: AutoPricingCompListingMode | null;
    compListingFloor: number | null;
    compListingCeiling: number | null;
    compListingQuantityScoreAdjustmentEnabled: boolean | null;
    compListingQuantityScoreAdjustmentOverrides: { [key: string]: number; } | null;
    compListingQuantityScoreAdjustmentOverrideJson: string | null;
    compListingOnlyForSameZoneEnabled: boolean | null;
    compListingOnlyForSelectedSectionsEnabled: boolean | null;
    compListingExcludeFanInventory: boolean | null;
    compListingExcludeDefects: boolean | null;
    compListingIncludeUnmappedInventory: boolean | null;
    compListingSelectedSectionSettings: SelectedSectionSettings | null;
    compListingQuantityFilters: CompListingQuantity | null;
    circuitBreakerRelativeCeiling: number | null;
    circuitBreakerRelativeFloor: number | null;
    circuitBreakerMaxDiscountVelocityPercent: number | null;
    circuitBreakerMaxDiscountVelocityTicksInHours: number | null;
    circuitBreakerMinCompListingCount: number | null;
    outlierMode: AutoPricingOutlierMode | null;
    outlierStandardDeviations: number | null;
    outlierKthLowestLimit: number | null;
    outlierKthLowestLimitRelativeSpacing: number | null;
    outlierKthLowestLimitAbsoluteSpacing: number | null;
}

export enum ScoreModel {
    VenueGeometry = "VenueGeometry",
    MergedVenueGeometry = "MergedVenueGeometry",
    BespokeBaseball = "BespokeBaseball",
    SqsClassifier = "SqsClassifier",
}

export enum VenueZoneConfigType {
    Amphitheater = "Amphitheater",
    ConcertsSectionsBehindStage = "ConcertsSectionsBehindStage",
    SportsOrConcertsWith360 = "SportsOrConcertsWith360",
}

export interface BulkEditLog {
    entityType: ActionOutboxEntityType;
    bulkActionType: BulkActionType;
    bulkProcessingId: string;
    payload: BulkEditLogPayload;
    sellerUserId: string | null;
    startDate: string;
    endDate: string | null;
}

export enum BulkActionType {
    GroupListings = "GroupListings",
    ChangeEvent = "ChangeEvent",
    AdminHold = "AdminHold",
    MarkAsFulfilled = "MarkAsFulfilled",
    CancelPurchase = "CancelPurchase",
    DeleteTicketGroup = "DeleteTicketGroup",
    UploadPurchaseFile = "UploadPurchaseFile",
    BackfillDeliverySettings = "BackfillDeliverySettings",
    ConvertPurchasePayment = "ConvertPurchasePayment",
    WasteTickets = "WasteTickets",
    MergeSelectedListings = "MergeSelectedListings",
    UploadSeatSaversFile = "UploadSeatSaversFile",
    UnwasteTickets = "UnwasteTickets",
    UpdateBroadcastSettings = "UpdateBroadcastSettings",
    UpdatePrices = "UpdatePrices",
    UpdateTagValues = "UpdateTagValues",
    UpdatePriceFloorCeiling = "UpdatePriceFloorCeiling",
    UpdateAutoPricingSettings = "UpdateAutoPricingSettings",
    UpdateGeneralSettings = "UpdateGeneralSettings",
    UpdateMarketplaceSeating = "UpdateMarketplaceSeating",
    UpdateTicketTypeRules = "UpdateTicketTypeRules",
    UpdateBuyerCommissions = "UpdateBuyerCommissions",
    UpdateInternalNotes = "UpdateInternalNotes",
    UpdateIsNoFulfill = "UpdateIsNoFulfill",
    UpdateDeliveryType = "UpdateDeliveryType",
    UpdateSeatTraits = "UpdateSeatTraits",
    UpdateMarketplacePrices = "UpdateMarketplacePrices",
    UpdatePurchaseCurrency = "UpdatePurchaseCurrency",
    UpdateBarcodes = "UpdateBarcodes",
    UpdateSaleFulfiller = "UpdateSaleFulfiller",
    UpdateFaceValue = "UpdateFaceValue",
    DeleteSeatSavers = "DeleteSeatSavers",
    RemovePredelivery = "RemovePredelivery",
    ResetMergedListings = "ResetMergedListings",
    UngroupListings = "UngroupListings",
    EditListingGroupSetting = "EditListingGroupSetting",
    MarkPurchaseAsPaid = "MarkPurchaseAsPaid",
    MarkSaleAsPaid = "MarkSaleAsPaid",
    CancelSale = "CancelSale",
    AdjustCost = "AdjustCost",
    ReturnTicket = "ReturnTicket",
    SplitListings = "SplitListings",
    AdjustFxRate = "AdjustFxRate",
    UpdateSeating = "UpdateSeating",
    CopyTickets = "CopyTickets",
}

export interface BulkEditLogPayload {
    method: string;
    latestStep: BulkEditStep;
    errors: string[];
    warnings: string[];
    entitiesByType: { [key in keyof typeof ActionOutboxEntityType]?: BulkEditCountWithId; };
    filterQuery: EntityWithTicketsQuery | null;
    params: any | null;
    startDate: string;
    endDate: string;
}

export interface BulkEditCountWithId extends BulkEditCount {
    skipCount: number;
    idsToBeProcessed: string[];
    idsSkipped: string[];
    idsSuccessful: string[];
    idsFailed: string[];
    idsWarning: string[];
    idsToRetry: string[];
}

export interface BulkEditLogQuery {
    startDates: DateTimeRangeWithRelative | null;
    entityType: ActionOutboxEntityType | null;
    bulkActionTypes: BulkActionType[];
    timezoneOffsetMins: number | null;
}

export interface PurchaseOrderQuery extends EntityWithTicketsQuery {
    ticketGroupIds: number[] | null;
    purchaseMonths: string[] | null;
    paymentMethod: PurchasePaymentMethodType | null;
    paymentStatus: PurchasePaymentStatus | null;
    paymentDates: DateTimeRangeWithRelative | null;
    totalCostHigh: number | null;
    totalCostLow: number | null;
    unitCostHigh: number | null;
    unitCostLow: number | null;
    deliveryType: DeliveryType | null;
    purchaseOrderState: PurchaseOrderState | null;
    viewMode: PurchaseViewMode | null;
    paymentMethodId: number | null;
    paymentCurrencyCodes: string[] | null;
    isConsignment: boolean | null;
}

export enum PurchaseViewMode {
    TileView = "Tile View",
    FlattenedView = "Flattened View",
    EventTileView = "Event Tile View",
}

export interface ValueTupleOfBulkEditPreviewAndPosFieldOfNullableGuid {
    item1: BulkEditPreview;
    item2: PosFieldOfNullableGuid;
}

export interface PosFieldOfNullableGuid {
    value: string | null;
    hasChanged: boolean;
}

export interface ValueTupleOfBulkEditPreviewAndString {
    item1: BulkEditPreview;
    item2: string;
}

export interface ValueTupleOfBulkEditPreviewAndNullableSaleCancellationReason {
    item1: BulkEditPreview;
    item2: SaleCancellationReason | null;
}

export enum BulkChangePriceMode {
    Increase = "Increase",
    Decrease = "Decrease",
    Override = "Override",
}

export enum BulkAdjustCostField {
    UnitCost = "UnitCost",
    TotalTicketCost = "TotalTicketCost",
    PurchaseOrderUnitCost = "PurchaseOrderUnitCost",
    PurchaseOrderTotalCost = "PurchaseOrderTotalCost",
}

export interface SaleQuery extends EntityWithTicketsQuery {
    soldOnMarketplace: Marketplace | null;
    saleStatus: PointOfSaleSaleStatus | null;
    saleStatuses: PointOfSaleSaleStatus[] | null;
    fulfillmentStates: PointOfSaleFulfillmentState[] | null;
    paymentState: PointOfSalePaymentState | null;
    marketplacePaymentState: MarketplacePaymentState | null;
    paymentReceived: boolean | null;
    paymentReferenceId: string | null;
    paymentDates: DateTimeRangeWithRelative | null;
    fulfillmentDates: DateTimeRangeWithRelative | null;
    cancellationDates: DateTimeRangeWithRelative | null;
    saleDates: DateTimeRangeWithRelative | null;
    ticketType: TicketType | null;
    fulfillerSellerUserId: string | null;
    listingInsertBy: string | null;
    buyerEmail: string | null;
    isNoFulfill: boolean | null;
    unitCostHigh: number | null;
    unitCostLow: number | null;
    viewMode: SalesViewMode | null;
}

export enum SalesViewMode {
    TileView = "Tile View",
    FlattenedView = "Flattened View",
}

export interface ValueTupleOfBulkEditPreviewAndSaleInput {
    item1: BulkEditPreview;
    item2: SaleInput;
}

export interface SaleInput {
    saleId: number;
    ticketType: PosFieldOfNullableTicketType | null;
    fulfillerSellerUserId: PosFieldOfNullableGuid | null;
    internalNotes: PosFieldOfString | null;
    tags: PosFieldArrayOfTag | null;
    lineItems: PosFieldArrayOfSaleLineItem | null;
    marketplacePaymentLines: PosFieldArrayOfSiteMarketplacePaymentLineInput | null;
    paymentReceived: PosFieldOfNullableBoolean | null;
    paymentReferenceId: PosFieldOfString | null;
    lastPaymentDate: PosFieldOfNullableDateTime | null;
    paymentAmountReceived: PosFieldOfNullableDecimal | null;
    paymentCurrency: PosFieldOfString | null;
    disableAutoSourcing: PosFieldOfNullableBoolean | null;
    isNoFulfill: PosFieldOfNullableBoolean | null;
    commissions: PosFieldArrayOfCommission | null;
    cancellationReason: PosFieldOfNullableSaleCancellationReason | null;
}

export interface PosFieldOfNullableTicketType {
    value: TicketType | null;
    hasChanged: boolean;
}

export interface PosFieldArrayOfTag {
    value: Tag[] | null;
    hasChanged: boolean;
}

export interface PosFieldArrayOfSaleLineItem {
    value: SaleLineItem[] | null;
    hasChanged: boolean;
}

export interface SaleLineItem {
    id: number;
    saleId: number;
    status: SaleLineItemStatus;
    costType: SaleCostType;
    costDate: string | null;
    dueDate: string | null;
    cost: number;
    currencyCode: string;
    description: string | null;
    saleLineItemChargeReason: SaleLineItemChargeReason | null;
    saleLineItemCreditReason: SaleLineItemCreditReason | null;
    marketplacePaymentLineId: number | null;
    isMarketplacePaymentLocked: boolean | null;
    paymentReceived: boolean | null;
    paymentReferenceId: string | null;
}

export enum SaleLineItemStatus {
    Paid = "Paid",
    Unpaid = "Unpaid",
}

export enum SaleCostType {
    Charge = "Charge",
    Credit = "Credit",
    Proceeds = "Proceeds",
    Taxes = "Taxes",
    Shipping = "Shipping",
}

export enum SaleLineItemChargeReason {
    CancelledProceeds = "CancelledProceeds",
    DroppedOrderPenalty = "DroppedOrderPenalty",
    Compensation = "Compensation",
    Other = "Other",
}

export enum SaleLineItemCreditReason {
    ReversedPenalty = "ReversedPenalty",
    ReversedCharge = "ReversedCharge",
    ProceedRepayment = "ProceedRepayment",
    Other = "Other",
}

export interface PosFieldArrayOfSiteMarketplacePaymentLineInput {
    value: SiteMarketplacePaymentLineInput[] | null;
    hasChanged: boolean;
}

export interface SiteMarketplacePaymentLineInput {
    marketplacePaymentLineId: number | null;
    marketplacePaymentId: number | null;
    externalPaymentId: string;
    externalPaymentLineId: string;
    externalSaleId: string;
    saleId: number | null;
    currency: string;
    amount: number;
    isCredit: boolean;
    paymentLineType: MarketplacePaymentLineType;
    paymentState: MarketplacePaymentState | null;
    paymentDate: string | null;
    receivedDate: string | null;
    isLocked: boolean | null;
    externalPaymentMethodType: ExternalPaymentMethodType | null;
    externalPaymentNote: string | null;
}

export enum MarketplacePaymentLineType {
    Credit = "Credit",
    Proceeds = "Proceeds",
    FullPrice = "FullPrice",
    SellerFee = "SellerFee",
    Penalty = "Penalty",
    AlternativeTickets = "AlternativeTickets",
    OrderNotFulfilled = "OrderNotFulfilled",
    CancelledEvent = "CancelledEvent",
    WitheldFunds = "WitheldFunds",
    LastMinuteSalesLateDelivery = "LastMinuteSalesLateDelivery",
    ExpiredShippingLabel = "ExpiredShippingLabel",
    DeliveryMethodChange = "DeliveryMethodChange",
    BuyerDeniedEntry = "BuyerDeniedEntry",
    WrongTicketsReturnShippingCost = "WrongTicketsReturnShippingCost",
    EarlyShippingLabelGeneration = "EarlyShippingLabelGeneration",
    WrongTrackingNumber = "WrongTrackingNumber",
    ExcessiveFailureRate = "ExcessiveFailureRate",
    SellerError = "SellerError",
    AlternativeTicketsBuyerCompensation = "AlternativeTicketsBuyerCompensation",
    RAGSellerFaultNoResponse = "RAGSellerFaultNoResponse",
    OverchargedSeller = "OverchargedSeller",
    ShippingRefund = "ShippingRefund",
    SellerRelationship = "SellerRelationship",
    RAGDeliveryDispute = "RAGDeliveryDispute",
    CSError = "CSError",
    LMSError = "LMSError",
    TaxRefund = "TaxRefund",
    Other = "Other",
    Charge = "Charge",
    CancelledProceeds = "CancelledProceeds",
    Tax = "Tax",
}

export enum ExternalPaymentMethodType {
    CreditCard = "CreditCard",
    Wire = "Wire",
    ACH = "ACH",
    Check = "Check",
    CustomerCredit = "CustomerCredit",
    Cash = "Cash",
    Other = "Other",
}

export interface PosFieldOfNullableDateTime {
    value: string | null;
    hasChanged: boolean;
}

export interface PosFieldArrayOfCommission {
    value: Commission[] | null;
    hasChanged: boolean;
}

export interface PosFieldOfNullableSaleCancellationReason {
    value: SaleCancellationReason | null;
    hasChanged: boolean;
}

export interface SalesFulfillerBackfillQuery {
    venueIds: number[] | null;
    eventId: number | null;
    fulfillerSellerUserId: string;
}

export interface ValueTupleOfBulkEditPreviewAndGuid {
    item1: BulkEditPreview;
    item2: string;
}

export interface ValueTupleOfBulkEditPreviewAndDecimal {
    item1: BulkEditPreview;
    item2: number;
}

export interface BulkCopyTicketsPreviewRequest {
    query: PurchaseOrderQuery;
    targetEvents: CopyTicketsTargetEvent[];
    splitCost: boolean;
}

export interface CopyTicketsTargetEvent {
    viagogoVirtualId: string;
    viagogoEventId: number | null;
    eventMappingId: string | null;
    posEventId: string | null;
    eventName: string | null;
    eventDateTime: string | null;
}

export interface ValueTupleOfBulkEditPreviewAndIListOfCopyTicketsTargetEventAndBoolean {
    item1: BulkEditPreview;
    item2: CopyTicketsTargetEvent[];
    item3: boolean;
}

export interface ValueTupleOfBulkEditPreviewAndStringAndStringAndStringAndString {
    item1: BulkEditPreview;
    item2: string;
    item3: string;
    item4: string;
    item5: string;
}

export interface ValueTupleOfIListOfIntegerAndIListOfInteger {
    item1: number[];
    item2: number[];
}

export interface BaseClientResponse {
    success: boolean;
    errorMessage: string | null;
    validationErrors: ValidationError[] | null;
}

export interface ValidationError {
    field: string;
    message: string;
    code: string;
}

export interface SponsoredListingsCampaignInput {
    eventId: number;
    campaignId: number;
    dateRange: DateTimeRange;
    campaignName: PosFieldOfString;
    recurringFlightBudget: PosFieldOfNullableDecimal;
    currentFlightBudget: PosFieldOfNullableDecimal;
    flightDuration: PosFieldOfNullableFlightDuration;
    biddingMode: PosFieldOfNullableBiddingMode;
    baseBid: PosFieldOfNullableDecimal;
    targetTicketClassIds: PosFieldOfIListOfInteger;
    firstThreeRowsOnly: PosFieldOfNullableBoolean;
    spendStrategy: PosFieldOfNullableSpendStrategy;
    targetRoas: PosFieldOfNullableDecimal;
    editBudgetForActiveFlightOnly: PosFieldOfNullableBoolean;
}

export interface PosFieldOfNullableFlightDuration {
    value: FlightDuration | null;
    hasChanged: boolean;
}

export enum FlightDuration {
    Daily = "Daily",
    Weekly = "Weekly",
    Monthly = "Monthly",
}

export interface PosFieldOfNullableBiddingMode {
    value: BiddingMode | null;
    hasChanged: boolean;
}

export enum BiddingMode {
    Automatic = "Automatic",
    Manual = "Manual",
    TargetRoas = "TargetRoas",
}

export interface PosFieldOfIListOfInteger {
    value: number[] | null;
    hasChanged: boolean;
}

export interface PosFieldOfNullableSpendStrategy {
    value: SpendStrategy | null;
    hasChanged: boolean;
}

export enum SpendStrategy {
    HoldForBetterPrices = "HoldForBetterPrices",
    SteadyHarvest = "SteadyHarvest",
    MeasuredPush = "MeasuredPush",
    Accelerate = "Accelerate",
    TurboBoost = "TurboBoost",
}

export interface UpdateCampaignStateClientResponse extends BaseClientResponse {
}

export enum AdCampaignState {
    Active = "Active",
    Paused = "Paused",
    Deleted = "Deleted",
}

export interface SponsoredListingsCampaign {
    eventId: number;
    performerId: number | null;
    campaignName: string;
    campaignId: number;
    totalBudget: number | null;
    totalSpend: number | null;
    baseBid: number | null;
    maxBid: number | null;
    recurringFlightBudget: number | null;
    flightDuration: FlightDuration | null;
    dateRange: DateTimeRange;
    biddingMode: BiddingMode;
    spendStrategy: SpendStrategy | null;
    targetRoas: number | null;
    targetTicketClassIds: number[] | null;
    firstThreeRowsOnly: boolean;
    campaignState: AdCampaignState;
    autoCampaignRuleId: number | null;
    autoCampaignRuleName: string | null;
    currencyCode: string;
    activeFlight: SponsoredListingsFlight | null;
    campaignFlightIds: number[] | null;
    adGroups: SponsoredListingsAdGroup[] | null;
    flights: SponsoredListingsFlight[] | null;
    historicPotentialImpressions: number | null;
    actualImpressions: number | null;
    impressionShare: number | null;
    clicks: number | null;
    salesCount: number | null;
    salesProceeds: number | null;
    potentialSales: number | null;
    potentialRevenue: number | null;
    incrementalSellerProceedsUSD: number | null;
    hasEnded: boolean;
}

export interface SponsoredListingsFlight {
    flightId: number;
    campaignId: number;
    dateRange: DateTimeRange;
    flightBudget: number;
    flightSpend: number | null;
    baseBid: number | null;
    maxBid: number | null;
    pacingOption: FlightPacingOption | null;
    isCurrent: boolean;
    historicPotentialImpressions: number | null;
    actualImpressions: number | null;
    impressionShare: number | null;
    clicks: number | null;
    salesCount: number | null;
    salesProceeds: number | null;
    potentialSales: number | null;
    potentialRevenue: number | null;
    incrementalSellerProceedsUSD: number | null;
}

export enum FlightPacingOption {
    PaceToEndOfFlight = "PaceToEndOfFlight",
    ASAP = "ASAP",
}

export interface SponsoredListingsAdGroup {
    adGroupId: number;
    name: string;
    state: AdGroupState;
}

export enum AdGroupState {
    Active = "Active",
    Paused = "Paused",
    Deleted = "Deleted",
}

export interface BoostedSale {
    saleId: number;
    posEventId: string;
    adCampaignFlightId: number;
    currencyCode: string;
    listingId: number | null;
    originatedFromListingId: number | null;
    totalCost: number | null;
    totalNetProceeds: number;
}

export interface CatalogResults {
    events: { [key: string]: EventWithData; };
    performers: { [key: string]: Performer; };
    venues: { [key: string]: Venue; };
    viagIdToLatestIdLookup: { [key: string]: string; };
    posIdToViagIdLookup: { [key: string]: string; };
    countries: { [key: string]: Country; };
    purchaseCount: number;
}

export interface EventWithData {
    event: Event;
    counts: EventEntityCounts;
    entities: EventEntities;
}

export interface EventEntityCounts {
    viagVirtId: string;
    perfId: number | null;
    venId: number;
    rowVer: number | null;
    salesCnt: number | null;
    listCnt: number | null;
    pricedListCnt: number | null;
    ungrListCnt: number | null;
    listGrpCnt: number | null;
    tktGrpsCnt: number | null;
    poCnt: number | null;
}

export interface EventEntities {
    listings: Listing[] | null;
    listingsSummary: Listing | null;
    sales: Sale[] | null;
    salesSummary: Sale | null;
    ticketGroups: PurchaseOrderTicketGroup[] | null;
    ticketGroupsSummary: PurchaseOrderTicketGroup | null;
    getDataFail: boolean | null;
}

export interface Country {
    code: string | null;
    name: string | null;
}

export interface CatalogEntityMetricsResultsOfSaleMetrics {
    maxRowVersion: number | null;
    events: { [key: string]: SaleMetrics; };
    performers: { [key: string]: SaleMetrics; };
    venues: { [key: string]: SaleMetrics; };
    usedCache: boolean | null;
    cacheStale: boolean | null;
    cacheStaleTimeMs: number | null;
    missingPosEventIdsCount: number | null;
    top100MissingPosEventIds: string[] | null;
    metricsDif: { [key: string]: any; } | null;
    timeDif: { [key: string]: number; } | null;
}

export interface CatalogSaleMetricsResults extends CatalogEntityMetricsResultsOfSaleMetrics {
}

export interface SaleMetrics {
    qtySold: number;
    saleUnfilled: number;
    saleFulfillable: number;
    pendSrc: number;
    netProcs: number | null;
    ttlCst: number | null;
    currency: string | null;
    marg: number | null;
    tags: Tag[] | null;
}

export interface CatalogEntityMetricsResultsOfTicketGroupMetrics {
    maxRowVersion: number | null;
    events: { [key: string]: TicketGroupMetrics; };
    performers: { [key: string]: TicketGroupMetrics; };
    venues: { [key: string]: TicketGroupMetrics; };
    usedCache: boolean | null;
    cacheStale: boolean | null;
    cacheStaleTimeMs: number | null;
    missingPosEventIdsCount: number | null;
    top100MissingPosEventIds: string[] | null;
    metricsDif: { [key: string]: any; } | null;
    timeDif: { [key: string]: number; } | null;
}

export interface CatalogTicketGroupMetricsResults extends CatalogEntityMetricsResultsOfTicketGroupMetrics {
}

export interface TicketGroupMetrics {
    tktQty: number;
    ttlCst: number | null;
    currency: string | null;
    tags: Tag[] | null;
}

export interface EventGroupingQuery {
    groupingType: EventGroupingType;
    searchText: string | null;
    sortBy: EventGroupingSortBy | null;
    isSortDescending: boolean | null;
}

export enum EventGroupingType {
    Performer = "Performers",
    Venue = "Venues",
}

export enum EventGroupingSortBy {
    Name = "Name",
}

export interface EventSearchQuery {
    searchText: string | null;
    performerId: number | null;
    venueId: number | null;
    timeFrame: EventTimeFrameFilter | null;
}

export interface CatalogEntityMetricsResultsOfListingMetrics {
    maxRowVersion: number | null;
    events: { [key: string]: ListingMetrics; };
    performers: { [key: string]: ListingMetrics; };
    venues: { [key: string]: ListingMetrics; };
    usedCache: boolean | null;
    cacheStale: boolean | null;
    cacheStaleTimeMs: number | null;
    missingPosEventIdsCount: number | null;
    top100MissingPosEventIds: string[] | null;
    metricsDif: { [key: string]: any; } | null;
    timeDif: { [key: string]: number; } | null;
}

export interface CatalogListingMetricsResults extends CatalogEntityMetricsResultsOfListingMetrics {
    eventsDetailed: { [key: string]: ListingDetailedMetrics; };
}

export interface ListingMetrics {
    tktQty: number;
    soldQty: number;
    unsoldQty: number;
    listQty: number;
    unlistQty: number;
    currency: string;
    ttlCst: number;
    soldCst: number;
    unsoldCst: number;
    ttlListPrc: number;
    ttlUnsoldListPrc: number;
    netProcs: number;
    pandL: number;
    tags: Tag[] | null;
}

export interface ListingDetailedMetrics extends ListingMetrics {
    str: number;
    rvn: number;
    liftPerc: number;
    atp: number;
    listedATP: number;
    priceUpdatedOn: string | null;
    lastSaleDate: string | null;
    qtySoldL1: number;
    qtySoldL3: number;
    qtySoldL7: number;
    unfulfilledTickets: number;
    fulfillableTickets: number;
    pendSrc: number;
}

export interface ListingMetricsInput {
    totalTicketQuantity: number | null;
    totalSoldQuantity: number | null;
    totalUnsoldQuantity: number | null;
    totalListedQuantity: number | null;
    totalUnlistedQuantity: number | null;
    currencyCode: string | null;
    totalCost: number | null;
    totalSoldCost: number | null;
    totalUnsoldCost: number | null;
    totalListPrice: number | null;
    totalListedValue: number | null;
    totalUnsoldListPrice: number | null;
    totalNetProceeds: number | null;
    totalGrossProfit: number | null;
}

export interface ValueTupleOfEventAndVenueAndPerformer {
    item1: Event;
    item2: Venue;
    item3: Performer;
}

export interface EventMappingRequest {
    eventName: string;
    eventDate: string;
    isEventDateConfirmed: boolean | null;
    eventNote: string | null;
    venueName: string;
    city: string;
    stateProvince: string;
    countryCode: string;
    requestCount: number | null;
}

export interface UpcomingOnSalesResult {
    catalog: CatalogResults;
    marketplaceEventInfos: { [key: string]: SellerEventMarketplaceEventInfo[]; };
}

export interface SellerEventMarketplaceEventInfo {
    viagogoEventId: number | null;
    marketplace: Marketplace;
    mappedEventId: string | null;
    websiteEventId: string | null;
    eventIdOverride: string | null;
    eventMappingId: string | null;
}

export interface OnSaleEventQuery {
    onSaleDates: DateTimeRangeWithRelative | null;
    performerIds: number[] | null;
    venueIds: number[] | null;
    countryCodes: string[] | null;
    stateProvinceIds: number[] | null;
    cityIds: number[] | null;
    topLevelCategories: TopLevelCategory[] | null;
    parentCategories: number[] | null;
    timezoneOffsetMins: number | null;
    viewMode: OnSaleEventViewMode | null;
    searchText: string | null;
    eventIds: number[] | null;
    listingQtyRange: NumericRange | null;
    ticketQtyRange: NumericRange | null;
    visitsL1HRange: NumericRange | null;
    visitsL24HRange: NumericRange | null;
    visitsL3DRange: NumericRange | null;
    visitsL7DRange: NumericRange | null;
    transL1HRange: NumericRange | null;
    transL24HRange: NumericRange | null;
    transL3DRange: NumericRange | null;
    transL7DRange: NumericRange | null;
    priceMinRange: NumericRange | null;
    priceP25Range: NumericRange | null;
    priceP50Range: NumericRange | null;
}

export enum OnSaleEventViewMode {
    MetricView = "Metric View",
}

export interface OnSaleEventMetrics {
    eId: number;
    eventVisits: OnSaleEventCountMetrics | null;
    eventTransactions: OnSaleEventCountMetrics | null;
    minUNP: number;
    p25UNP: number;
    p50UNP: number;
    ltgCnt: number;
    tktCnt: number;
    vstBkt: number[];
    vstIdx: number;
}

export interface OnSaleEventCountMetrics {
    lastHour: number;
    lastDay: number;
    lastThreeDays: number;
    lastSevenDays: number;
}

export interface EventAttributes {
    eventId: number;
    inferredPrimary: string | null;
}

export interface CategoryResult {
    categoryId: number;
    imageUrl: string | null;
    description: string | null;
}

export interface CatalogResultsSlim {
    events: Event[];
    venues: Venue[];
    performers: Performer[];
    countries: Country[];
}

export interface CatalogCounts {
    entityCnts: EventEntityCounts[];
    purchaseCount: number;
    usedCache: boolean | null;
    cacheStale: boolean | null;
    cacheStaleTimeMs: number | null;
    countDif: { [key: string]: any; } | null;
    timeDif: { [key: string]: number; } | null;
    missingPosEventIdsCount: number | null;
    top100MissingPosEventIds: string[] | null;
}

export interface ListingQueryV2 extends ListingQuery {
    pricerSellerUserIds: string[] | null;
    deliveryTypes: DeliveryType[] | null;
    ticketTypes: TicketType[] | null;
    splitTypes: SplitType[] | null;
    eventUnpricedStatuses: EventUnpricedStatus[] | null;
    operations: ListingQueryOperations | null;
    searchOptions: UISearchOptions | null;
    unitAllInPriceRange: NumericRange | null;
    quantityRange: NumericRange | null;
}

export interface EntityWithTicketsQueryOperations {
    entityIdsOp: FilterOperationType | null;
    marketplaceEntityIdsOp: FilterOperationType | null;
    eventOrMappingIdsOp: FilterOperationType | null;
    eventIdsOverrideOp: FilterOperationType | null;
    oldPosEventIdsOp: FilterOperationType | null;
    performerIdsOp: FilterOperationType | null;
    venueIdsOp: FilterOperationType | null;
    countryCodesOp: FilterOperationType | null;
    stateProvinceIdsOp: FilterOperationType | null;
    cityIdsOp: FilterOperationType | null;
    purchaseOrderIdsOp: FilterOperationType | null;
    saleIdsOp: FilterOperationType | null;
    listingIdsOp: FilterOperationType | null;
    purchaseVendorIdOp: FilterOperationType | null;
    vendorAccessControlProviderIdOp: FilterOperationType | null;
    purchaseVendorAccountIdsOp: FilterOperationType | null;
    purchaseVendorOrderIdOp: FilterOperationType | null;
    purchaseBuyerIdOp: FilterOperationType | null;
    purchaseOrderCreatedByOp: FilterOperationType | null;
    purchaseCommissionUserIdOp: FilterOperationType | null;
    purchaseDatesOp: FilterOperationType | null;
    inHandDatesOp: FilterOperationType | null;
    eventTimeFrameFilterOp: FilterOperationType | null;
    sectionOp: FilterOperationType | null;
    rowOp: FilterOperationType | null;
    isSeatSaverOp: FilterOperationType | null;
    eventDatesOp: FilterOperationType | null;
    eventNotReviewedSinceDateOp: FilterOperationType | null;
    isMappedOp: FilterOperationType | null;
    isMappingRejectedOp: FilterOperationType | null;
    searchTextOp: FilterOperationType | null;
    isBoostedOp: FilterOperationType | null;
    sortByOp: FilterOperationType | null;
    isSortDescendingOp: FilterOperationType | null;
    tagNameOp: FilterOperationType | null;
    tagValueOp: FilterOperationType | null;
    eventTagNameOp: FilterOperationType | null;
    eventTagValueOp: FilterOperationType | null;
    lastSaleDatesOp: FilterOperationType | null;
    noSaleDatesOp: FilterOperationType | null;
    numberOfTicketsHeldOp: FilterOperationType | null;
    topLevelCategoriesOp: FilterOperationType | null;
    parentCategoriesOp: FilterOperationType | null;
    internalNotesOp: FilterOperationType | null;
    currencyCodesOp: FilterOperationType | null;
    officeIdsOp: FilterOperationType | null;
    eventStatusesOp: FilterOperationType | null;
    searchConfigIdOp: FilterOperationType | null;
}

export interface ListingQueryOperations extends EntityWithTicketsQueryOperations {
    pricerSellerUserIdOp: FilterOperationType | null;
    isPredeliveredOp: FilterOperationType | null;
    isListedOp: FilterOperationType | null;
    deliveryTypeOp: FilterOperationType | null;
    eventHasUnsoldTicketsOp: FilterOperationType | null;
    hasUnsoldTicketsOp: FilterOperationType | null;
    hasBroadcastErrorOp: FilterOperationType | null;
    isAutoPricingEnabledOp: FilterOperationType | null;
    isPricedAboveZeroOp: FilterOperationType | null;
    lastPriceUpdateDatesOp: FilterOperationType | null;
    autoPricingResultTypesOp: FilterOperationType | null;
    preDeliveryStatesOp: FilterOperationType | null;
    isSeatingUnmappedOp: FilterOperationType | null;
    isAdminHoldOp: FilterOperationType | null;
    isDuplicateOp: FilterOperationType | null;
    hasListingGroupIdOp: FilterOperationType | null;
    isPricedByMarketplaceOp: FilterOperationType | null;
    isPendingProofOp: FilterOperationType | null;
    purchaseCancellationDatesOp: FilterOperationType | null;
    purchaseCancelledOnlyOp: FilterOperationType | null;
    isNoFulfillOp: FilterOperationType | null;
    ticketTypeOp: FilterOperationType | null;
    splitTypeOp: FilterOperationType | null;
    eventUnpricedStatusOp: FilterOperationType | null;
    unitAllInPriceRangeOp: FilterOperationType | null;
    quantityRangeOp: FilterOperationType | null;
    unitCostHighOp: FilterOperationType | null;
    unitCostLowOp: FilterOperationType | null;
}

export enum FilterOperationType {
    Equals = "Equals",
    NotEquals = "NotEquals",
    GreaterThan = "GreaterThan",
    LessThan = "LessThan",
    GreaterThanOrEqual = "GreaterThanOrEqual",
    LessThanOrEqual = "LessThanOrEqual",
    Between = "Between",
    In = "In",
    NotIn = "NotIn",
    Contains = "Contains",
    NotContains = "NotContains",
}

export interface UISearchOptions {
    take: number | null;
    skip: number | null;
    sort: UISortCriteria[] | null;
    includeAggregations: boolean | null;
    pitId: string | null;
    searchAfter: any[] | null;
}

export interface UISortCriteria {
    field: string | null;
    desc: boolean | null;
    userNames: { [key: string]: string; } | null;
}

export interface InsertCatchUpModeEventIdsMapRequest {
    catchUpModeSource: CatchUpModeSource;
    eventIds: string[];
}

export enum CatchUpModeSource {
    InventoryEvents = "InventoryEvents",
    OnSaleEvents = "OnSaleEvents",
}

export interface CatchUpModeEventIdsMapResponse {
    mapId: string;
    catchUpModeSource: CatchUpModeSource;
    eventIdsJson: string;
    insertDate: string;
}

export interface ClientLogRequest {
    logLevel: LogLevel;
    applicationSource: string;
    errorId: string | null;
    error: string;
    pageUrl: string;
    componentStack: string | null;
    timestamp: string;
    additionalInfo: { [key: string]: any; } | null;
}

export enum LogLevel {
    Trace = "Trace",
    Verbose = "Verbose",
    Information = "Information",
    Warning = "Warning",
    Error = "Error",
    Critical = "Critical",
    None = "None",
}

export interface StopwatchLogEntry {
    applicationSource: string;
    logId: string | null;
    message: string;
    pageUrl: string;
    startTime: string;
    endTime: string;
    totalDurationMs: number;
    stopGaps: { [key: string]: StopwatchStopGap; };
    hasGrpcCacheFeature: boolean | null;
    usedJSHeapSize: number | null;
    totalJSHeapSize: number | null;
    jsHeapSizeLimit: number | null;
    browserCap: BrowserCap | null;
}

export interface StopwatchStopGap {
    name: string;
    time: string;
    logKey: string | null;
    browserCap: BrowserCap | null;
    usedJSHeapSize: number | null;
    totalJSHeapSize: number | null;
    jsHeapSizeLimit: number | null;
}

export interface BrowserCap {
    estimatedCpuLoad: EstimatedCpuLoad | null;
    estimatedNetworkSpeed: NetworkSpeed | null;
    domContentLoadedMs: number | null;
    loadCompleteMs: number | null;
    renderTimeMs: number | null;
    hardwareConcurrency: number | null;
    browserAgent: string | null;
}

export enum EstimatedCpuLoad {
    Unknown = "Unknown",
    Low = "Low",
    Medium = "Medium",
    High = "High",
}

export enum NetworkSpeed {
    Unknown = "Unknown",
    Slow = "Slow",
    Moderate = "Moderate",
    Fast = "Fast",
}

export enum CommandOptionType {
    NavigateHome = "NavigateHome",
    NavigateInventory = "NavigateInventory",
    NavigateSales = "NavigateSales",
    NavigatePurchases = "NavigatePurchases",
    NavigatePayments = "NavigatePayments",
    NavigateReports = "NavigateReports",
    NavigateSettings = "NavigateSettings",
    ToggleTheme = "ToggleTheme",
    ToggleSelectionMode = "ToggleSelectionMode",
    SelectAll = "SelectAll",
    ListingBulkEditListingGroupSettings = "ListingBulkEditListingGroupSettings",
    ListingsGroupListings = "ListingsGroupListings",
    ListingBulkEditMoveToGroup = "ListingBulkEditMoveToGroup",
    ListingBulkEditUngroupListings = "ListingBulkEditUngroupListings",
    ListingBulkEditAddTags = "ListingBulkEditAddTags",
    ListingBulkEditRemoveTags = "ListingBulkEditRemoveTags",
    ListingBroadcastListing = "ListingBroadcastListing",
    ListingUnbroadcastListing = "ListingUnbroadcastListing",
    ListingBulkEditAddHold = "ListingBulkEditAddHold",
    ListingBulkEditRemoveHold = "ListingBulkEditRemoveHold",
    ListingBulkEditIncreasePrice = "ListingBulkEditIncreasePrice",
    ListingBulkEditDecreasePrice = "ListingBulkEditDecreasePrice",
    ListingBulkEditAdjustFloor = "ListingBulkEditAdjustFloor",
    ListingBulkEditAdjustCeiling = "ListingBulkEditAdjustCeiling",
    ListingBulkEditAutoPricingSettings = "ListingBulkEditAutoPricingSettings",
    ListingBulkEditUpdateMarketplacePrices = "ListingBulkEditUpdateMarketplacePrices",
    ExpandAll = "ExpandAll",
    CollapseAll = "CollapseAll",
    ListingCatchupMode = "ListingCatchupMode",
    ListingBulkEditChangeEvent = "ListingBulkEditChangeEvent",
    ListingBulkEditTicketTypeRule = "ListingBulkEditTicketTypeRule",
    ListingBulkEditCommissionAction = "ListingBulkEditCommissionAction",
    ListingBulkEditMarketplaceSeating = "ListingBulkEditMarketplaceSeating",
    ListingBulkEditRemovePredelivery = "ListingBulkEditRemovePredelivery",
    ListingBulkEditAutoFulfill = "ListingBulkEditAutoFulfill",
    ListingBulkUpdateBarcodes = "ListingBulkUpdateBarcodes",
    ListingBulkEditDeliveryType = "ListingBulkEditDeliveryType",
    ListingBulkEditInternalNotes = "ListingBulkEditInternalNotes",
    ListingBulkEditUpdateListingSettings = "ListingBulkEditUpdateListingSettings",
    ListingBulkEditSeatTraits = "ListingBulkEditSeatTraits",
    ListingBulkEditWasteTickets = "ListingBulkEditWasteTickets",
    ListingBulkEditDeleteSeatSavers = "ListingBulkEditDeleteSeatSavers",
    ListingExportListing = "ListingExportListing",
    ListingBulkReturnTicket = "ListingBulkReturnTicket",
    SalesBulkEditDeallocate = "SalesBulkEditDeallocate",
    SalesBulkEditReject = "SalesBulkEditReject",
    SalesBulkUpdateBarcodes = "SalesBulkUpdateBarcodes",
    SalesBulkEditCommission = "SalesBulkEditCommission",
    SalesBulkEditAddTags = "SalesBulkEditAddTags",
    SalesBulkEditRemoveTags = "SalesBulkEditRemoveTags",
    SalesBulkEditMarkAsFulfilled = "SalesBulkEditMarkAsFulfilled",
    SalesBulkMarkSaleAsPaid = "SalesBulkMarkSaleAsPaid",
    SalesBulkEditAutoFulfill = "SalesBulkEditAutoFulfill",
    SalesBulkEditInternalNotes = "SalesBulkEditInternalNotes",
    SalesBulkEditGeneralSettings = "SalesBulkEditGeneralSettings",
    SalesExportSales = "SalesExportSales",
    PurchasesBulkAdjustCost = "PurchasesBulkAdjustCost",
    PurchaseBulkCancelPurchase = "PurchaseBulkCancelPurchase",
    PurchasesBulkConvertPurchasePayment = "PurchasesBulkConvertPurchasePayment",
    PurchaseBulkDeleteTicketGroup = "PurchaseBulkDeleteTicketGroup",
    PurchasesBulkEditCommissionAction = "PurchasesBulkEditCommissionAction",
    PurchasesBulkEditAddTag = "PurchasesBulkEditAddTag",
    PurchasesBulkEditRemoveTag = "PurchasesBulkEditRemoveTag",
    PurchasesBulkMarkPurchaseAsPaid = "PurchasesBulkMarkPurchaseAsPaid",
    PurchasesBulkUpdateDeliveryType = "PurchasesBulkUpdateDeliveryType",
    PurchasesBulkUpdateInternalNotes = "PurchasesBulkUpdateInternalNotes",
    PurchasesBulkChangeEvent = "PurchasesBulkChangeEvent",
    PurchasesBulkUpdatePurhcaseCurrencyCode = "PurchasesBulkUpdatePurhcaseCurrencyCode",
    PurchasesBulkUpdatePurchaseSettings = "PurchasesBulkUpdatePurchaseSettings",
    PurchasesBulkUpdateSeatTraits = "PurchasesBulkUpdateSeatTraits",
    PurchasesBulkUpdateFaceValue = "PurchasesBulkUpdateFaceValue",
    PurchasesExportPurchases = "PurchasesExportPurchases",
    ListingBulkEditUnwasteTickets = "ListingBulkEditUnwasteTickets",
}

export interface ContentData {
    body: string;
}

export interface DocumentUploadInfo {
    entityId: number;
    entityType: ActionOutboxEntityType;
    documentType: DocumentType;
    blobName: string;
    documentId: string;
    contentType: string;
}

export interface PosUiActionResult {
    entityId: number | null;
    entityType: ActionOutboxEntityType | null;
    status: number | null;
    message: string | null;
}

export interface PosUiActionResultWithDataOfUserDocumentLinks extends PosUiActionResult {
    data: UserDocumentLinks | null;
}

export interface DocumentPage {
    id: string;
    documentId: string;
    pageNumber: number;
    thumbUrl: string;
    documentUrl: string;
}

export interface VenueMapInfo {
    eventId: number;
    venueId: number;
    venueCfgId: number;
    svgMapVer: number | null;
    geoJsonVer: number | null;
    sections: SectionInfo[];
    sectionScores: SectionScoreOverride[];
    focalPt: FocalPointInfo | null;
    hasRow: boolean;
}

export interface SectionInfo {
    id: number;
    name: string;
    rows: RowInfo[];
    sectionType: VenueMapSectionType;
    dist: number | null;
    angle: number | null;
    directionalAngle: number | null;
    height: number | null;
    specRow: VenueMapRow | null;
}

export interface RowInfo {
    id: number;
    name: string | null;
    ordinal: number | null;
    tktClass: TicketClassInfo | null;
    seatQualityScore: number | null;
    isSpeculative: boolean;
}

export interface TicketClassInfo {
    id: number;
    name: string;
    color: string;
    cssPostFix: string;
}

export interface VenueMapRow {
    id: number;
    name: string | null;
    ordinal: number | null;
    ticketClassId: number | null;
    tktClass: VenueMapTicketClass | null;
    seatQualityScore: number | null;
    isSpeculative: boolean;
}

export interface VenueMapTicketClass {
    ticketClassId: number;
    ticketClassName: string;
    color: string;
    cssPostFix: string;
}

export interface SectionScoreOverride {
    sectionId: number;
    rowId: number;
    rowName: string | null;
    rowOrdinal: number | null;
    tkClsId: number | null;
    score: number | null;
    scoreRaw: number | null;
    isManualOverride: boolean | null;
}

export interface FocalPointInfo {
    x: number | null;
    y: number | null;
    angleDeg: number | null;
    isDirectional: boolean;
}

export interface EventListingConstraints {
    eventId: number;
    validListingNoteIds: number[] | null;
    validTicketTypes: number[] | null;
    isSeatRequired: boolean | null;
    validSplitTypes: number[] | null;
}

export interface MarketTransaction {
    listingId: number;
    transactionDateTime: string;
    section: string;
    row: string;
    seatFrom: string;
    seatTo: string;
    quantityPurchased: number;
    sellerUserId: string;
    sellerNetProceeds: number;
    sellerCurrencyCode: string;
}

export interface SellerEventNote {
    eventId: number | null;
    sellerEventNoteId: number;
    sellerUserId: string;
    content: string;
    createDate: string;
}

export interface SellerEventNoteResult extends SellerEventNote {
    sellerDisplayName: string;
}

export interface SellerAccountEventSetting {
    delivType: DeliveryType | null;
    isNoFulfill: boolean | null;
    tktTypeRules: TicketTypeOverride | null;
    inHandAt: string | null;
    vendorId: number | null;
}

export interface EventDiscoveryQuotaConfig {
    enabled: boolean | null;
    autoRenew: boolean | null;
    eventViewQuota: number;
    stubHubProceedsAdvantageAmount: number;
}

export interface OnSaleEventAccess {
    onSaleEventAccessLevel: OnSaleEventAccessLevel;
    eventDiscoveryConfig: EventDiscoveryConfig;
    eventDiscoveryQuota: SellerAccountEventDiscoveryQuota | null;
    recentViewed: boolean;
    hasAccessToView: boolean;
    hasQuota: boolean;
    noProceedsAdvantage: boolean;
}

export enum OnSaleEventAccessLevel {
    Granted = "Granted",
    RecentViewedWithAccess = "RecentViewedWithAccess",
    RecentViewedWithNoQuota = "RecentViewedWithNoQuota",
    RecentViewedWithNoProceedsAdvantage = "RecentViewedWithNoProceedsAdvantage",
    DeniedWithNoProceedsAdvantage = "DeniedWithNoProceedsAdvantage",
    DeniedWithNoQuota = "DeniedWithNoQuota",
}

export interface EventDiscoveryConfig {
    proceedsAdvantageDurationInHours: number;
    eventDiscoveryQuotaResetFrequencyInHours: number;
    quotaConfigs: EventDiscoveryQuotaConfig[];
}

export interface SellerAccountEventDiscoveryQuota {
    eventViewQuota: number;
    eventViewQuotaUsed: number;
    eventViewQuotaUsedResetFrequencyInHours: number;
    eventViewQuotaUsedNextResetDate: string;
}

export interface EventDiscoveryConfigSettings {
    eventDiscoveryConfig: EventDiscoveryConfig;
    sellerProceedsAdvantageConfig: SellerProceedsAdvantageConfig;
    sellerAccountEventDiscoveryQuota: SellerAccountEventDiscoveryQuota | null;
}

export interface SellerProceedsAdvantageConfig {
    hasActiveProceedsAdvantage: boolean;
    hasRenewableActiveProceedsAdvantage: boolean;
    activeProceedsAdvantageAmount: number;
}

export interface EventSectionMetrics {
    sectionId: number;
    pageVisits: EventIncrementalMetricsOfNullableInteger;
    mapSectionClicks: EventIncrementalMetricsOfNullableInteger;
    transactions: EventIncrementalMetricsOfNullableInteger;
    availableTickets: EventIncrementalMetricsOfNullableInteger;
    minPrice: EventIncrementalMetricsOfUiMoney;
    p25Price: EventIncrementalMetricsOfUiMoney;
    medianPrice: EventIncrementalMetricsOfUiMoney;
}

export interface EventIncrementalMetricsOfNullableInteger {
    currentMetricsValue: number | null;
    previousMetricsValue: number | null;
}

export interface EventIncrementalMetricsOfUiMoney {
    currentMetricsValue: UiMoney;
    previousMetricsValue: UiMoney;
}

export enum EventMetricsTimestamp {
    LastHour = "LastHour",
    LastDay = "LastDay",
    Last3Days = "Last3Days",
    LastWeek = "LastWeek",
}

export interface EventNotification {
    id: string;
    name: string;
    notificationType: EventNotificationType;
    status: EventNotificationStatus;
    filters: OnSaleEventQuery;
    userIdTargets: string[];
    webhookTargets: Webhook[];
}

export enum EventNotificationType {
    Email = "Email",
    Webhook = "Webhook",
}

export enum EventNotificationStatus {
    Active = "Active",
    Deactivated = "Deactivated",
}

export interface Webhook {
    id: number;
    name: string;
    url: string;
    authorizationHeader: string;
}

export interface EventGroupListItemDto {
    eventGroupId: string;
    name: string;
    venueId: number | null;
    venueConfigId: number | null;
    categoryId: number | null;
    startDate: string | null;
    endDate: string | null;
    insertDate: string;
}

export interface CreateEventGroupResult {
    eventGroupId: string;
    slots: EventGroupSlot[];
}

export interface EventGroupSlot {
    posEventId: string;
    sellerEventId: string;
}

export interface CreateEventGroupRequest {
    eventGroupId: string;
    name: string;
    selectedEvents: SelectedEventInput[];
    startDate: string;
    endDate: string;
}

export interface SelectedEventInput {
    viagogoEventId: number | null;
    eventMappingId: string | null;
    eventDateTime: string | null;
}

export interface AddPlaceholderEventResult {
    sellerEventId: string;
    posEventId: string;
}

export interface AddPlaceholderEventRequest {
    eventGroupId: string;
}

export interface RemovePlaceholderEventRequest {
    sellerEventId: string;
}

export interface AllocatePlaceholderEventRequest {
    posEventId: string;
    viagogoEventId: number;
    eventDateTime: string;
}

export interface AddEventGroupTicketGroupRequest {
    eventGroupId: string;
    purchaseOrderId: number;
    posEventId: string;
    ticketGroups: EventGroupTicketGroupItem[];
}

export interface EventGroupTicketGroupItem {
    section: string;
    row: string | null;
    quantity: number;
    seatFrom: string | null;
    seatTo: string | null;
    unitCost: number;
    currencyCode: string;
    deliveryType: DeliveryType;
}

export interface GetEventGroupEventsResult {
    eventGroupId: string;
    name: string | null;
    purchaseOrderId: number | null;
    expectedEventCount: number;
    totalCost: number | null;
    members: EventGroupMemberEvent[];
}

export interface EventGroupMemberEvent {
    posEventId: string;
    sellerEventId: string;
    viagogoEventId: number | null;
    eventMappingId: string | null;
    eventDateTime: string | null;
    name: string | null;
    venueId: number | null;
    venueConfigId: number | null;
    categoryId: number | null;
    startDate: string | null;
    endDate: string | null;
}

export interface GetEventGroupEventsRequest {
    eventGroupId: string;
}

export interface FulfillmentProvider {
    fulfillmentProviderSellerUserId: string;
    fulfillmentProviderName: string;
    descriptionMessage: string;
    isEnabled: boolean;
    costPercentagePerTransfer: number | null;
    flatCostPerTransfer: number | null;
}

export interface IndexFreshnessResponse {
    lastUpdatedAt: string | null;
    cachedResult: boolean;
    queryDurationMs: number;
}

export interface ProblemDetails {
    type: string | null;
    title: string | null;
    status: number | null;
    detail: string | null;
    instance: string | null;
    extensions: { [key: string]: any; };

    [key: string]: any;
}

export interface EventMarketplaceWebsiteMetrics {
    ticketsOnPlatform: EventMarketplaceWebsiteMetricOfInteger;
    eventVisitors: EventMarketplaceWebsiteMetricOfInteger;
    visitorsInCheckout: EventMarketplaceWebsiteMetricOfInteger;
    totalTicketPriceInCheckout: EventMarketplaceWebsiteMetricOfUiMoney;
}

export interface EventMarketplaceWebsiteMetricOfInteger {
    currentValue: number;
    previousValue: number;
}

export interface EventMarketplaceWebsiteMetricOfUiMoney {
    currentValue: UiMoney;
    previousValue: UiMoney;
}

export interface InventoryMetricsQueryId {
    posEventId: string | null;
    viagogoEventId: number | null;
}

export enum EventWebsiteMetricsTimePeriod {
    OneHour = "OneHour",
    OneDay = "OneDay",
}

export interface EventDemandFactor {
    type: EventDemandFactorType;
    value: string;
}

export enum EventDemandFactorType {
    Opponent = "Opponent",
    Weather = "Weather",
    Standing = "Standing",
    Stakes = "Stakes",
    SpotifyPopularity = "SpotifyPopularity",
    HomeTeamOdds = "HomeTeamOdds",
}

export interface InventoryEventDashboardResults {
    mktShares: MarketplaceMarketShare[];
    atp: TicketPricePercentiles;
    totalListings: number;
}

export interface MarketplaceMarketShare {
    mktPlc: Marketplace;
    share: number;
}

export interface TicketPricePercentiles {
    currency: string;
    listingCount: number;
    ticketCount: number;
    min: number;
    p25: number;
    p50: number;
    p75: number;
    max: number;
}

export enum SellerEventDashboardMetricsTimePeriod {
    Last7Days = "Last7Days",
    AllTime = "AllTime",
}

export interface EventSectionClearingPrices {
    sectionId: number | null;
    sectionName: string;
    p01: UiMoney;
    p25: UiMoney;
    p50: UiMoney;
    p75: UiMoney;
    p99: UiMoney;
    transactionCount: number;
    normalizedScore: number;
}

export enum EventSectionMetricsTimePeriod {
    LastSixHours = "LastSixHours",
    LastTwentyFourHours = "LastTwentyFourHours",
    LastThreeDays = "LastThreeDays",
    LastSevenDays = "LastSevenDays",
}

export interface EventSupplyMetrics {
    dateTime: string;
    listingCount: number;
    ticketCount: number;
    min: number;
    p25: number;
    p50: number;
    p75: number;
    max: number;
}

export enum EventSupplyMetricsTimePeriod {
    LastDay = "LastDay",
    LastSevenDays = "LastSevenDays",
    LastNinetyDays = "LastNinetyDays",
}

export interface ListingDetails extends Listing {
    purchaseInfos: UiPurchaseInfo[] | null;
    tickets: Ticket[] | null;
    availArtTypes: ArtifactType[] | null;
    saleInfos: SaleDisplayInfo[] | null;
    proofOfPurchaseDocs: UserDocumentLinks[] | null;
    no_Op: MarketplaceListing | null;
}

export interface UiPurchaseInfo {
    purchaseOrderId: number;
    vendorOrderId: string | null;
    purchaseOrderDate: string | null;
    buyerUserId: string | null;
    vendor: UiPurchaseVendorInfo | null;
    vendorAccount: UiVendorAccountInfo | null;
    createdBy: string | null;
    internalNotes: string | null;
}

export interface UiPurchaseVendorInfo {
    vendorId: number;
    vendorName: string;
}

export interface UiVendorAccountInfo {
    vendorAccountId: string;
    vendorId: number;
    vendorAccountName: string | null;
    encryptedEmailAddress: string;
    isAccountCrawlEnabled: boolean;
}

export enum ArtifactType {
    TicketUrl = "TicketUrl",
    ExternalId = "ExternalId",
    ETicket = "ETicket",
    ETicketUrl = "ETicketUrl",
    TransferProof = "TransferProof",
    Barcode = "Barcode",
    QRCode = "QRCode",
}

export interface SaleDisplayInfo {
    id: number;
    idOnMkp: string | null;
    mkp: Marketplace;
    stat: PointOfSaleSaleStatus;
    externalId: string | null;
}

export interface EntitiesWithSummaryOfListing {
    items: Listing[];
    summary: Listing | null;
}

export interface EntitySearchResultOfIDictionaryOfStringAndEntitiesWithSummaryOfListingWithCatalogData {
    entities: { [key: string]: EntitiesWithSummaryOfListingWithCatalogData; };
    pitId: string | null;
    totalItemsCount: number | null;
    maxResultWindow: number | null;
    searchAfter: any[] | null;
    sortedGroupIds: string[] | null;
    sortedItemIds: number[] | null;
}

export interface EntitiesWithSummaryOfListingWithCatalogData {
    items: ListingWithCatalogData[];
    summary: ListingWithCatalogData | null;
}

export interface ListingWithCatalogData extends Listing {
    entityCatalogData: EntityCatalogData | null;
}

export interface SectionalListingsForEventsInput {
    listingQuery: ListingQuery;
    curListings: Listing[] | null;
}

export interface RetailSaleListingTickets {
    listingId: number;
    viagVirtId: string;
    seating: Seating | null;
    sectionType: VenueMapSectionType | null;
    isSeatSaver: boolean;
    availableQuantity: number;
    currency: string;
    topPriTktType: TicketType | null;
    listPrice: number;
    allInPrice: number;
    unitCst: UiMoney | null;
    inHandAt: string | null;
    tickets: Ticket[] | null;
    accId: string | null;
}

export interface ValueTupleOfBooleanAndIListOfTicket {
    item1: boolean;
    item2: Ticket[];
}

export interface DuplicateListingDetails {
    listingId: number;
    lastUpdateDate: string;
    duplicateListingId: number;
    duplicateListingLastUpdateDate: string;
}

export interface ValueTupleOfLongAndListingDetailsUpdateInput {
    item1: number;
    item2: ListingDetailsUpdateInput;
}

export interface MergeListingsInput {
    listingIds: number[];
}

export interface BulkMergeListingsInput {
    listingIdLists: number[][];
    consigneeOwnership: { [key: string]: string; } | null;
}

export interface ListingMergeSuggestion {
    listingIds: number[];
    eventId: number | null;
    eventMappingId: string | null;
    seatFrom: string | null;
    seatTo: string | null;
    accId: string | null;
}

export interface SplitListingInput {
    sourceListingId: number;
    numOfListings: number;
    ticketsByListingNumber: TicketByListingNumber[];
    alwaysUnbroadcastListing: boolean;
    useOriginalTicketGroupInfoForNewListings: boolean;
    retainSeatTraits: boolean;
}

export interface TicketByListingNumber {
    ticket: Ticket;
    listingNumber: number;
}

export interface TicketExternalId {
    ticketId: number;
    externalId: string;
    section: string | null;
    row: string | null;
    seat: string | null;
}

export interface TicketUrl {
    ticketId: number;
    url: string;
    section: string | null;
    row: string | null;
    seat: string | null;
}

export interface ListingPriceHistory {
    unitNetProceeds: UiMoney;
    priceDate: string;
    marketplace: Marketplace | null;
    pricerUserId: string | null;
    applicationName: string | null;
}

export interface ValueTupleOfLongAndNullableInteger {
    item1: number;
    item2: number | null;
}

export interface ListingPriceCalculation extends BaseListingPriceCalculation {
    compListings: CompListing[];
}

export interface ValueTupleOfListingQueryAndListingCsvColumnSelectionConfig {
    item1: ListingQuery;
    item2: ListingCsvColumnSelectionConfig;
}

export interface ListingCsvColumnSelectionConfig {
    hasAutoPricingFeature: boolean | null;
}

export interface PosUiActionResultWithDataOfIEnumerableOfNullableLong extends PosUiActionResult {
    data: (number | null)[] | null;
}

export interface SeatSaverListingDetailsInput {
    event: Event;
    autoBroadcastCreatedListing: boolean;
    sellerOwnTickets: boolean | null;
    seatings: SeatSaverSeating[];
    deliveryType: DeliveryType;
    ticketTypeRules: TicketTypeOverride | null;
    inHandDate: string | null;
    daysBeforeEvent: number | null;
}

export interface SeatSaverSeating {
    section: string;
    sectionId: number | null;
    row: string | null;
    rowId: number | null;
    quantity: number | null;
    maxDisplayQuantity: number | null;
    listingNotes: ListingNote[] | null;
    unitNetProceeds: number | null;
    websitePrice: number | null;
    faceValue: number | null;
}

export interface BatchSwapListingGroupInput {
    listings: SwapListingGroupInput[];
    toListingGroupId: string;
}

export interface SwapListingGroupInput {
    listingId: number;
    listingGroupId: string | null;
    quantity: number;
    adminHoldExpirationDate: string | null;
}

export interface ReorderListingInGroupInput {
    listingGroupId: string;
    listingId: number;
    fromPosition: number;
    toPosition: number;
}

export interface ListingDetailsBroadcastSectionUpdates {
    id: number;
    rowVersion: number | null;
    adminHoldNotes: string | null;
    marketplaceSeatOverrides: ListingMarketplaceSeatingOverride[];
    enableNativeSync: boolean | null;
}

export interface ListingDetailsTicketSectionUpdates {
    id: number;
    rowVersion: number | null;
    splitType: SplitType | null;
    hideSeatsFromMarketplace: boolean | null;
    faceValue: number | null;
    inHandDate: string | null;
    daysBeforeEvent: number | null;
    section: string | null;
    sectionId: number | null;
    row: string | null;
    rowId: number | null;
    internalNotes: string | null;
    ticketTypeRules: TicketTypeOverride | null;
    manualMaxDisplayQuantity: number | null;
    isNoFulfill: boolean | null;
    seatTraits: ListingNote[] | null;
    delivType: DeliveryType | null;
    updateSalesOfListings: boolean | null;
    updatePredeliveryETicketArtifacts: boolean | null;
}

export interface ListingPricingSectionPosFieldUpdates {
    unitNetProceeds: PosFieldOfNullableDecimal | null;
    autoPricingEnabled: PosFieldOfNullableBoolean | null;
    netProceedsFloor: PosFieldOfNullableDecimal | null;
    netProceedsCeiling: PosFieldOfNullableDecimal | null;
    pricerSellerUserId: PosFieldOfNullableGuid | null;
}

export interface ListingDetailsPricingSectionUpdates {
    id: number;
    rowVersion: number | null;
    pricerSellerUserId: string | null;
    listPrice: number | null;
    allInPrice: number | null;
    netProceedsFloor: number | null;
    netProceedsCeiling: number | null;
    autoPricingEnabled: boolean | null;
    buyerUserId: string | null;
    marketplacePriceUpdates: ListingMarketplacePriceUpdateInput[];
    currencyCode: string | null;
}

export interface ListingDetailsAutoPricingSectionUpdates extends AutoPricingInputs {
    id: number;
    rowVersion: number | null;
    netProceedsFloor: number | null;
    netProceedsCeiling: number | null;
    skipAutoPricing: boolean | null;
    autoPricingEnabled: boolean | null;
    skipUndercut: boolean | null;
    skipCompListing: boolean | null;
    skipAdvancePricing: boolean | null;
    velocityCircuitBreakerStateRowVersion: number | null;
    currencyCode: string | null;
    previewMarketPrices: { [key: string]: number; } | null;
    sectionRowScoreRecommendations: SectionRowScoreRecommendations | null;
}

export interface SectionRowScoreRecommendations {
    eventId: number;
    venueConfigId: number;
    modelVersionId: number;
    recommendedSelectedSectionSettings: SelectedSectionSettings;
}

export interface ListingDetailsTagsSectionUpdates {
    id: number;
    rowVersion: number | null;
    tags: Tag[] | null;
}

export interface ListingStatusInfo {
    entityType: ActionOutboxEntityType;
    id: number;
    accId: string | null;
    status: ListingStatus;
    brdcstStatus: ListingBroadcastStatus | null;
    mkp: Marketplace | null;
    idOnMkp: string | null;
    pendProofState: PendingProofState | null;
    mkpListings: MarketplaceListingStatusInfo[];
}

export interface MarketplaceListingStatusInfo {
    mkpListingId: string | null;
    mkp: Marketplace;
    status: ListingStatus;
}

export interface PosUiActionResultWithDataOfLong extends PosUiActionResult {
    data: number;
}

export interface ChangeListingOfficeInput {
    listingId: number;
    officeId: number;
}

export interface ListingExperiment {
    viagogoEventId: number;
    listingGroupId: string | null;
    listingGroupName: string | null;
    targetPercentage: number | null;
    discountPercentage: number | null;
    startDate: string;
    endDate: string;
    insertBy: string;
}

export interface ListingGroup extends Listing {
    groupType: GroupType;
    groupName: string;
    deliveryTypes: ValueTupleOfDeliveryTypeAndNullableTicketType[];
    groupItems: IListingGroupItem[];
    desiredActiveListings: number | null;
    minActiveListings: number | null;
    maxActiveListings: number | null;
    targetPercentage: number | null;
    desiredAvailableQuantity: number | null;
    deprioritizedQuantities: string[] | null;
    marketplaceSettings: ListingGroupListingMarketplaceSettings | null;
    absoluteRankPremium: number | null;
    relativeRankPremium: number | null;
    isLockedFromEdits: boolean | null;
    isPrcStaggerOn: boolean | null;
}

export enum GroupType {
    Invisible = "Invisible",
    FullySold = "FullySold",
    Inactive = "Inactive",
    Active = "Active",
    Leader = "Leader",
}

export interface ValueTupleOfDeliveryTypeAndNullableTicketType {
    item1: DeliveryType;
    item2: TicketType | null;
}

export interface IListingGroupItem {
    ltGrpId: string | null;
    isLtGrp: boolean;
    isFull: boolean;
    id: number;
    insertBy: string | null;
    rowVer: number;
    ltGrpParentId: number | null;
    ltGrpPrior: number | null;
    seating: Seating;
    delivType: DeliveryType;
    topPriTktType: TicketType | null;
    availQty: number;
    wastedQty: number | null;
    ticketCnt: number;
    maxDispQty: number;
    manMaxDispQty: number | null;
    ltGrpActive: boolean | null;
    unitCst: UiMoney | null;
    faceValue: UiMoney | null;
    currency: string;
    isDeleted: boolean;
    ltGrpUndercut: ListingGroupUndercutSetting | null;
    brdcstStatus: ListingBroadcastStatus | null;
    officeId: number | null;
}

export interface PosUiActionResultWithDataOfAutoCompListingsPreview extends PosUiActionResult {
    data: AutoCompListingsPreview | null;
}

export interface AutoCompListingsPreview {
    zoneSectionAreaGroupLookup: ZoneSectionAreaGroupLookup;
}

export interface ZoneSectionAreaGroupLookup {
    zoneSectionAreaRankOverrides: ZoneSectionAreaRankOverride[];
    groupIdToSectionIdMap: { [key: string]: ZoneSectionArea[]; };
    groupIdToMedianSeatScoreMap: { [key: string]: number; };
    sectionIdToGroupIdMap: { [key: string]: string; };
    zoneNameToRankMap: { [key: string]: { [key: string]: number; }; };
    customSectionGroups: string[];
}

export interface ZoneSectionAreaRankOverride {
    zoneAreaName: string;
    rank: number;
    color: string;
}

export interface ZoneSectionArea {
    sectId: number;
    rank: number;
    zoneAreaName: string;
    ticketClassId: number;
    ticketClassName: string;
}

export interface AutoCompSettingsPreviewInput {
    viagogoEventId: number;
    venueZoneConfigType: VenueZoneConfigType;
    combineCornersAndEnds: boolean;
}

export interface PosUiActionResultWithDataOfAutoGroupListingsPreview extends PosUiActionResult {
    data: AutoGroupListingsPreview | null;
}

export interface AutoGroupListingsPreview {
    listingGroups: { [key: string]: AutoGroupListingsPreviewListingUpdate[]; };
}

export interface AutoGroupListingsPreviewListingUpdate {
    listingId: number;
    selectedSectionSettings: SelectedSectionSettings | null;
    onlyForSelectedSectionsEnabled: boolean | null;
    compListingMode: AutoPricingCompListingMode | null;
    compListingFloor: number | null;
    compListingCeiling: number | null;
    autoPricingEnabled: boolean | null;
    circuitBreakerMinCompListingCount: number | null;
    excludeFanInventory: boolean | null;
    area: RowArea;
    filteredAreas: RowArea[];
}

export interface RowArea extends RowInfo {
    sectId: number;
    normOrd: number;
    area: ConfigArea;
    sectName: string;
}

export interface ConfigArea {
    areaName: string;
    rank: number;
}

export interface AutoGroupListingsPreviewInput {
    viagogoEventId: number;
    eventListingIds: number[];
    zoneSectionAreaGroupLookupJson: string;
    rowCompOffset: number;
    rowGroupSetting: RowGroupSetting;
    venueZoneConfigType: VenueZoneConfigType;
    combineCornersAndEnds: boolean;
    rowCompOverrides: RowCompOverride[];
    useCustomRank: boolean;
}

export enum RowGroupSetting {
    SingleTwoToFiveSixPlus = "SingleTwoToFiveSixPlus",
    OneToFiveSixPlus = "OneToFiveSixPlus",
    OneToTenElevenPlus = "OneToTenElevenPlus",
    AllRows = "AllRows",
    OneTwoToFiveSixToTwelveThirteenPlus = "OneTwoToFiveSixToTwelveThirteenPlus",
}

export interface RowCompOverride {
    rowOrdinalFrom: number;
    rowOrdinalTo: number;
    offsetOverride: number;
}

export interface PosUiActionResultWithDataOfIEnumerableOfMergeListingGroupInput extends PosUiActionResult {
    data: (MergeListingGroupInput | null)[] | null;
}

export interface ListingGroupCompData {
    totalCompListingCount: number;
    compListings: CompListing[];
}

export interface ListingAggregationResponse {
    summary: ListingAggregationSummary;
    byOriginalCurrency: CurrencyBreakdown[] | null;
    metadata: AggregationResponseMetadata;
}

export interface ListingAggregationSummary {
    totalTickets: number;
    totalAvailableTickets: number;
    totalSoldTickets: number;
    totalWastedTickets: number;
    totalMaxDisplayQuantity: number;
    totalManualMaxDisplayQuantity: number;
    totalShownQuantity: number;
    totalCost: UiMoney | null;
    totalFaceValue: UiMoney | null;
    totalSoldCost: UiMoney | null;
    totalUnsoldCost: UiMoney | null;
    totalWastedCost: UiMoney | null;
    totalListPrice: UiMoney | null;
    totalAllInPrice: UiMoney | null;
    aggregatedUnitCost: UiMoney | null;
    aggregatedFaceValue: UiMoney | null;
    averageListPrice: number;
    averageAllInPrice: number;
    currency: string;
    listingCount: number;
}

export interface CurrencyBreakdown {
    currency: string;
    documentCount: number;
    summary: ListingAggregationSummary;
}

export interface AggregationResponseMetadata {
    totalDocuments: number;
    currencyCount: number;
    targetCurrency: string;
    computedAt: string;
    openSearchTookMs: number;
    processingTookMs: number;
}

export interface MultiCurrencyAggregationRequestOfListingSearchRequestV2AndListingFilterQueryV2 {
    request: ListingSearchRequestV2;
    targetCurrency: string;
    includeCurrencyBreakdown: boolean;
}

export interface OpenSearchRequestOfListingFilterQueryV2 {
    filter: ListingFilterQueryV2;
    options: SearchOptions | null;
    allowedFields: string[] | null;
    appliedSecurityFilters: string[] | null;
    dataIsolationContext: { [key: string]: any; } | null;
}

export interface ListingSearchRequestV2 extends OpenSearchRequestOfListingFilterQueryV2 {
}

export interface ListingFilterQueryV2 {
    eventIds: FieldFilter | null;
    eventDates: FieldFilter | null;
    eventTimeFrameFilters: FieldFilter | null;
    clientTimezoneOffsetMins: number | null;
    eventStatuses: FieldFilter | null;
    topLevelCategories: FieldFilter | null;
    parentCategories: FieldFilter | null;
    eventOrMappingIds: FieldFilter | null;
    oldPosEventIds: FieldFilter | null;
    performerIds: FieldFilter | null;
    venueIds: FieldFilter | null;
    countryCodes: FieldFilter | null;
    stateProvinceIds: FieldFilter | null;
    cityIds: FieldFilter | null;
    eventNotReviewedSince: FieldFilter | null;
    lastSaleDates: FieldFilter | null;
    numberOfAvailableTickets: FieldFilter | null;
    eventHasUnsoldTickets: FieldFilter | null;
    hasUnpricedListings: FieldFilter | null;
    isListed: FieldFilter | null;
    hasBroadcastError: FieldFilter | null;
    isDuplicate: FieldFilter | null;
    hasListingGroupId: FieldFilter | null;
    isAdminHold: FieldFilter | null;
    isPendingProof: FieldFilter | null;
    listingIds: FieldFilter | null;
    lastPriceUpdateDates: FieldFilter | null;
    lastUpdateDates: FieldFilter | null;
    listingInsertByIds: FieldFilter | null;
    sellerAccountIds: FieldFilter | null;
    pricedByIds: FieldFilter | null;
    isAutoPricingEnabled: FieldFilter | null;
    autoPricingResultState: FieldFilter | null;
    isPriced: FieldFilter | null;
    isPricedByMarketplace: FieldFilter | null;
    currencyCodes: FieldFilter | null;
    preDeliveryStateIds: FieldFilter | null;
    deliveryTypes: FieldFilter | null;
    inHandDates: FieldFilter | null;
    ticketTypes: FieldFilter | null;
    isNoFulfill: FieldFilter | null;
    hasUnsoldTickets: FieldFilter | null;
    section: FieldFilter | null;
    row: FieldFilter | null;
    splitTypes: FieldFilter | null;
    isEventMappingRejected: FieldFilter | null;
    isEventMapped: FieldFilter | null;
    isSeatingUnmapped: FieldFilter | null;
    internalNotes: FieldFilter | null;
    tagPairs: TagPairFilter | null;
    eventTagPairs: TagPairFilter | null;
    purchaseOrderTagPairs: TagPairFilter | null;
    purchaseOrdersFilter: PurchaseOrderNestedFilter | null;
    unitCosts: FieldFilter | null;
    prices: FieldFilter | null;
    priceFilterIsConverted: boolean;
    quantity: FieldFilter | null;
    quantitySold: FieldFilter | null;
    quantityWasted: FieldFilter | null;
    isUndeliverable: FieldFilter | null;
    isSeatSaver: FieldFilter | null;
    and: ListingFilterQueryV2[] | null;
    or: ListingFilterQueryV2[] | null;
    orConditions: ListingFilterQueryV2[] | null;
    not: boolean | null;
    orListingInsertByUserId: string | null;
    orPricerSellerUserId: string | null;
    orPricerSellerUserIds: string[] | null;
    orPurchaseBuyerId: string | null;
    orPurchaseBuyerIds: string[] | null;
    dataIsolationContext: { [key: string]: any; } | null;
    allowedFields: string[] | null;
    appliedSecurityFilters: string[] | null;
}

export interface FieldFilter {
    operation: FilterOperationType;
    value: any | null;
    values: any[] | null;
    start: any | null;
    end: any | null;
    min: any | null;
    max: any | null;
}

export interface TagPairFilter {
    operation: TagPairOperation;
    pairs: TagPair[];
}

export enum TagPairOperation {
    AnyOf = "AnyOf",
    AllOf = "AllOf",
    Contains = "Contains",
    Equals = "Equals",
    NotExists = "NotExists",
    NotEquals = "NotEquals",
    NotContains = "NotContains",
    NoTags = "NoTags",
}

export interface TagPair {
    name: string;
    value: string | null;
    operation: TagPairOperation | null;
}

export interface PurchaseOrderNestedFilter {
    purchaseOrderIds: FieldFilter | null;
    purchaseOrderDates: FieldFilter | null;
    purchaseOrderVendorOrderIds: FieldFilter | null;
    purchaseOrderVendorAccountIds: FieldFilter | null;
    purchaseOrderVendorIds: FieldFilter | null;
    buyerUserIds: FieldFilter | null;
    purchaseOrderInsertByUserIds: FieldFilter | null;
    encryptedEmailAddresses: FieldFilter | null;
    purchaseOrderVendorAccountNames: FieldFilter | null;
    purchaseOrderVendorNames: FieldFilter | null;
}

export interface SearchOptions {
    size: number | null;
    from: number | null;
    sort: SortCriteria[] | null;
    aggregations: AggregationDictionary | null;
    timeoutMs: number | null;
    includeAggregations: boolean;
    allowedFields: string[] | null;
    pitId: string | null;
    searchAfter: any[] | null;
    keepAlive: string | null;
    pitPaginationDisabled: boolean;
    usesPitPagination: boolean;
    terminateAfter: number | null;
    trackTotalHits: boolean | null;
    bypassMaxPageSize: boolean;
}

export interface SortCriteria {
    field: string | null;
    order: string | null;
    userNames: { [key: string]: string; } | null;
}

export interface IsADictionaryBaseOfStringAndIAggregationContainer {
    Item: IAggregationContainer | null;
    BackingDictionary: { [key: string]: IAggregationContainer; } | null;
}

export interface AggregationDictionary extends IsADictionaryBaseOfStringAndIAggregationContainer {
}

export interface IAggregationContainer {
    adjacencyMatrix: IAdjacencyMatrixAggregation | null;
    aggregations: AggregationDictionary | null;
    average: IAverageAggregation | null;
    averageBucket: IAverageBucketAggregation | null;
    bucketScript: IBucketScriptAggregation | null;
    bucketSelector: IBucketSelectorAggregation | null;
    bucketSort: IBucketSortAggregation | null;
    cardinality: ICardinalityAggregation | null;
    children: IChildrenAggregation | null;
    composite: ICompositeAggregation | null;
    cumulativeSum: ICumulativeSumAggregation | null;
    dateHistogram: IDateHistogramAggregation | null;
    autoDateHistogram: IAutoDateHistogramAggregation | null;
    dateRange: IDateRangeAggregation | null;
    derivative: IDerivativeAggregation | null;
    diversifiedSampler: IDiversifiedSamplerAggregation | null;
    extendedStats: IExtendedStatsAggregation | null;
    extendedStatsBucket: IExtendedStatsBucketAggregation | null;
    filter: IFilterAggregation | null;
    filters: IFiltersAggregation | null;
    geoBounds: IGeoBoundsAggregation | null;
    geoCentroid: IGeoCentroidAggregation | null;
    geoDistance: IGeoDistanceAggregation | null;
    geoHash: IGeoHashGridAggregation | null;
    geoLine: IGeoLineAggregation | null;
    geoTile: IGeoTileGridAggregation | null;
    global: IGlobalAggregation | null;
    histogram: IHistogramAggregation | null;
    ipRange: IIpRangeAggregation | null;
    matrixStats: IMatrixStatsAggregation | null;
    max: IMaxAggregation | null;
    maxBucket: IMaxBucketAggregation | null;
    meta: { [key: string]: any; } | null;
    min: IMinAggregation | null;
    minBucket: IMinBucketAggregation | null;
    missing: IMissingAggregation | null;
    movingAverage: IMovingAverageAggregation | null;
    movingFunction: IMovingFunctionAggregation | null;
    nested: INestedAggregation | null;
    parent: IParentAggregation | null;
    percentileRanks: IPercentileRanksAggregation | null;
    percentiles: IPercentilesAggregation | null;
    percentilesBucket: IPercentilesBucketAggregation | null;
    range: IRangeAggregation | null;
    rareTerms: IRareTermsAggregation | null;
    reverseNested: IReverseNestedAggregation | null;
    sampler: ISamplerAggregation | null;
    scriptedMetric: IScriptedMetricAggregation | null;
    serialDifferencing: ISerialDifferencingAggregation | null;
    significantTerms: ISignificantTermsAggregation | null;
    significantText: ISignificantTextAggregation | null;
    stats: IStatsAggregation | null;
    statsBucket: IStatsBucketAggregation | null;
    sum: ISumAggregation | null;
    sumBucket: ISumBucketAggregation | null;
    terms: ITermsAggregation | null;
    topHits: ITopHitsAggregation | null;
    valueCount: IValueCountAggregation | null;
    weightedAverage: IWeightedAverageAggregation | null;
    medianAbsoluteDeviation: IMedianAbsoluteDeviationAggregation | null;
    multiTerms: IMultiTermsAggregation | null;
    variableWidthHistogram: IVariableWidthHistogramAggregation | null;
}

export interface IAdjacencyMatrixAggregation {
    filters: INamedFiltersContainer | null;
}

export interface INamedFiltersContainer {
}

export interface IAverageAggregation {
}

export interface IAverageBucketAggregation {
}

export interface IBucketScriptAggregation {
    script: IScript | null;
}

export interface IScript {
    lang: string | null;
    params: { [key: string]: any; } | null;
}

export interface IBucketSelectorAggregation {
    script: IScript | null;
}

export interface IBucketSortAggregation {
    from: number | null;
    gapPolicy: GapPolicy | null;
    size: number | null;
    sort: ISort[] | null;
}

export enum GapPolicy {
    Skip = "skip",
    InsertZeros = "insert_zeros",
}

export interface ISort {
    missing: any | null;
    mode: SortMode | null;
    numericType: NumericType | null;
    nested: INestedSort | null;
    order: SortOrder | null;
}

export enum SortMode {
    Min = "min",
    Max = "max",
    Sum = "sum",
    Average = "avg",
    Median = "median",
}

export enum NumericType {
    Long = "long",
    Double = "double",
    Date = "date",
    DateNanos = "date_nanos",
}

export interface INestedSort {
    filter: QueryContainer | null;
    nested: INestedSort | null;
    path: Field | null;
    maxChildren: number | null;
}

export interface QueryContainer {
}

export interface Field {
    boost: number | null;
    format: string | null;
    cachableExpression: boolean;
    expression: Expression | null;
    name: string | null;
    property: PropertyInfo | null;
}

export interface Expression {
    nodeType: ExpressionType;
    type: string;
    canReduce: boolean;
}

export enum ExpressionType {
    Add = "Add",
    AddChecked = "AddChecked",
    And = "And",
    AndAlso = "AndAlso",
    ArrayLength = "ArrayLength",
    ArrayIndex = "ArrayIndex",
    Call = "Call",
    Coalesce = "Coalesce",
    Conditional = "Conditional",
    Constant = "Constant",
    Convert = "Convert",
    ConvertChecked = "ConvertChecked",
    Divide = "Divide",
    Equal = "Equal",
    ExclusiveOr = "ExclusiveOr",
    GreaterThan = "GreaterThan",
    GreaterThanOrEqual = "GreaterThanOrEqual",
    Invoke = "Invoke",
    Lambda = "Lambda",
    LeftShift = "LeftShift",
    LessThan = "LessThan",
    LessThanOrEqual = "LessThanOrEqual",
    ListInit = "ListInit",
    MemberAccess = "MemberAccess",
    MemberInit = "MemberInit",
    Modulo = "Modulo",
    Multiply = "Multiply",
    MultiplyChecked = "MultiplyChecked",
    Negate = "Negate",
    UnaryPlus = "UnaryPlus",
    NegateChecked = "NegateChecked",
    New = "New",
    NewArrayInit = "NewArrayInit",
    NewArrayBounds = "NewArrayBounds",
    Not = "Not",
    NotEqual = "NotEqual",
    Or = "Or",
    OrElse = "OrElse",
    Parameter = "Parameter",
    Power = "Power",
    Quote = "Quote",
    RightShift = "RightShift",
    Subtract = "Subtract",
    SubtractChecked = "SubtractChecked",
    TypeAs = "TypeAs",
    TypeIs = "TypeIs",
    Assign = "Assign",
    Block = "Block",
    DebugInfo = "DebugInfo",
    Decrement = "Decrement",
    Dynamic = "Dynamic",
    Default = "Default",
    Extension = "Extension",
    Goto = "Goto",
    Increment = "Increment",
    Index = "Index",
    Label = "Label",
    RuntimeVariables = "RuntimeVariables",
    Loop = "Loop",
    Switch = "Switch",
    Throw = "Throw",
    Try = "Try",
    Unbox = "Unbox",
    AddAssign = "AddAssign",
    AndAssign = "AndAssign",
    DivideAssign = "DivideAssign",
    ExclusiveOrAssign = "ExclusiveOrAssign",
    LeftShiftAssign = "LeftShiftAssign",
    ModuloAssign = "ModuloAssign",
    MultiplyAssign = "MultiplyAssign",
    OrAssign = "OrAssign",
    PowerAssign = "PowerAssign",
    RightShiftAssign = "RightShiftAssign",
    SubtractAssign = "SubtractAssign",
    AddAssignChecked = "AddAssignChecked",
    MultiplyAssignChecked = "MultiplyAssignChecked",
    SubtractAssignChecked = "SubtractAssignChecked",
    PreIncrementAssign = "PreIncrementAssign",
    PreDecrementAssign = "PreDecrementAssign",
    PostIncrementAssign = "PostIncrementAssign",
    PostDecrementAssign = "PostDecrementAssign",
    TypeEqual = "TypeEqual",
    OnesComplement = "OnesComplement",
    IsTrue = "IsTrue",
    IsFalse = "IsFalse",
}

export interface MemberInfo {
    module: Module;
    customAttributes: CustomAttributeData[];
    isCollectible: boolean;
    metadataToken: number;
}

export interface PropertyInfo extends MemberInfo {
    memberType: MemberTypes;
    isSpecialName: boolean;
    getMethod: MethodInfo | null;
    setMethod: MethodInfo | null;
}

export enum MemberTypes {
    Constructor = "Constructor",
    Event = "Event",
    Field = "Field",
    Method = "Method",
    Property = "Property",
    TypeInfo = "TypeInfo",
    Custom = "Custom",
    NestedType = "NestedType",
    All = "All",
}

export interface MethodBase extends MemberInfo {
    methodImplementationFlags: MethodImplAttributes;
    callingConvention: CallingConventions;
    isAbstract: boolean;
    isConstructor: boolean;
    isFinal: boolean;
    isHideBySig: boolean;
    isSpecialName: boolean;
    isStatic: boolean;
    isVirtual: boolean;
    isAssembly: boolean;
    isFamily: boolean;
    isFamilyAndAssembly: boolean;
    isFamilyOrAssembly: boolean;
    isPrivate: boolean;
    isPublic: boolean;
    isConstructedGenericMethod: boolean;
    isGenericMethod: boolean;
    isGenericMethodDefinition: boolean;
    containsGenericParameters: boolean;
    isSecurityCritical: boolean;
    isSecuritySafeCritical: boolean;
    isSecurityTransparent: boolean;
}

export interface MethodInfo extends MethodBase {
    memberType: MemberTypes;
    returnParameter: ParameterInfo;
    returnType: string;
}

export interface ParameterInfo {
    attributes: ParameterAttributes;
    member: MemberInfo;
    name: string | null;
    parameterType: string;
    position: number;
    isIn: boolean;
    isLcid: boolean;
    isOptional: boolean;
    isOut: boolean;
    isRetval: boolean;
    defaultValue: any | null;
    rawDefaultValue: any | null;
    hasDefaultValue: boolean;
    customAttributes: CustomAttributeData[];
    metadataToken: number;
}

export enum ParameterAttributes {
    None = "None",
    In = "In",
    Out = "Out",
    Lcid = "Lcid",
    Retval = "Retval",
    Optional = "Optional",
    HasDefault = "HasDefault",
    HasFieldMarshal = "HasFieldMarshal",
    Reserved3 = "Reserved3",
    Reserved4 = "Reserved4",
    ReservedMask = "ReservedMask",
}

export interface Module {
    assembly: Assembly;
    fullyQualifiedName: string;
    name: string;
    mdStreamVersion: number;
    moduleVersionId: string;
    scopeName: string;
    moduleHandle: ModuleHandle;
    customAttributes: CustomAttributeData[];
    metadataToken: number;
}

export interface Assembly {
    definedTypes: string[];
    exportedTypes: string[];
    codeBase: string | null;
    entryPoint: MethodInfo | null;
    fullName: string | null;
    imageRuntimeVersion: string;
    isDynamic: boolean;
    location: string;
    reflectionOnly: boolean;
    isCollectible: boolean;
    isFullyTrusted: boolean;
    customAttributes: CustomAttributeData[];
    escapedCodeBase: string;
    manifestModule: Module;
    modules: Module[];
    globalAssemblyCache: boolean;
    hostContext: number;
    securityRuleSet: SecurityRuleSet;
}

export interface CustomAttributeData {
    attributeType: string;
    constructor: ConstructorInfo;
    constructorArguments: CustomAttributeTypedArgument[];
    namedArguments: CustomAttributeNamedArgument[];
}

export interface ConstructorInfo extends MethodBase {
    memberType: MemberTypes;
}

export enum MethodImplAttributes {
    IL = "Managed",
    Managed = "Managed",
    Native = "Native",
    OPTIL = "OPTIL",
    CodeTypeMask = "Runtime",
    Runtime = "Runtime",
    ManagedMask = "ManagedMask",
    Unmanaged = "ManagedMask",
    NoInlining = "NoInlining",
    ForwardRef = "ForwardRef",
    Synchronized = "Synchronized",
    NoOptimization = "NoOptimization",
    PreserveSig = "PreserveSig",
    AggressiveInlining = "AggressiveInlining",
    AggressiveOptimization = "AggressiveOptimization",
    InternalCall = "InternalCall",
    MaxMethodImplVal = "MaxMethodImplVal",
}

export enum CallingConventions {
    Standard = "Standard",
    VarArgs = "VarArgs",
    Any = "Any",
    HasThis = "HasThis",
    ExplicitThis = "ExplicitThis",
}

export interface CustomAttributeTypedArgument {
    argumentType: string;
    value: any | null;
}

export interface CustomAttributeNamedArgument {
    memberInfo: MemberInfo;
    typedValue: CustomAttributeTypedArgument;
    memberName: string;
    isField: boolean;
}

export enum SecurityRuleSet {
    None = "None",
    Level1 = "Level1",
    Level2 = "Level2",
}

export interface ModuleHandle {
    mdStreamVersion: number;
}

export enum SortOrder {
    Ascending = "asc",
    Descending = "desc",
}

export interface ICardinalityAggregation {
    precisionThreshold: number | null;
    rehash: boolean | null;
}

export interface IChildrenAggregation {
    type: RelationName | null;
}

export interface RelationName {
    name: string | null;
    type: string | null;
}

export interface ICompositeAggregation {
    after: CompositeKey | null;
    size: number | null;
    sources: ICompositeAggregationSource[] | null;
}

export interface IsAReadOnlyDictionaryBaseOfStringAndObject {
    Count: number;
    Item: any | null;
    Keys: string[] | null;
    Values: any[] | null;
    BackingDictionary: { [key: string]: any; } | null;
}

export interface CompositeKey extends IsAReadOnlyDictionaryBaseOfStringAndObject {
}

export interface ICompositeAggregationSource {
    field: Field | null;
    missingBucket: boolean | null;
    order: SortOrder | null;
}

export interface ICumulativeSumAggregation {
}

export interface IDateHistogramAggregation {
    extendedBounds: ExtendedBoundsOfDateMath | null;
    hardBounds: HardBoundsOfDateMath | null;
    field: Field | null;
    format: string | null;
    calendarInterval: UnionOfNullableDateIntervalAndDateMathTime | null;
    fixedInterval: Time | null;
    minimumDocumentCount: number | null;
    missing: string | null;
    offset: string | null;
    order: HistogramOrder | null;
    script: IScript | null;
    timeZone: string | null;
}

export interface ExtendedBoundsOfDateMath {
    maximum: DateMath | null;
    minimum: DateMath | null;
}

export interface DateMath {
}

export interface HardBoundsOfDateMath {
    maximum: DateMath | null;
    minimum: DateMath | null;
}

export interface UnionOfNullableDateIntervalAndDateMathTime {
}

export interface Time {
    factor: number | null;
    interval: TimeUnit | null;
    milliseconds: number | null;
}

export enum TimeUnit {
    Nanoseconds = "nanos",
    Microseconds = "micros",
    Millisecond = "ms",
    Second = "s",
    Minute = "m",
    Hour = "h",
    Day = "d",
}

export interface HistogramOrder {
    key: string | null;
    order: SortOrder;
}

export interface IAutoDateHistogramAggregation {
    field: Field | null;
    buckets: number | null;
    format: string | null;
    missing: string | null;
    offset: string | null;
    params: { [key: string]: any; } | null;
    script: IScript | null;
    timeZone: string | null;
    minimumInterval: MinimumInterval | null;
}

export enum MinimumInterval {
    Second = "second",
    Minute = "minute",
    Hour = "hour",
    Day = "day",
    Month = "month",
    Year = "year",
}

export interface IDateRangeAggregation {
    field: Field | null;
    format: string | null;
    missing: any | null;
    ranges: IDateRangeExpression[] | null;
    timeZone: string | null;
}

export interface IDateRangeExpression {
    from: DateMath | null;
    key: string | null;
    to: DateMath | null;
}

export interface IDerivativeAggregation {
}

export interface IDiversifiedSamplerAggregation {
    executionHint: DiversifiedSamplerAggregationExecutionHint | null;
    field: Field | null;
    maxDocsPerValue: number | null;
    script: IScript | null;
    shardSize: number | null;
}

export enum DiversifiedSamplerAggregationExecutionHint {
    Map = "map",
    GlobalOrdinals = "global_ordinals",
    BytesHash = "bytes_hash",
}

export interface IExtendedStatsAggregation {
    sigma: number | null;
}

export interface IExtendedStatsBucketAggregation {
    sigma: number | null;
}

export interface IFilterAggregation {
    filter: QueryContainer | null;
}

export interface IFiltersAggregation {
    filters: UnionOfINamedFiltersContainerAndIEnumerableOfQueryContainer | null;
    otherBucket: boolean | null;
    otherBucketKey: string | null;
}

export interface UnionOfINamedFiltersContainerAndIEnumerableOfQueryContainer {
}

export interface IGeoBoundsAggregation {
    wrapLongitude: boolean | null;
}

export interface IGeoCentroidAggregation {
}

export interface IGeoDistanceAggregation {
    distanceType: GeoDistanceType | null;
    field: Field | null;
    origin: GeoLocation | null;
    ranges: IAggregationRange[] | null;
    unit: DistanceUnit | null;
}

export enum GeoDistanceType {
    Arc = "arc",
    Plane = "plane",
}

export interface GeoLocation {
    latitude: number;
    longitude: number;
}

export interface IAggregationRange {
    from: number | null;
    key: string | null;
    to: number | null;
}

export enum DistanceUnit {
    Inch = "in",
    Feet = "ft",
    Yards = "yd",
    Miles = "mi",
    NauticalMiles = "nmi",
    Kilometers = "km",
    Meters = "m",
    Centimeters = "cm",
    Millimeters = "mm",
}

export interface IGeoHashGridAggregation {
    field: Field | null;
    precision: GeoHashPrecision | null;
    shardSize: number | null;
    size: number | null;
    bounds: IBoundingBox | null;
}

export enum GeoHashPrecision {
    Precision1 = "Precision1",
    Precision2 = "Precision2",
    Precision3 = "Precision3",
    Precision4 = "Precision4",
    Precision5 = "Precision5",
    Precision6 = "Precision6",
    Precision7 = "Precision7",
    Precision8 = "Precision8",
    Precision9 = "Precision9",
    Precision10 = "Precision10",
    Precision11 = "Precision11",
    Precision12 = "Precision12",
}

export interface IBoundingBox {
    bottomRight: GeoLocation | null;
    topLeft: GeoLocation | null;
    wellKnownText: string | null;
}

export interface IGeoLineAggregation {
    point: GeoLinePoint | null;
    sort: GeoLineSort | null;
    includeSort: boolean | null;
    sortOrder: string | null;
    size: number | null;
}

export interface GeoLinePoint {
    field: Field | null;
}

export interface GeoLineSort {
    field: Field | null;
}

export interface IGeoTileGridAggregation {
    field: Field | null;
    precision: GeoTilePrecision | null;
    shardSize: number | null;
    size: number | null;
}

export enum GeoTilePrecision {
    Precision0 = "Precision0",
    Precision1 = "Precision1",
    Precision2 = "Precision2",
    Precision3 = "Precision3",
    Precision4 = "Precision4",
    Precision5 = "Precision5",
    Precision6 = "Precision6",
    Precision7 = "Precision7",
    Precision8 = "Precision8",
    Precision9 = "Precision9",
    Precision10 = "Precision10",
    Precision11 = "Precision11",
    Precision12 = "Precision12",
    Precision13 = "Precision13",
    Precision14 = "Precision14",
    Precision15 = "Precision15",
    Precision16 = "Precision16",
    Precision17 = "Precision17",
    Precision18 = "Precision18",
    Precision19 = "Precision19",
    Precision20 = "Precision20",
    Precision21 = "Precision21",
    Precision22 = "Precision22",
    Precision23 = "Precision23",
    Precision24 = "Precision24",
    Precision25 = "Precision25",
    Precision26 = "Precision26",
    Precision27 = "Precision27",
    Precision28 = "Precision28",
    Precision29 = "Precision29",
}

export interface IGlobalAggregation {
}

export interface IHistogramAggregation {
    extendedBounds: ExtendedBoundsOfDouble | null;
    hardBounds: HardBoundsOfDouble | null;
    field: Field | null;
    interval: number | null;
    minimumDocumentCount: number | null;
    missing: number | null;
    offset: number | null;
    order: HistogramOrder | null;
    script: IScript | null;
}

export interface ExtendedBoundsOfDouble {
    maximum: number;
    minimum: number;
}

export interface HardBoundsOfDouble {
    maximum: number;
    minimum: number;
}

export interface IIpRangeAggregation {
    field: Field | null;
    ranges: IIpRangeAggregationRange[] | null;
}

export interface IIpRangeAggregationRange {
    from: string | null;
    mask: string | null;
    to: string | null;
}

export interface IMatrixStatsAggregation {
    mode: MatrixStatsMode | null;
}

export enum MatrixStatsMode {
    Avg = "avg",
    Min = "min",
    Max = "max",
    Sum = "sum",
    Median = "median",
}

export interface IMaxAggregation {
}

export interface IMaxBucketAggregation {
}

export interface IMinAggregation {
}

export interface IMinBucketAggregation {
}

export interface IMissingAggregation {
    field: Field | null;
}

export interface IMovingAverageAggregation {
    minimize: boolean | null;
    model: IMovingAverageModel | null;
    predict: number | null;
    window: number | null;
}

export interface IMovingAverageModel {
}

export interface IMovingFunctionAggregation {
    script: string | null;
    window: number | null;
    shift: number | null;
}

export interface INestedAggregation {
    path: Field | null;
}

export interface IParentAggregation {
    type: RelationName | null;
}

export interface IPercentileRanksAggregation {
    method: IPercentilesMethod | null;
    values: number[] | null;
    keyed: boolean | null;
}

export interface IPercentilesMethod {
}

export interface IPercentilesAggregation {
    method: IPercentilesMethod | null;
    percents: number[] | null;
    keyed: boolean | null;
}

export interface IPercentilesBucketAggregation {
    percents: number[] | null;
}

export interface IRangeAggregation {
    field: Field | null;
    ranges: IAggregationRange[] | null;
    script: IScript | null;
}

export interface IRareTermsAggregation {
    exclude: TermsExclude | null;
    field: Field | null;
    include: TermsInclude | null;
    maximumDocumentCount: number | null;
    missing: any | null;
    precision: number | null;
}

export interface TermsExclude {
    pattern: string | null;
    values: string[] | null;
}

export interface TermsInclude {
    numberOfPartitions: number | null;
    partition: number | null;
}

export interface IReverseNestedAggregation {
    path: Field | null;
}

export interface ISamplerAggregation {
    shardSize: number | null;
}

export interface IScriptedMetricAggregation {
    combineScript: IScript | null;
    initScript: IScript | null;
    mapScript: IScript | null;
    params: { [key: string]: any; } | null;
    reduceScript: IScript | null;
}

export interface ISerialDifferencingAggregation {
    lag: number | null;
}

export interface ISignificantTermsAggregation {
    backgroundFilter: QueryContainer | null;
    chiSquare: IChiSquareHeuristic | null;
    exclude: IncludeExclude | null;
    executionHint: TermsAggregationExecutionHint | null;
    field: Field | null;
    googleNormalizedDistance: IGoogleNormalizedDistanceHeuristic | null;
    include: IncludeExclude | null;
    minimumDocumentCount: number | null;
    mutualInformation: IMutualInformationHeuristic | null;
    percentageScore: IPercentageScoreHeuristic | null;
    script: IScriptedHeuristic | null;
    shardMinimumDocumentCount: number | null;
    shardSize: number | null;
    size: number | null;
}

export interface IChiSquareHeuristic {
    backgroundIsSuperSet: boolean | null;
    includeNegatives: boolean | null;
}

export interface IncludeExclude {
}

export enum TermsAggregationExecutionHint {
    Map = "map",
    GlobalOrdinals = "global_ordinals",
    GlobalOrdinalsHash = "global_ordinals_hash",
    GlobalOrdinalsLowCardinality = "global_ordinals_low_cardinality",
}

export interface IGoogleNormalizedDistanceHeuristic {
    backgroundIsSuperSet: boolean | null;
}

export interface IMutualInformationHeuristic {
    backgroundIsSuperSet: boolean | null;
    includeNegatives: boolean | null;
}

export interface IPercentageScoreHeuristic {
}

export interface IScriptedHeuristic {
    script: IScript | null;
}

export interface ISignificantTextAggregation {
    backgroundFilter: QueryContainer | null;
    chiSquare: IChiSquareHeuristic | null;
    exclude: IncludeExclude | null;
    executionHint: TermsAggregationExecutionHint | null;
    field: Field | null;
    filterDuplicateText: boolean | null;
    googleNormalizedDistance: IGoogleNormalizedDistanceHeuristic | null;
    include: IncludeExclude | null;
    minimumDocumentCount: number | null;
    mutualInformation: IMutualInformationHeuristic | null;
    percentageScore: IPercentageScoreHeuristic | null;
    script: IScriptedHeuristic | null;
    shardMinimumDocumentCount: number | null;
    shardSize: number | null;
    size: number | null;
    sourceFields: Field[] | null;
}

export interface IStatsAggregation {
}

export interface IStatsBucketAggregation {
}

export interface ISumAggregation {
}

export interface ISumBucketAggregation {
}

export interface ITermsAggregation {
    collectMode: TermsAggregationCollectMode | null;
    exclude: TermsExclude | null;
    executionHint: TermsAggregationExecutionHint | null;
    field: Field | null;
    include: TermsInclude | null;
    minimumDocumentCount: number | null;
    missing: any | null;
    order: TermsOrder[] | null;
    script: IScript | null;
    shardSize: number | null;
    showTermDocCountError: boolean | null;
    size: number | null;
}

export enum TermsAggregationCollectMode {
    DepthFirst = "depth_first",
    BreadthFirst = "breadth_first",
}

export interface TermsOrder {
    key: string | null;
    order: SortOrder;
}

export interface ITopHitsAggregation {
    docValueFields: Field[] | null;
    explain: boolean | null;
    from: number | null;
    highlight: IHighlight | null;
    scriptFields: IScriptFields | null;
    size: number | null;
    sort: ISort[] | null;
    source: UnionOfBooleanAndISourceFilter | null;
    storedFields: Field[] | null;
    trackScores: boolean | null;
    version: boolean | null;
}

export interface IHighlight {
    boundaryChars: string | null;
    boundaryMaxScan: number | null;
    boundaryScanner: BoundaryScanner | null;
    boundaryScannerLocale: string | null;
    encoder: HighlighterEncoder | null;
    fields: { [key: string]: IHighlightField; } | null;
    fragmenter: HighlighterFragmenter | null;
    fragmentOffset: number | null;
    fragmentSize: number | null;
    highlightQuery: QueryContainer | null;
    maxAnalyzerOffset: number | null;
    maxFragmentLength: number | null;
    noMatchSize: number | null;
    numberOfFragments: number | null;
    order: HighlighterOrder | null;
    postTags: string[] | null;
    preTags: string[] | null;
    requireFieldMatch: boolean | null;
    tagsSchema: HighlighterTagsSchema | null;
}

export enum BoundaryScanner {
    Characters = "chars",
    Sentence = "sentence",
    Word = "word",
}

export enum HighlighterEncoder {
    Default = "default",
    Html = "html",
}

export interface IHighlightField {
    boundaryChars: string | null;
    boundaryMaxScan: number | null;
    boundaryScanner: BoundaryScanner | null;
    boundaryScannerLocale: string | null;
    field: Field | null;
    forceSource: boolean | null;
    fragmenter: HighlighterFragmenter | null;
    fragmentOffset: number | null;
    fragmentSize: number | null;
    highlightQuery: QueryContainer | null;
    matchedFields: Field[] | null;
    maxAnalyzerOffset: number | null;
    maxFragmentLength: number | null;
    noMatchSize: number | null;
    numberOfFragments: number | null;
    order: HighlighterOrder | null;
    phraseLimit: number | null;
    postTags: string[] | null;
    preTags: string[] | null;
    requireFieldMatch: boolean | null;
    tagsSchema: HighlighterTagsSchema | null;
    type: UnionOfHighlighterTypeAndString | null;
}

export enum HighlighterFragmenter {
    Simple = "simple",
    Span = "span",
}

export enum HighlighterOrder {
    Score = "score",
}

export enum HighlighterTagsSchema {
    Styled = "styled",
}

export interface UnionOfHighlighterTypeAndString {
}

export interface IScriptFields {
}

export interface UnionOfBooleanAndISourceFilter {
}

export interface IValueCountAggregation {
}

export interface IWeightedAverageAggregation {
    format: string | null;
    value: IWeightedAverageValue | null;
    valueType: ValueType | null;
    weight: IWeightedAverageValue | null;
}

export interface IWeightedAverageValue {
    field: Field | null;
    missing: number | null;
    script: IScript | null;
}

export enum ValueType {
    String = "string",
    Long = "long",
    Double = "double",
    Number = "number",
    Date = "date",
    DateNanos = "date_nanos",
    Ip = "ip",
    Numeric = "numeric",
    GeoPoint = "geo_point",
    Boolean = "boolean",
}

export interface IMedianAbsoluteDeviationAggregation {
    compression: number | null;
}

export interface IMultiTermsAggregation {
    collectMode: TermsAggregationCollectMode | null;
    minimumDocumentCount: number | null;
    order: TermsOrder[] | null;
    script: IScript | null;
    shardMinimumDocumentCount: number | null;
    shardSize: number | null;
    showTermDocCountError: boolean | null;
    size: number | null;
    terms: ITerm[] | null;
}

export interface ITerm {
    field: Field | null;
    missing: any | null;
}

export interface IVariableWidthHistogramAggregation {
    field: Field | null;
    buckets: number | null;
    initialBuffer: number | null;
    shardSize: number | null;
}

export interface SecureListingSearchMappedResult {
    listings: ListingWithCatalogData[];
    total: number;
    took: number;
    maxScore: number | null;
    timedOut: boolean;
    appliedSecurityFilters: string[] | null;
    allowedFieldCount: number;
    aggregations: { [key: string]: AggregationResult; } | null;
    pitId: string | null;
    searchAfter: any[] | null;
    hasNextPage: boolean;
}

export interface AggregationResult {
    value: any;
    displayName: string;
    type: AggregationType;
    metadata: { [key: string]: any; } | null;
}

export enum AggregationType {
    Sum = "Sum",
    Count = "Count",
    Average = "Average",
    Min = "Min",
    Max = "Max",
    DistinctCount = "DistinctCount",
    Script = "Script",
}

export interface LoginContext {
    isSuccess: boolean;
    user: UserDetail | null;
    returnUrl: string | null;
    authorizationUrl: string | null;
    version: string | null;
}

export interface UserDetail {
    userId: string;
    displayName: string;
    userName: string;
    localeLanguage: string;
    activeAccount: SellerAccount;
    features: Feature[];
    hasManyAccounts: boolean;
    impersonatorDisplayName: string | null;
    permissions: Permission[];
    ownerIds: string[] | null;
}

export interface SellerAccount {
    id: string;
    accountName: string;
    impersonatedUserId: string | null;
    impersonatedUsername: string | null;
    currencyCode: string | null;
    sellerAccountSettings: SellerAccountSettings;
    marketplaceSettings: MarketplaceAccountSetting[];
    officeMarketplaceSettings: MarketplaceAccountSetting[];
    isConsignor: boolean | null;
    isConsignee: boolean | null;
    sellerAccountState: SellerAccountState | null;
    sellerAccountType: SellerAccountType | null;
    sellerAccountTypeId: number | null;
    isReadOnly: boolean | null;
    isOfficeEnabled: boolean | null;
    isCached: boolean;
}

export interface SellerAccountSettings {
    defaultSplitType: number | null;
    ticketTypeRules: string | null;
    inHandDatePaddingInDays: number | null;
    defaultHideSeatNumbers: boolean | null;
    priceFloor: number | null;
    defaultMaxQuantityDisplay: number | null;
    saleListingPriceBoundary: number | null;
    inHandDaysBeforeEvent: number | null;
    placeholderInHandDaysBeforeEvent: number | null;
    defaultManualMaxDisplayQuantity: number | null;
    adminHoldIndefinitelyForCancelledSales: boolean | null;
}

export interface MarketplaceAccountSetting {
    officeId: number | null;
    isEnabled: boolean;
    mkp: Marketplace;
    markup: number | null;
    sellerFee: number | null;
    hasApiToken: boolean;
    hasApiRefreshToken: boolean;
    tokenExpired: boolean;
    seatSaverFee: number | null;
    isSyncHandledByProcessor: boolean;
    processor: Processor | null;
}

export enum Processor {
    Automatiq = "Automatiq",
    TicketSuite = "TicketSuite",
    OneTicket = "OneTicket",
    Taciyon = "Taciyon",
    TicketAttendant = "TicketAttendant",
    Reveal = "Reveal",
    VictoryLive = "VictoryLive",
    TicketVault = "TicketVault",
}

export enum SellerAccountState {
    Migrating = "Migrating",
    Active = "Active",
    Churned = "Churned",
    Blocked = "Blocked",
    PendingChurn = "PendingChurn",
}

export enum SellerAccountType {
    Sandbox = "Sandbox",
    Live = "Live",
    Employee = "Employee",
    Processor = "Processor",
    BrokerReadonly = "BrokerReadonly",
    Trial = "Trial",
    International = "International",
    DI = "DI",
    NextGenSell = "NextGenSell",
    PosLite = "PosLite",
}

export enum Permission {
    Sales_ViewAll = "Sales_ViewAll",
    Sales_ViewRecent = "Sales_ViewRecent",
    Sales_ViewRecentFromExternalMarketplace = "Sales_ViewRecentFromExternalMarketplace",
    Sales_ConfirmReject = "Sales_ConfirmReject",
    Sales_Fulfill = "Sales_Fulfill",
    Sales_CreateForExternalMarketplaces = "Sales_CreateForExternalMarketplaces",
    Sales_ViewProceeds = "Sales_ViewProceeds",
    Sales_ViewRecentProceeds = "Sales_ViewRecentProceeds",
    Sales_ViewCostAndMargin = "Sales_ViewCostAndMargin",
    Sales_ViewPaymentState = "Sales_ViewPaymentState",
    Sales_ViewFulfillmentArtifacts = "Sales_ViewFulfillmentArtifacts",
    Sales_ManageHold = "Sales_ManageHold",
    Sales_AddTagType = "Sales_AddTagType",
    Sales_UpdateTags = "Sales_UpdateTags",
    Sales_ViewSalesOnIsPricerOf = "Sales_ViewSalesOnIsPricerOf",
    Sales_UpdateSalesInfo = "Sales_UpdateSalesInfo",
    Sales_UpdateSalesInfoOnIsPricerOf = "Sales_UpdateSalesInfoOnIsPricerOf",
    Sales_UpdateSalesInfoOnIsFulfillerOf = "Sales_UpdateSalesInfoOnIsFulfillerOf",
    Sales_FulfillOnIsFulfillerOf = "Sales_FulfillOnIsFulfillerOf",
    Sales_ViewSalesOnPurchasedBy = "Sales_ViewSalesOnPurchasedBy",
    Sales_UpdateSaleOnPurchasedBy = "Sales_UpdateSaleOnPurchasedBy",
    Sales_FulfillOnPurchasedBy = "Sales_FulfillOnPurchasedBy",
    Sales_FulfillOnPricerOf = "Sales_FulfillOnPricerOf",
    Sales_UpdateTagsOnPurchasedBy = "Sales_UpdateTagsOnPurchasedBy",
    Sales_UpdateTagsOnIsPricerOf = "Sales_UpdateTagsOnIsPricerOf",
    Sales_UpdateTagsOnIsFulfillerOf = "Sales_UpdateTagsOnIsFulfillerOf",
    Sales_ConfirmRejectOnIsPricerOf = "Sales_ConfirmRejectOnIsPricerOf",
    Sales_ConfirmRejectOnPurchasedBy = "Sales_ConfirmRejectOnPurchasedBy",
    Sales_ViewFulfillmentArtifactsOnPurchasedBy = "Sales_ViewFulfillmentArtifactsOnPurchasedBy",
    Sales_ViewFulfillmentArtifactsOnIsPricerOf = "Sales_ViewFulfillmentArtifactsOnIsPricerOf",
    Sales_ConfirmRejectOnIsFulfillerOf = "Sales_ConfirmRejectOnIsFulfillerOf",
    Sales_ViewSalesOnIsFulfillerOf = "Sales_ViewSalesOnIsFulfillerOf",
    Sales_ViewFulfillmentArtifactsOnIsFulfillerOf = "Sales_ViewFulfillmentArtifactsOnIsFulfillerOf",
    Sales_CreateOfflineSale = "Sales_CreateOfflineSale",
    Sales_ManageOfflineSale = "Sales_ManageOfflineSale",
    Sales_ManageOfflineSaleCreatedBy = "Sales_ManageOfflineSaleCreatedBy",
    Sales_ConfirmTransferWithoutProof = "Sales_ConfirmTransferWithoutProof",
    Sales_ResetFulfillment = "Sales_ResetFulfillment",
    Sales_ViewHomePageMetrics = "Sales_ViewHomePageMetrics",
    Sales_Export = "Sales_Export",
    Sales_ViewColumnTotals = "Sales_ViewColumnTotals",
    Sales_CreateDonationSale = "Sales_CreateDonationSale",
    Sales_ManageDonationSale = "Sales_ManageDonationSale",
    Inventory_ViewAll = "Inventory_ViewAll",
    Inventory_ViewRecent = "Inventory_ViewRecent",
    Inventory_ViewRecentFromExternalMarketplace = "Inventory_ViewRecentFromExternalMarketplace",
    Inventory_ViewAllMarketplaceAttributes = "Inventory_ViewAllMarketplaceAttributes",
    Inventory_ViewExternalMarketplaceAttributes = "Inventory_ViewExternalMarketplaceAttributes",
    Inventory_ViewFulfillmentArtifacts = "Inventory_ViewFulfillmentArtifacts",
    Inventory_SetPrice = "Inventory_SetPrice",
    Inventory_SetPriceOnPurchasedBy = "Inventory_SetPriceOnPurchasedBy",
    Inventory_SetPriceOnIsPricerOf = "Inventory_SetPriceOnIsPricerOf",
    Inventory_Predelivery = "Inventory_Predelivery",
    Inventory_BroadcastUnbroadcast = "Inventory_BroadcastUnbroadcast",
    Inventory_BroadcastUnbroadcastOnPurchasedBy = "Inventory_BroadcastUnbroadcastOnPurchasedBy",
    Inventory_EditPricing = "Inventory_EditPricing",
    Inventory_UpdateListingInfo = "Inventory_UpdateListingInfo",
    Inventory_UpdateListingInfoOnPurchasedBy = "Inventory_UpdateListingInfoOnPurchasedBy",
    Inventory_AddTagType = "Inventory_AddTagType",
    Inventory_UpdateTags = "Inventory_UpdateTags",
    Inventory_UpdateTagsOnPurchasedBy = "Inventory_UpdateTagsOnPurchasedBy",
    Inventory_ViewListingOnIsPricerOf = "Inventory_ViewListingOnIsPricerOf",
    Inventory_UpdateListingInfoOnIsPricerOf = "Inventory_UpdateListingInfoOnIsPricerOf",
    Inventory_UpdateTagsOnIsPricerOf = "Inventory_UpdateTagsOnIsPricerOf",
    Inventory_PredeliveryOnPurchasedBy = "Inventory_PredeliveryOnPurchasedBy",
    Inventory_PredeliveryOnIsPricerOf = "Inventory_PredeliveryOnIsPricerOf",
    Inventory_ViewListingsOnPurchasedBy = "Inventory_ViewListingsOnPurchasedBy",
    Inventory_ViewFulfillmentArtifactsOnPurchasedBy = "Inventory_ViewFulfillmentArtifactsOnPurchasedBy",
    Inventory_ViewFulfillmentArtifactsOnIsPricerOf = "Inventory_ViewFulfillmentArtifactsOnIsPricerOf",
    Inventory_BroadcastUnbroadcastOnIsPricerOf = "Inventory_BroadcastUnbroadcastOnIsPricerOf",
    Inventory_AddSeatSaver = "Inventory_AddSeatSaver",
    Inventory_ManageSeatSaver = "Inventory_ManageSeatSaver",
    Inventory_ManageSeatSaverCreatedBy = "Inventory_ManageSeatSaverCreatedBy",
    Inventory_UpdateDeliveryStrategy = "Inventory_UpdateDeliveryStrategy",
    Inventory_UpdateDeliveryStrategyOnIsPricerOf = "Inventory_UpdateDeliveryStrategyOnIsPricerOf",
    Inventory_UpdateDeliveryStrategyOnPurchasedBy = "Inventory_UpdateDeliveryStrategyOnPurchasedBy",
    Inventory_ManageAdminHolds = "Inventory_ManageAdminHolds",
    Inventory_Export = "Inventory_Export",
    Inventory_ViewColumnTotals = "Inventory_ViewColumnTotals",
    SellerAccount_Admin = "SellerAccount_Admin",
    SellerSupportCase_Create = "SellerSupportCase_Create",
    SellerSupportCase_View = "SellerSupportCase_View",
    Purchases_ViewAll = "Purchases_ViewAll",
    Purchases_ViewRecent = "Purchases_ViewRecent",
    Purchases_Edit = "Purchases_Edit",
    Purchases_EditOwned = "Purchases_EditOwned",
    Purchases_Create = "Purchases_Create",
    Purchases_AddTagType = "Purchases_AddTagType",
    Purchases_UpdateTags = "Purchases_UpdateTags",
    Purchases_UpdateTagsOwned = "Purchases_UpdateTagsOwned",
    Purchases_ViewOwned = "Purchases_ViewOwned",
    Purchases_UpdateBuyerCommission = "Purchases_UpdateBuyerCommission",
    Purchases_UpdateBuyerCommissionOwned = "Purchases_UpdateBuyerCommissionOwned",
    Purchases_UpdateDeliveryType = "Purchases_UpdateDeliveryType",
    Purchases_UpdateDeliveryTypeOwned = "Purchases_UpdateDeliveryTypeOwned",
    Purchases_UpdateCustomDeliveryType = "Purchases_UpdateCustomDeliveryType",
    Purchases_UpdateCustomDeliveryTypeOwned = "Purchases_UpdateCustomDeliveryTypeOwned",
    Purchases_UpdateSeatTraits = "Purchases_UpdateSeatTraits",
    Purchases_UpdateSeatTraitsOwned = "Purchases_UpdateSeatTraitsOwned",
    Purchases_LockUnlockCommission = "Purchases_LockUnlockCommission",
    Purchases_LockUnlockCommissionOwned = "Purchases_LockUnlockCommissionOwned",
    Purchases_EditVendor = "Purchases_EditVendor",
    Purchases_Export = "Purchases_Export",
    Purchases_ViewColumnTotals = "Purchases_ViewColumnTotals",
    Purchases_ManagePaymentMethod = "Purchases_ManagePaymentMethod",
    Purchases_ManageTeamVendors = "Purchases_ManageTeamVendors",
    Purchases_ManageTeamPurchasedBy = "Purchases_ManageTeamPurchasedBy",
    Events_ViewAll = "Events_ViewAll",
    Events_AddTagType = "Events_AddTagType",
    Events_UpdateTags = "Events_UpdateTags",
    Events_SetPrice = "Events_SetPrice",
    Events_Edit = "Events_Edit",
    Events_ManageEventDiscovery = "Events_ManageEventDiscovery",
    Events_TeamPricing = "Events_TeamPricing",
    Accounts_ViewAll = "Accounts_ViewAll",
    Account_SetPrice = "Account_SetPrice",
    TicketGroups_ViewAll = "TicketGroups_ViewAll",
    Webhook_View = "Webhook_View",
    Webhook_Create = "Webhook_Create",
    Webhook_Edit = "Webhook_Edit",
    EventConfig_Edit = "EventConfig_Edit",
    EventConfig_Create = "EventConfig_Create",
    EventConfig_View = "EventConfig_View",
    Reports_CreateReports = "Reports_CreateReports",
    Reports_UpdateReports = "Reports_UpdateReports",
    Reports_UpdateReportsOwned = "Reports_UpdateReportsOwned",
    Reports_ViewInventoryReports = "Reports_ViewInventoryReports",
    Reports_ViewSalesReports = "Reports_ViewSalesReports",
    Reports_ViewAll = "Reports_ViewAll",
    Reports_ViewGlobalReports = "Reports_ViewGlobalReports",
    Reports_ViewSharedReports = "Reports_ViewSharedReports",
    Accounting_ViewAll = "Accounting_ViewAll",
    Accounting_ViewPaymentsOnSale = "Accounting_ViewPaymentsOnSale",
    Accounting_ViewStubhubPayments = "Accounting_ViewStubhubPayments",
    Accounting_ViewAutoPricingSettings = "Accounting_ViewAutoPricingSettings",
    Accounting_AdjustBuyerCredit = "Accounting_AdjustBuyerCredit",
    AdPlatform_Edit = "AdPlatform_Edit",
    AdPlatform_CampaignsViewAll = "AdPlatform_CampaignsViewAll",
    AdPlatform_CampaignsCreate = "AdPlatform_CampaignsCreate",
    AdPlatform_CampaignsEdit = "AdPlatform_CampaignsEdit",
    General_ViewReleaseNotes = "General_ViewReleaseNotes",
    General_ViewNotifications = "General_ViewNotifications",
    General_ViewHelpCenter = "General_ViewHelpCenter",
    Purchases_B2B_View = "Purchases_B2B_View",
    Purchases_B2B_Update = "Purchases_B2B_Update",
    Purchases_CreateAutoBroadcast = "Purchases_CreateAutoBroadcast",
}

export interface LoginRequest {
    code: string | null;
    state: string | null;
}

export interface CouponBalanceResponse {
    balance: number | null;
}

export interface MarketOrderListResponse {
    orders: MarketOrderResponse[];
    totalCount: number;
}

export interface MarketOrderResponse {
    marketOrderId: number;
    partitionId: number;
    sellerAccountId: string;
    sellerUserId: string;
    eventId: number;
    zone: string | null;
    zoneId: number | null;
    section: string | null;
    sectionId: number | null;
    rowBetterThan: string | null;
    rowId: number | null;
    sellerType: MarketOrderSellerType;
    maxPriceAmount: number;
    maxPriceCurrencyCode: string;
    totalTickets: number;
    filledTickets: number;
    status: MarketOrderStatus;
    startDate: string | null;
    endDate: string | null;
    inventoryThreshold: number | null;
    packSizes: string | null;
    createDate: string;
    updateDate: string;
}

export enum MarketOrderSellerType {
    Fan = "Fan",
    Broker = "Broker",
}

export enum MarketOrderStatus {
    Active = "Active",
    Paused = "Paused",
    Expired = "Expired",
    Filled = "Filled",
    Cancelled = "Cancelled",
}

export interface MarketOrderQuery {
    eventId: number;
    status: MarketOrderStatus | null;
    take: number | null;
    skip: number | null;
}

export interface CreateMarketOrderRequest {
    eventId: number;
    zone: string | null;
    zoneId: number | null;
    section: string | null;
    sectionId: number | null;
    rowBetterThan: string | null;
    rowId: number | null;
    sellerType: MarketOrderSellerType;
    maxPriceAmount: number;
    maxPriceCurrencyCode: string;
    totalTickets: number;
    packSizes: string | null;
    startDate: string | null;
    endDate: string | null;
    inventoryThreshold: number | null;
}

export interface UpdateMarketOrderRequest {
    marketOrderId: number;
    zone: string | null;
    zoneId: number | null;
    section: string | null;
    sectionId: number | null;
    rowBetterThan: string | null;
    rowId: number | null;
    sellerType: MarketOrderSellerType;
    maxPriceAmount: number;
    maxPriceCurrencyCode: string;
    totalTickets: number;
    packSizes: string | null;
    startDate: string | null;
    endDate: string | null;
    inventoryThreshold: number | null;
    status: MarketOrderStatus | null;
}

export interface DeleteMarketOrderRequest {
    marketOrderId: number;
}

export interface MarketOrderPurchaseOrderListResponse {
    purchaseOrders: MarketOrderPurchaseOrderResponse[];
    totalCount: number;
}

export interface MarketOrderPurchaseOrderResponse {
    marketOrderPurchaseOrderId: number;
    partitionId: number;
    sellerAccountId: string;
    marketOrderId: number;
    purchaseOrderId: number;
    createDate: string;
}

export interface MarketOrderPurchaseOrderQuery {
    marketOrderId: number | null;
    eventId: number | null;
    take: number | null;
    skip: number | null;
}

export interface CreateMarketOrderPurchaseOrderRequest {
    marketOrderId: number;
    purchaseOrderId: number;
}

export interface PurchaseListingsResponse {
    results: PurchaseListingResultDto[];
}

export interface PurchaseListingResultDto {
    listingId: number;
    success: boolean;
    failureCode: string | null;
    message: string | null;
    transactionId: number | null;
}

export interface PurchaseListingsRequest {
    items: PurchaseListingItem[];
}

export interface PurchaseListingItem {
    listingId: number;
    quantity: number;
}

export interface EntitiesWithSummaryOfMarketplaceSalePayment {
    items: MarketplaceSalePayment[];
    summary: MarketplaceSalePayment | null;
}

export interface MarketplaceSalePayment {
    id: number;
    mkp: Marketplace | null;
    extPmtId: string;
    pmtRefId: string | null;
    pmtDate: string | null;
    recvDate: string | null;
    state: MarketplacePaymentState;
    pmtAmt: UiMoney;
    proceedsAmt: UiMoney | null;
    credit: UiMoney | null;
    charge: UiMoney | null;
    convertedPmtAmt: UiMoney | null;
    mkpPmtTerm: MarketplacePaymentTerm | null;
    manualPmtAmt: UiMoney | null;
    manualProceedsAmt: UiMoney | null;
    manualCreditAmt: UiMoney | null;
    manualChargeAmt: UiMoney | null;
    isLocked: boolean | null;
}

export enum MarketplacePaymentTerm {
    PaymentUponSaleConfirmation = "PaymentUponSaleConfirmation",
    PaymentUponDelivery = "PaymentUponDelivery",
    PaymentPostEvent = "PaymentPostEvent",
}

export interface MarketplacePaymentQuery {
    marketplace: Marketplace | null;
    marketplacePaymentState: MarketplacePaymentState | null;
    paymentDates: DateTimeRangeWithRelative | null;
    sortBy: EventSort | null;
    isSortDescending: boolean | null;
    hasPaymentLineUnmappedToSale: boolean | null;
    hasPaymentLineUnmappedToSaleLineItem: boolean | null;
    hasPaymentTotalDiscrepancy: boolean | null;
    hasProceedsTotalDiscrepancy: boolean | null;
    hasCreditTotalDiscrepancy: boolean | null;
    hasChargeTotalDiscrepancy: boolean | null;
    currencyCodes: string[] | null;
    viewMode: string | null;
    timezoneOffsetMins: number | null;
}

export interface MonthContainingMarketplacePaymentsResult {
    firstOfMonth: string;
    totalPaymentAmount: UiMoney | null;
}

export interface MarketplacePaymentLineWithSaleInfo {
    id: number;
    marketplace: Marketplace | null;
    posPmtId: number;
    extPmtId: string;
    extLineId: string;
    state: MarketplacePaymentState;
    date: string | null;
    recvDate: string | null;
    extPmtMethodType: ExternalPaymentMethodType | null;
    extPmtNote: string | null;
    extCustomPmtTypeName: string | null;
    isCred: boolean;
    amt: UiMoney;
    type: MarketplacePaymentLineType;
    isAddedToSale: boolean | null;
    isLocked: boolean | null;
    saleId: number | null;
    extSaleId: string;
    saleStatus: PointOfSaleSaleStatus | null;
    posEvId: string | null;
    viagEvId: number | null;
    viagEvMapId: string | null;
    viagVirtId: string | null;
    seating: Seating | null;
    convertedPmtAmt: UiMoney | null;
}

export interface MarketplacePaymentLineQuery {
    hasUnlinkedChargesCredits: boolean | null;
    externalSaleIdContains: string | null;
    viewMode: string | null;
    timezoneOffsetMins: number | null;
}

export interface MarketplacePaymentSaleLineInput {
    marketplacePaymentLineId: number;
    marketplacePaymentId: number;
    externalPaymentLineId: PosFieldOfString | null;
    paymentLineType: PosFieldOfNullableMarketplacePaymentLineType | null;
    saleId: PosFieldOfNullableLong | null;
    externalSaleId: PosFieldOfString | null;
    amount: PosFieldOfNullableDecimal | null;
    currency: PosFieldOfString | null;
}

export interface PosFieldOfNullableMarketplacePaymentLineType {
    value: MarketplacePaymentLineType | null;
    hasChanged: boolean;
}

export interface MarketplacePaymentInput {
    marketplacePaymentId: number;
    externalPaymentId: PosFieldOfString | null;
    marketplace: PosFieldOfNullableMarketplace | null;
    paymentDate: PosFieldOfNullableDateTime | null;
    paymentReferenceId: PosFieldOfString | null;
    paymentCurrency: PosFieldOfString | null;
    manualPaymentAmount: PosFieldOfNullableDecimal | null;
    manualProceedsAmount: PosFieldOfNullableDecimal | null;
    manualCreditAmount: PosFieldOfNullableDecimal | null;
    manualChargeAmount: PosFieldOfNullableDecimal | null;
}

export interface PosFieldOfNullableMarketplace {
    value: Marketplace | null;
    hasChanged: boolean;
}

export interface UiCurrency {
    code: string;
    dec: number;
    sym: string;
}

export interface NativeUserDetailResponse {
    email: string;
    displayName: string;
    userId: string;
}

export interface Notification {
    notificationId: number;
    notificationType: NotificationType;
    entityType: ActionOutboxEntityType;
    entityId: number;
    notificationState: NotificationState;
    createDateTime: string;
    expirationDateTime: string;
    posEventId: string | null;
    section: string | null;
    row: string | null;
    piggybackRow: string | null;
    seatFrom: string | null;
    seatTo: string | null;
    marketplace: Marketplace | null;
    marketplaceEntityId: string | null;
    event: Event | null;
    performer: Performer | null;
    venue: Venue | null;
}

export enum NotificationType {
    SaleNew = "SaleNew",
    SaleFulfilmentFailed = "SaleFulfilmentFailed",
    SaleMarketplaceCancelled = "SaleMarketplaceCancelled",
    ListingHideSeatsFailed = "ListingHideSeatsFailed",
    ListingUpdateAllInPriceFailed = "ListingUpdateAllInPriceFailed",
    ListingUpdateInHandDateFailed = "ListingUpdateInHandDateFailed",
    ListingUpdateSplitTypeFailed = "ListingUpdateSplitTypeFailed",
    ListingUpdateDeliveryTypeFailed = "ListingUpdateDeliveryTypeFailed",
    ListingUpdateUnitNetProceedsFailed = "ListingUpdateUnitNetProceedsFailed",
    ListingBroadcastFailed = "ListingBroadcastFailed",
    ListingUnbroadcastFailed = "ListingUnbroadcastFailed",
    ListingMergeFailed = "ListingMergeFailed",
    ListingSplitFailed = "ListingSplitFailed",
    ListingPriceUpdate = "ListingPriceUpdate",
    AutopriceBelowFloor = "AutopriceBelowFloor",
    AutopriceInsufficientCompListings = "AutopriceInsufficientCompListings",
    AutopriceFirebrake = "AutopriceFirebrake",
    SellerSupportCaseNewReply = "SellerSupportCaseNewReply",
}

export enum NotificationState {
    Active = "Active",
    Inactive = "Inactive",
}

export interface RegisterPushTokenResponse {
    success: boolean;
    message: string;
}

export interface RegisterPushTokenRequest {
    token: string;
    deviceType: string;
    deviceInstallationId: string;
    deviceName: string | null;
    osVersion: string | null;
}

export interface Office {
    officeId: number;
    officeName: string;
    isDefault: boolean;
}

export interface UpdateListingGroupAutoPriceSettingsFromOnePagerRequest {
    autoPricingSettings: ListingGroupAutoPriceSettings;
    hasChangesInCompSettings: boolean;
    hasChangesInUndercutSettings: boolean;
    hasChangesInOutlierSettings: boolean;
}

export interface ListingGroupAutoPriceSettings extends AutoPricingInputs {
    desiredActiveListings: number | null;
    deprioritizedQuantities: string[] | null;
    undAbsAmt: number | null;
    undRelAmt: number | null;
    netProceedsFloor: number | null;
    netProceedsCeiling: number | null;
    autoPricingEnabled: boolean | null;
    startingUnitNetProceeds: number | null;
    previewMarketPrices: { [key: string]: number; } | null;
}

export interface EventAutoPricingSettingsInputs extends AutoPricingInputs {
    compRowOffsetMode: CompRowOffsetMode | null;
}

export enum CompRowOffsetMode {
    Ordinal = "Ordinal",
    Text = "Text",
}

export interface EventConfigScoreOverride {
    id: number;
    name: string;
    eventIds: number[] | null;
    cfgId: number;
    cfgPayload: string | null;
    scoreOverrides: SectionScoreOverride[];
    isActive: boolean | null;
    isTemplate: boolean | null;
    viagogoEventId: number | null;
    venueId: number | null;
    categoryId: number | null;
}

export interface SellerAccountEventConfigScoreOverrides {
    eventConfigScoreOverrideId: number;
    configPayload: string;
    name: string;
    eventId: number | null;
    createDate: string;
    updateDate: string;
}

export interface SellThroughRateHistory {
    sellThroughRatePercentage: number;
    timelineDate: string;
}

export interface SellThroughRateConfig {
    targets: SellThroughRateHistory[];
    overselling: SellThroughRateHistory[] | null;
    underselling: SellThroughRateHistory[] | null;
}

export interface SellThroughRateConfigInput {
    targets: SellThroughRateHistory[];
    overselling: SellThroughRateHistory[] | null;
    underselling: SellThroughRateHistory[] | null;
}

export interface AutoPricingSettingsCollection extends AutoPricingInputs {
    autoPricingSettingsCollectionId: number | null;
    strategyName: string;
}

export interface UpsertAutoCompSettingsInput {
    viagogoEventId: number;
    venueZoneConfigType: string;
    rowCompOffset: number;
    rowGroupSetting: string;
    sectionGroupCustomRankEnabled: boolean;
    rowCompOverrides: RowCompOverrideInput[];
    zoneSectionAreaGroupLookupJson: string;
}

export interface RowCompOverrideInput {
    rowOrdinalFrom: number;
    rowOrdinalTo: number;
    offsetOverride: number;
}

export interface AutoCompSettingsResult {
    venueZoneConfigType: VenueZoneConfigType | null;
    rowCompOffset: number;
    rowGroupSetting: RowGroupSetting | null;
    sectionGroupCustomRankEnabled: boolean;
    rowCompOverrides: RowCompOverride[] | null;
}

export interface VenueMapZoneConfigInfo {
    defaultVenueZoneConfigType: VenueZoneConfigType;
    venueMapZoneConfigs: { [key in keyof typeof VenueZoneConfigType]?: { [key: string]: SectionSectionGroup; }; };
}

export interface SectionSectionGroup {
    sectId: number;
    areaRank: number;
    sectionGroupRank: number;
    sectionGroupAreaType: SectionGroupAreaType | null;
    sectionGroupAreaName: string | null;
    ticketClassId: number | null;
    ticketClassName: string | null;
    sectionGroupColor: string;
}

export enum SectionGroupAreaType {
    Unknown = "Unknown",
    Center = "Center",
    LeftRight = "LeftRight",
    FarLeftFarRight = "FarLeftFarRight",
    Front = "Front",
    Sides = "Sides",
    SideT1 = "SideT1",
    SideT2 = "SideT2",
    Ends = "Ends",
    Rear = "Rear",
    Corners = "Corners",
}

export interface EventsPricingConfig {
    sharedConfigId: number | null;
    canUseZoneMap: boolean;
}

export interface VenueZoneConfigOverride {
    name: string;
    eventId: number | null;
    configId: number | null;
    venueId: number | null;
    sectionSectionGroupLookup: { [key: string]: SectionSectionGroup; };
}

export interface UpsertVenueZoneSectionGroupOverridesInput {
    viagogoEventId: number;
    venueZoneOverrideId: number | null;
    name: string;
    sectionSectionGroupsJson: string;
    saveAsNewMap: boolean;
}

export interface EventMapConfigMetadata {
    defaultVenueZoneConfigType: VenueZoneConfigType;
    selectedVenueMapConfigType: VenueZoneConfigType | null;
    selectedOverrideId: number | null;
    selectedOverrideName: string | null;
    selectedVenueMapConfig: { [key: string]: SectionSectionGroup; };
}

export interface SqsSectionRowRecommendations {
    modelVersionId: number;
    rowRecommendations: { [key: string]: SelectedSectionSettings; };
}

export enum VelocityCircuitBreakerSuppressionType {
    Reset = "Reset",
    Permanent = "Permanent",
}

export interface SellerEventWithVenue {
    sellerEventId: string;
    viagogoEventId: number;
    venueId: number;
    venueConfigId: number;
}

export interface PurchaseOrderDetails extends PurchaseOrder {
    additionalCosts: CostDetail[] | null;
    ticketGroups: TicketGroup[];
    miniCatalog: CatalogResults | null;
    payments: PurchasePayment[] | null;
    transferId: string | null;
    hasMergedListings: boolean | null;
    hasSplitListings: boolean | null;
    deal: PurchaseOrderDeal | null;
}

export interface CostDetail {
    id: number;
    cost: UiMoney | null;
    costType: PurchaseOrderCostType;
    date: string;
    description: string | null;
}

export enum PurchaseOrderCostType {
    Tax = "Tax",
    Shipping = "Shipping",
    CreditCardFee = "Credit Card Fee",
    BulkDiscount = "Bulk Discount",
    Cancelled = "Cancelled",
    Other = "Other",
}

export interface TicketGroup extends EntityWithTickets {
    entityType: ActionOutboxEntityType;
    tickets: Ticket[];
    unitCst: UiMoney;
    unitFullyLoadedCst: UiMoney | null;
    totalCst: UiMoney | null;
    expectedVal: UiMoney | null;
    webPrice: UiMoney | null;
    taxPaid: UiMoney | null;
    isFaceVal: boolean;
    faceVal: UiMoney | null;
    delivType: DeliveryType;
    delivCst: UiMoney | null;
    poId: number | null;
    vendOrdId: string | null;
    availArtTypes: ArtifactType[];
    canGetDocArts: boolean | null;
    venId: number | null;
    perfId: number | null;
}

export interface PurchasePayment {
    paymentId: number;
    paymentStatus: PurchasePaymentStatus;
    paymentDueDate: string;
    paymentDate: string | null;
    paymentAmount: UiMoney;
    currencyCode: string;
    convertedPaymentAmount: UiMoney | null;
    convertedCurrencyCode: string | null;
    conversionRate: number | null;
    conversionDate: string | null;
    conversionUserId: string | null;
    paymentMethod: PurchasePaymentMethod;
}

export interface PurchaseOrderDeal {
    dealId: string | null;
    dealType: DealType;
    dealDetails: PurchaseOrderDealDetails;
}

export enum DealType {
    Sor = "Sor",
    Guaranteed = "Guaranteed",
}

export interface PurchaseOrderDealDetails {
    guaranteedAmountPaid: number | null;
    dealStartDate: string | null;
    dealEndDate: string | null;
    configSplitType: DealSplitType;
    dealConfigId: string | null;
    dealFallbackConfig: PurchaseOrderDealConfig | null;
    dealConfigs: PurchaseOrderDealConfig[] | null;
}

export enum DealSplitType {
    Quantity = "Quantity",
    Sales = "Sales",
    None = "None",
}

export interface PurchaseOrderDealConfig {
    dealConfigHurdleId: string | null;
    thresholdSplitDirection: DealThresholdSplitDirection | null;
    thresholdValue: number | null;
    vendorCommission: PurchaseOrderDealCommission;
    purchaserCommissions: PurchaseOrderDealCommission[];
    priority: number | null;
}

export enum DealThresholdSplitDirection {
    Above = "Above",
    Below = "Below",
}

export interface PurchaseOrderDealCommission {
    userId: string;
    splitValue: number;
}

export interface EntitiesWithSummaryOfPurchaseOrder {
    items: PurchaseOrder[];
    summary: PurchaseOrder | null;
}

export interface EntitySearchResultOfEntitiesWithSummaryOfPurchaseOrderTicketGroup {
    entities: EntitiesWithSummaryOfPurchaseOrderTicketGroup;
    pitId: string | null;
    totalItemsCount: number | null;
    maxResultWindow: number | null;
    searchAfter: any[] | null;
    sortedGroupIds: string[] | null;
    sortedItemIds: number[] | null;
}

export interface EntitiesWithSummaryOfPurchaseOrderTicketGroup {
    items: PurchaseOrderTicketGroup[];
    summary: PurchaseOrderTicketGroup | null;
}

export interface PurchaseOrderQueryV2 extends PurchaseOrderQuery {
    deliveryTypes: DeliveryType[] | null;
    paymentMethods: PurchasePaymentMethodType[] | null;
    paymentMethodIds: number[] | null;
    paymentStatuses: PurchasePaymentStatus[] | null;
    operations: PurchaseQueryOperations | null;
    searchOptions: UISearchOptions | null;
}

export interface PurchaseQueryOperations extends EntityWithTicketsQueryOperations {
    ticketGroupIdsOp: FilterOperationType | null;
    purchaseMonthsOp: FilterOperationType | null;
    paymentMethodOp: FilterOperationType | null;
    paymentStatusOp: FilterOperationType | null;
    paymentDatesOp: FilterOperationType | null;
    totalCostHighOp: FilterOperationType | null;
    totalCostLowOp: FilterOperationType | null;
    unitCostHighOp: FilterOperationType | null;
    unitCostLowOp: FilterOperationType | null;
    deliveryTypeOp: FilterOperationType | null;
    purchaseOrderStateOp: FilterOperationType | null;
    paymentMethodIdOp: FilterOperationType | null;
    paymentCurrencyCodesOp: FilterOperationType | null;
    isConsignmentOp: FilterOperationType | null;
}

export interface AccessControlProvider {
    id: number;
    name: string;
}

export interface ValueTupleOfISetOfIntegerAndISetOfGuid {
    item1: number[];
    item2: string[];
}

export interface PurchaseVendorAccountDetails extends PurchaseVendorAccount {
    delivType: DeliveryType | null;
    isNoFulfill: boolean | null;
    tktTypeRules: TicketTypeOverride | null;
    favPmtMethodIds: number[] | null;
}

export enum PurchasingIdInUseResultType {
    NoneMatching = "NoneMatching",
    SameOrderId = "SameOrderId",
    SameOrderIdAndVendorId = "SameOrderIdAndVendorId",
}

export interface MonthContainingPurchaseOrdersResult {
    firstOfMonth: string;
    purchaseCount: number;
    numOfTickets: number;
    totalCost: UiMoney | null;
}

export interface TimePeriodContainingPurchaseOrderResult {
    firstOfTimePeriod: string;
    purchaseCount: number;
    numOfTickets: number;
    totalCost: UiMoney | null;
}

export enum TimePeriodType {
    Daily = "Daily",
    Weekly = "Weekly",
    Monthly = "Monthly",
}

export interface PurchaseOrderDetailsInput {
    id: number;
    vendorOrderId: PosFieldOfString | null;
    purchaseDate: PosFieldOfNullableDateTime | null;
    buyerUserId: PosFieldOfNullableGuid | null;
    currencyCode: PosFieldOfString | null;
    commissions: PosFieldArrayOfCommission | null;
    vendor: PosFieldOfPurchaseVendor | null;
    vendorAccount: PosFieldOfPurchaseVendorAccount | null;
    partialVendorAccount: PartialPurchaseVendorAccount | null;
    secondaryVendorAccount: PosFieldOfPurchaseVendorAccount | null;
    partialSecondaryVendorAccount: PartialPurchaseVendorAccount | null;
    secondaryVendor: PosFieldOfPurchaseVendor | null;
    additionalCosts: PosFieldArrayOfCostDetail | null;
    payments: PosFieldArrayOfPurchasePayment | null;
    transferId: PosFieldOfString | null;
    tags: PosFieldArrayOfTag | null;
    privateNotes: PosFieldOfString | null;
    qcState: PosFieldOfNullableQualityControlState | null;
    isAutoPo: boolean;
    ticketGroups: TicketGroupInput[];
    deal: PosFieldOfPurchaseOrderDealInput | null;
    isCommissionsLocked: PosFieldOfNullableBoolean | null;
    officeId: PosFieldOfNullableShort | null;
    originalCurrencyCode: string | null;
    conversionRate: number | null;
}

export interface PosFieldOfPurchaseVendor {
    value: PurchaseVendor | null;
    hasChanged: boolean;
}

export interface PosFieldOfPurchaseVendorAccount {
    value: PurchaseVendorAccount | null;
    hasChanged: boolean;
}

export interface PartialPurchaseVendorAccount {
    vendorId: number;
    name: string | null;
    email: string;
}

export interface PosFieldArrayOfCostDetail {
    value: CostDetail[] | null;
    hasChanged: boolean;
}

export interface PosFieldArrayOfPurchasePayment {
    value: PurchasePayment[] | null;
    hasChanged: boolean;
}

export interface PosFieldOfNullableQualityControlState {
    value: QualityControlState | null;
    hasChanged: boolean;
}

export interface TicketGroupInput {
    ticketGroupId: number;
    purchaseOrderId: number | null;
    event: Event | null;
    performer: Performer | null;
    venue: Venue | null;
    canGetDocArts: boolean | null;
    viagogoEventId: number | null;
    eventMappingId: string | null;
    viagogoVirtualId: string;
    posEventId: string | null;
    unitCost: PosFieldOfNullableDecimal | null;
    unitFullyLoadedCost: number | null;
    inHandDate: PosFieldOfNullableDateTime | null;
    expectedValue: PosFieldOfNullableDecimal | null;
    isFaceValueCost: PosFieldOfNullableBoolean | null;
    faceValueCost: PosFieldOfNullableDecimal | null;
    deliveryType: PosFieldOfNullableDeliveryType | null;
    totalCost: PosFieldOfNullableDecimal | null;
    taxPaid: PosFieldOfNullableDecimal | null;
    isTaxExempt: PosFieldOfNullableBoolean | null;
    deliveryCost: PosFieldOfNullableDecimal | null;
    currencyCode: PosFieldOfString | null;
    section: PosFieldOfString | null;
    sectionId: PosFieldOfNullableInteger | null;
    rowId: PosFieldOfNullableInteger | null;
    row: PosFieldOfString | null;
    tickets: PosFieldArrayOfTicket | null;
    numberOfTickets: PosFieldOfNullableInteger | null;
    ticketTypeRules: TicketTypeOverride | null;
    internalNotes: PosFieldOfString | null;
    listingNotes: PosFieldArrayOfListingNote | null;
    seatIncementType: number | null;
    allocateSeats: boolean | null;
    webPrice: number | null;
    autoBroadcastCreatedListing: boolean | null;
}

export interface PosFieldOfNullableDeliveryType {
    value: DeliveryType | null;
    hasChanged: boolean;
}

export interface PosFieldArrayOfTicket {
    value: Ticket[] | null;
    hasChanged: boolean;
}

export interface PosFieldArrayOfListingNote {
    value: ListingNote[] | null;
    hasChanged: boolean;
}

export interface PosFieldOfPurchaseOrderDealInput {
    value: PurchaseOrderDealInput | null;
    hasChanged: boolean;
}

export interface PurchaseOrderDealInput {
    dealId: string | null;
    dealType: DealType;
    dealDetails: PurchaseOrderDealDetailsInput;
}

export interface PurchaseOrderDealDetailsInput {
    guaranteedAmountPaid: number | null;
    dealStartDate: string | null;
    dealEndDate: string | null;
    configSplitType: PosFieldOfNullableDealSplitType;
    dealConfigId: string | null;
    dealFallbackConfig: PurchaseOrderDealConfig | null;
    dealConfigs: PosFieldArrayOfPurchaseOrderDealConfig | null;
}

export interface PosFieldOfNullableDealSplitType {
    value: DealSplitType | null;
    hasChanged: boolean;
}

export interface PosFieldArrayOfPurchaseOrderDealConfig {
    value: PurchaseOrderDealConfig[] | null;
    hasChanged: boolean;
}

export interface PosFieldOfNullableShort {
    value: number | null;
    hasChanged: boolean;
}

export interface ValueTupleOfISetOfLongAndPosFieldOfNullableQualityControlState {
    item1: number[];
    item2: PosFieldOfNullableQualityControlState;
}

export interface ValueTupleOfLongAndDecimal {
    item1: number;
    item2: number;
}

export interface CurrencyConversionOverride {
    currencyConversionOverrideId: number;
    fromCurrencyCode: string;
    toCurrencyCode: string;
    purchasePaymentMethodId: number | null;
    purchasePaymentMethodName: string | null;
    paymentMethodNameKnownRegexId: PaymentMethodNameKnownRegex | null;
    conversionRate: number;
    conversionRateDate: string;
}

export enum PaymentMethodNameKnownRegex {
    All = "All",
    AllAmex = "AllAmex",
    AllVisa = "AllVisa",
    AllMastercard = "AllMastercard",
}

export interface CurrencyConversionOverrideRequest {
    currencyConversionOverrideId: number | null;
    conversionRateDate: string;
    fromCurrencyCode: string;
    toCurrencyCode: string;
    purchasePaymentMethodId: number | null;
    paymentMethodNameKnownRegexId: PaymentMethodNameKnownRegex | null;
    conversionRate: number;
}

export interface DeliveryOverride {
    delivType: DeliveryType | null;
    tktTypeRules: TicketTypeOverride | null;
    inHandAt: string | null;
}

export interface ValueTupleOfNullableIntegerAndNullableIntegerAndNullableGuidAndBoolean {
    item1: number | null;
    item2: number | null;
    item3: string | null;
    item4: boolean;
}

export interface PurchaseEventOverride {
    delivType: DeliveryType;
    vendorId: number | null;
}

export interface PurchaseOrderExportRequest {
    query: PurchaseOrderQuery;
    exportColumns: string[] | null;
}

export interface PurchaseOrderAggregationResponse {
    summary: PurchaseOrderAggregationSummary;
    byOriginalCurrency: PurchaseOrderCurrencyBreakdown[] | null;
    metadata: AggregationResponseMetadata;
}

export interface PurchaseOrderAggregationSummary {
    totalTickets: number;
    totalTicketGroups: number;
    totalCost: UiMoney | null;
    aggregatedUnitCost: UiMoney | null;
    totalPayment: UiMoney | null;
    totalConvertedPayment: UiMoney | null;
    averagePaymentConversionRate: number | null;
    outstandingBalance: UiMoney | null;
    currency: string;
    purchaseOrderCount: number;
}

export interface PurchaseOrderCurrencyBreakdown {
    currency: string;
    documentCount: number;
    summary: PurchaseOrderAggregationSummary;
}

export interface MultiCurrencyAggregationRequestOfPurchaseOrderSearchRequestV2AndPurchaseOrderFilterQueryV2 {
    request: PurchaseOrderSearchRequestV2;
    targetCurrency: string;
    includeCurrencyBreakdown: boolean;
}

export interface OpenSearchRequestOfPurchaseOrderFilterQueryV2 {
    filter: PurchaseOrderFilterQueryV2;
    options: SearchOptions | null;
    allowedFields: string[] | null;
    appliedSecurityFilters: string[] | null;
    dataIsolationContext: { [key: string]: any; } | null;
}

export interface PurchaseOrderSearchRequestV2 extends OpenSearchRequestOfPurchaseOrderFilterQueryV2 {
}

export interface PurchaseOrderFilterQueryV2 {
    eventIds: FieldFilter | null;
    eventDates: FieldFilter | null;
    eventTimeFrameFilters: FieldFilter | null;
    clientTimezoneOffsetMins: number | null;
    eventStatuses: FieldFilter | null;
    topLevelCategories: FieldFilter | null;
    parentCategories: FieldFilter | null;
    eventOrMappingIds: FieldFilter | null;
    oldPosEventIds: FieldFilter | null;
    performerIds: FieldFilter | null;
    venueIds: FieldFilter | null;
    countryCodes: FieldFilter | null;
    stateProvinceIds: FieldFilter | null;
    cityIds: FieldFilter | null;
    purchaseOrderIds: FieldFilter | null;
    ticketGroupIds: FieldFilter | null;
    purchaseVendorIds: FieldFilter | null;
    purchaseVendorAccountIds: FieldFilter | null;
    purchaseVendorOrderIds: FieldFilter | null;
    purchaseBuyerIds: FieldFilter | null;
    purchaseInsertByIds: FieldFilter | null;
    purchaseDates: FieldFilter | null;
    purchaseCommissionUserIds: FieldFilter | null;
    orBuyerUserId: FieldFilter | null;
    orBuyerUserIds: FieldFilter | null;
    paymentDates: FieldFilter | null;
    paymentStatuses: FieldFilter | null;
    paymentMethodTypes: FieldFilter | null;
    paymentMethodUsedIds: FieldFilter | null;
    paymentCurrencyCodes: FieldFilter | null;
    deliveryTypes: FieldFilter | null;
    purchaseOrderStates: FieldFilter | null;
    isConsignment: FieldFilter | null;
    totalCost: FieldFilter | null;
    unitCosts: FieldFilter | null;
    currencyCodes: FieldFilter | null;
    internalNotes: FieldFilter | null;
    tagPairs: TagPairFilter | null;
    eventTagPairs: TagPairFilter | null;
    and: PurchaseOrderFilterQueryV2[] | null;
    or: PurchaseOrderFilterQueryV2[] | null;
    not: boolean;
}

export interface SecurePurchaseOrdersSearchMappedResult {
    purchaseOrders: PurchaseOrderTicketGroup[];
    total: number;
    took: number;
    maxScore: number | null;
    timedOut: boolean;
    appliedSecurityFilters: string[] | null;
    allowedFieldCount: number;
    aggregations: { [key: string]: AggregationResult; } | null;
    pitId: string | null;
    searchAfter: any[] | null;
    hasNextPage: boolean;
    sortedItemIds: number[] | null;
}

export interface ReachProSupportCaseInboxResponse {
    items: ReachProSupportCaseResponse[];
    hasMore: boolean;
}

export interface ReachProSupportCaseResponse {
    workItemId: number;
    eventId: number | null;
    stubHubListingId: number | null;
    stubHubSaleId: number | null;
    topic: string | null;
    lastMessageSnippet: string | null;
    lastMessageTimestamp: string | null;
    createDate: string;
    eventName: string | null;
    eventStartDate: string | null;
    venueName: string | null;
    venueCity: string | null;
}

export interface ReachProSupportCaseLookupResponse {
    workItemId: number | null;
}

export interface ReachProSupportCaseNoteResponse {
    workItemNoteId: number | null;
    workItemId: number;
    messageContent: string;
    senderName: string;
    timestamp: string;
    isSent: boolean;
}

export interface ReachProSupportCaseAttachmentResponse {
    noteId: number;
    documentId: string;
    fileName: string;
    isImage: boolean;
}

export interface ReportAssistantChatRequest {
    message: string;
    conversationId: string;
    history: ConversationTurn[];
}

export interface ConversationTurn {
    role: string;
    content: string;
}

export interface ReportConfigOfListingQueryAndReportWidgetTypesInventory {
    schemaVersion: string;
    reportName: string;
    groupBy: ReportGroupBy;
    widgets: ReportWidgetTypesInventory[] | null;
    metrics: string[];
    filter: ListingQuery | null;
    hiddenFilterItemIds: string[] | null;
    viewableFilterItemIds: string[] | null;
    editableFilterItemIds: string[] | null;
    numberOfItemsPerPage: number | null;
    sortBy: string | null;
    isSortDescending: boolean | null;
    arAgingTimeBuckets: DateTimeRangeWithRelative[] | null;
    reportId: number | null;
    reportIdRedirect: number | null;
    ownerDisplayName: string | null;
    isOwner: boolean;
    globalReportTypeId: number | null;
    allowReaderEditMetrics: boolean;
    roleIdsToShare: number[];
    sellerUserIdsToShare: string[];
    hasMetricsOverride: boolean | null;
    hasFilterOverride: boolean | null;
}

export enum ReportGroupBy {
    Performer = "Performer",
    Event = "Event",
    Venue = "Venue",
    EventGenre = "EventGenre",
    EventCountry = "EventCountry",
    EventCity = "EventCity",
    SeatingSection = "SeatingSection",
    SeatingRow = "SeatingRow",
    SaleMarketplace = "SaleMarketplace",
    SaleMonth = "SaleMonth",
    SaleWeek = "SaleWeek",
    SaleDay = "SaleDay",
    SaleId = "SaleId",
    ListingId = "ListingId",
    PurchaseId = "PurchaseId",
    PurchasedBy = "PurchasedBy",
    PricedBy = "PricedBy",
    FulfilledBy = "FulfilledBy",
    Vendor = "Vendor",
    SaleIdTicketIdCommissionUser = "SaleIdTicketIdCommissionUser",
    ArAgingMarketplace = "ArAgingMarketplace",
}

export enum ReportWidgetTypesInventory {
    TicketsListedAndSold = "TicketsListedAndSold",
    SalesAndMargin = "SalesAndMargin",
    AverageTicketPrice = "AverageTicketPrice",
}

export interface ReportConfigOverrideOfListingQuery {
    schemaVersion: string;
    metrics: string[] | null;
    filter: ListingQuery | null;
}

export interface ReportConfigOfSaleQueryAndReportWidgetTypesNone {
    schemaVersion: string;
    reportName: string;
    groupBy: ReportGroupBy;
    widgets: ReportWidgetTypesNone[] | null;
    metrics: string[];
    filter: SaleQuery | null;
    hiddenFilterItemIds: string[] | null;
    viewableFilterItemIds: string[] | null;
    editableFilterItemIds: string[] | null;
    numberOfItemsPerPage: number | null;
    sortBy: string | null;
    isSortDescending: boolean | null;
    arAgingTimeBuckets: DateTimeRangeWithRelative[] | null;
    reportId: number | null;
    reportIdRedirect: number | null;
    ownerDisplayName: string | null;
    isOwner: boolean;
    globalReportTypeId: number | null;
    allowReaderEditMetrics: boolean;
    roleIdsToShare: number[];
    sellerUserIdsToShare: string[];
    hasMetricsOverride: boolean | null;
    hasFilterOverride: boolean | null;
}

export enum ReportWidgetTypesNone {
    None = "None",
}

export interface ReportConfigOverrideOfSaleQuery {
    schemaVersion: string;
    metrics: string[] | null;
    filter: SaleQuery | null;
}

export interface ListingReportMetricsResponse {
    metrics: ListingReportMetrics[];
    summary: ListingReportMetrics;
    totalCount: number;
    hasTimeout: boolean;
    hasUnknownError: boolean;
}

export interface ReportMetricsBase {
    perfId: number | null;
    venueId: number | null;
    eventId: string | null;
    genre: TopLevelCategory | null;
    country: Country | null;
    city: string | null;
    section: string | null;
    row: string | null;
    seatFr: string | null;
    seatTo: string | null;
    tags: ReportTag[];
    eventTags: ReportTag[];
    posEventIds: string[];
}

export interface ListingReportMetrics extends ReportMetricsBase {
    listId: number | null;
    tktQty: number;
    availQty: number;
    soldQty: number;
    currency: string;
    ttlCst: UiMoney;
    ttlListPrc: UiMoney;
    ttlWebPrc: UiMoney;
    soldCst: UiMoney;
    soldProcs: UiMoney;
    unsoldCst: UiMoney;
    pandL: UiMoney;
    marg: number | null;
    delivType: DeliveryType | null;
    inHandDate: string | null;
    poInfos: PurchaseInfosReport;
    zone: string | null;
    pricerId: string | null;
    sales: SaleInfoReport[];
    holds: SaleInfoReport[];
    privNotes: string | null;
}

export interface PurchaseInfosReportBase {
    createdBys: string[];
    poIds: number[];
    tktGrIds: number[];
    buyers: PurchaseBuyerInfo[];
    vendors: PurchaseVendorInfo[];
    vendorAccs: PurchaseVendorAccountInfo[];
}

export interface PurchaseInfosReport extends PurchaseInfosReportBase {
    poDates: string[];
    pmtStatuses: PurchasePaymentStatus[];
    pmtMethods: PurchasePaymentMethodType[];
    privNotes: string[];
    vendOrdIds: string[];
    cancDates: string[];
}

export interface PurchaseBuyerInfo {
    buyerUserId: string;
    averageBuyerCommissionPercent: number | null;
}

export interface PurchaseVendorInfo {
    vendorId: number;
    vendorName: string;
}

export interface PurchaseVendorAccountInfo {
    vendorAccountId: string;
    vendorId: number;
    vendorAccountName: string;
    encryptedEmailAddress: string;
}

export interface SaleInfoReport {
    saleId: number;
    pmtState: PointOfSalePaymentState | null;
    mkpPmtState: MarketplacePaymentState | null;
    chargs: UiMoney | null;
    creds: UiMoney | null;
    fulfillerId: string | null;
    ttlNetProcs: UiMoney;
    qtySold: number;
    soldCst: UiMoney | null;
    status: PointOfSaleSaleStatus;
}

export interface ReportTag {
    key: string;
    value: string;
    valueType: TagsValueType | null;
}

export interface ListingReportMetricsRequest {
    query: ListingQuery;
    groupBy: ReportGroupBy;
    globalReportTypeId: number | null;
    isUsingFilterOverride: boolean | null;
    listingReportMetricsRequested: ListingReportMetricColumn[];
}

export enum ListingReportMetricColumn {
    Zone = "Zone",
}

export interface SaleReportMetricsResponse {
    metrics: SaleReportMetrics[];
    summary: SaleReportMetrics;
    totalCount: number;
    hasTimeout: boolean;
    hasUnknownError: boolean;
}

export interface SaleReportMetrics extends ReportMetricsBase {
    saleDate: string | null;
    mkp: Marketplace | null;
    saleId: number | null;
    ticketId: number | null;
    tktGrId: number | null;
    mkpSaleId: string | null;
    timeBkt: DateTimeRangeWithRelative | null;
    mkpPmtTerm: MarketplacePaymentTerm | null;
    qtySold: number;
    currency: string;
    netProcs: UiMoney;
    ttlOutsBal: UiMoney;
    soldCst: UiMoney;
    commssionShr: UiMoney | null;
    commission: BuyerCommission | null;
    pandL: UiMoney;
    marg: number | null;
    chargs: UiMoney;
    creds: UiMoney;
    saleStatus: PointOfSaleSaleStatus | null;
    ticketType: TicketType | null;
    inHandDate: string | null;
    pmtState: PointOfSalePaymentState | null;
    mkpPmtState: MarketplacePaymentState | null;
    pmtRcv: boolean | null;
    pmtRefId: string | null;
    lastPmtOn: string | null;
    cancelDate: string | null;
    allocState: PointOfSaleAllocationState | null;
    fulfillerId: string | null;
    fulfillDate: string | null;
    pricerId: string | null;
    poInfos: PurchaseInfosReport;
    privNotes: string | null;
}

export interface BuyerCommission {
    buyerUserId: string;
    commissionPercentage: number | null;
}

export enum PointOfSaleAllocationState {
    Pending = "Pending",
    Allocated = "Allocated",
    TicketsUnavailable = "TicketsUnavailable",
    AlternativeTicketsOffered = "AlternativeTicketsOffered",
    BlockingAllocation = "BlockingAllocation",
    AutoSourced = "AutoSourced",
}

export interface SaleReportMetricsRequest {
    query: SaleQuery;
    groupBy: ReportGroupBy;
    globalReportTypeId: number | null;
    isUsingFilterOverride: boolean | null;
    arAgingTimeBuckets: DateTimeRangeWithRelative[] | null;
}

export interface ReportSnapshotInfo {
    name: string;
    createdDate: string;
    documentId: string;
    downloadUri: string;
}

export interface SaleReportMetricsDownloadRequest extends SaleReportMetricsRequest {
    metrics: string[] | null;
    fileType: ReportFileType;
}

export enum ReportFileType {
    CSV = "CSV",
    XLSX = "XLSX",
    PDF = "PDF",
}

export interface ListingReportMetricsDownloadRequest extends ListingReportMetricsRequest {
    metrics: string[] | null;
    fileType: ReportFileType;
}

export interface ReportV2ConfigOfInventoryReportV2RequestAndReportWidgetTypesInventory {
    schemaVersion: string;
    reportName: string;
    widgets: ReportWidgetTypesInventory[] | null;
    request: InventoryReportV2Request;
    reportId: number | null;
    ownerDisplayName: string | null;
    isOwner: boolean;
    globalReportTypeId: number | null;
    roleIdsToShare: number[];
    sellerUserIdsToShare: string[];
    hasMetricsOverride: boolean | null;
    hiddenFilterItemIds: string[] | null;
    viewableFilterItemIds: string[] | null;
    editableFilterItemIds: string[] | null;
    requiredRowGroupingNames: string[] | null;
    livePagePath: string | null;
    lastRefreshTime: string | null;
    originReportId: number | null;
}

export interface ReportBaseRequestOfUIReportV2ListingQuery {
    rowGroupings: ReportColumn[] | null;
    columnGroupings: ReportColumn[] | null;
    aggregations: ReportColumn[] | null;
    orderBy: string | null;
    orderByAsc: boolean;
    pageNumber: number;
    filters: UIReportV2ListingQuery;
    snapshotTime: string | null;
    useAccountCurrency: boolean | null;
    metadata: ReportRequestMetadata | null;
    useRealtimeQuery: boolean | null;
}

export interface InventoryReportV2Request extends ReportBaseRequestOfUIReportV2ListingQuery {
}

export interface ReportColumn {
    columnName: string;
    columnValue: string;
}

export interface ReportEntityWithTicketsQuery {
    performerIds: number[] | null;
    venueIds: number[] | null;
    countryCodes: string[] | null;
    stateProvinceIds: number[] | null;
    cityIds: number[] | null;
    officeIds: number[] | null;
    purchaseOrderId: number | null;
    purchaseVendorId: number | null;
    vendorAccessControlProviderId: number | null;
    purchaseVendorAccountIds: string[] | null;
    purchaseVendorOrderId: string | null;
    purchaseBuyerId: string | null;
    purchaseOrderCreatedBy: string | null;
    purchaseCommissionUserId: string | null;
    purchaseDates: DateTimeRangeWithRelative | null;
    inHandDates: DateTimeRangeWithRelative | null;
    eventTimeFrameFilter: EventTimeFrameFilter | null;
    sections: string[] | null;
    rows: string[] | null;
    sectionContains: string | null;
    sectionEquals: string | null;
    sectionNotContains: string | null;
    rowContains: string | null;
    rowEquals: string | null;
    rowNotContains: string | null;
    isSeatSaver: boolean | null;
    eventDates: DateTimeRangeWithRelative | null;
    noSaleDates: DateTimeRangeWithRelative | null;
    tagName: string | null;
    tagValue: string | null;
    eventTagName: string | null;
    eventTagValue: string | null;
    lastSaleDates: DateTimeRangeWithRelative | null;
    eventNotReviewedSinceDate: DateTimeRangeWithRelative | null;
    eventUnpricedStatus: number | null;
    numberOfTicketsHeld: NumericRange | null;
    topLevelCategories: TopLevelCategory[] | null;
    parentCategories: number[] | null;
    internalNotes: string | null;
    internalNotesContains: string | null;
    internalNotesEquals: string | null;
    internalNotesNotContains: string | null;
    timezoneOffsetMins: number | null;
    currencyCode: string | null;
    currencyCodes: string[] | null;
    eventStatuses: ApiEventStatus[] | null;
    eventHasUnsoldTickets: boolean | null;
    purchaseCancellationDates: DateTimeRangeWithRelative | null;
    isParking: boolean | null;
    listingIdContains: string | null;
    saleIdContains: string | null;
    marketplaceSaleIdContains: string | null;
    purchaseOrderIdContains: string | null;
    vendorOrderIdContains: string | null;
}

export interface ReportV2ListingQuery extends ReportEntityWithTicketsQuery {
    isPredelivered: boolean | null;
    preDeliveryStates: PreDeliveryState[] | null;
    isNoFulfill: boolean | null;
    lastPriceUpdateDates: DateTimeRangeWithRelative | null;
    isPricedByMarketplace: boolean | null;
    isAutoPricingEnabled: boolean | null;
    isListed: boolean | null;
    isMapped: boolean | null;
    isDuplicate: boolean | null;
    isSeatingUnmapped: boolean | null;
    isAdminHold: boolean | null;
    pricerSellerUserId: string | null;
    purchaseCancelledOnly: boolean | null;
    hasUnsoldTickets: boolean | null;
    autoPricingResultTypes: AutoPricingResultType[] | null;
    isPricedAboveZero: boolean | null;
    hasBroadcastError: boolean | null;
    isPendingProof: boolean | null;
    deliveryType: DeliveryType | null;
    ticketType: TicketType | null;
    purchaseInsertBy: string | null;
}

export interface UIReportV2ListingQuery extends ReportV2ListingQuery {
    viewMode: InventoryViewMode | null;
    isSortDescending: boolean | null;
}

export interface ReportRequestMetadata {
    reportConfigId: number | null;
    hubConnectionId: string | null;
}

export interface ReportV2ConfigOfSalesReportV2RequestAndReportWidgetTypesNone {
    schemaVersion: string;
    reportName: string;
    widgets: ReportWidgetTypesNone[] | null;
    request: SalesReportV2Request;
    reportId: number | null;
    ownerDisplayName: string | null;
    isOwner: boolean;
    globalReportTypeId: number | null;
    roleIdsToShare: number[];
    sellerUserIdsToShare: string[];
    hasMetricsOverride: boolean | null;
    hiddenFilterItemIds: string[] | null;
    viewableFilterItemIds: string[] | null;
    editableFilterItemIds: string[] | null;
    requiredRowGroupingNames: string[] | null;
    livePagePath: string | null;
    lastRefreshTime: string | null;
    originReportId: number | null;
}

export interface ReportBaseRequestOfUIReportV2SaleQuery {
    rowGroupings: ReportColumn[] | null;
    columnGroupings: ReportColumn[] | null;
    aggregations: ReportColumn[] | null;
    orderBy: string | null;
    orderByAsc: boolean;
    pageNumber: number;
    filters: UIReportV2SaleQuery;
    snapshotTime: string | null;
    useAccountCurrency: boolean | null;
    metadata: ReportRequestMetadata | null;
    useRealtimeQuery: boolean | null;
}

export interface SalesReportV2Request extends ReportBaseRequestOfUIReportV2SaleQuery {
}

export interface ReportV2SaleQuery extends ReportEntityWithTicketsQuery {
    isNoFulfill: boolean | null;
    saleDates: DateTimeRangeWithRelative | null;
    saleStatuses: PointOfSaleSaleStatus[] | null;
    soldOnMarketplace: Marketplace | null;
    cancellationDates: DateTimeRangeWithRelative | null;
    fulfillerSellerUserId: string | null;
    fulfillmentDates: DateTimeRangeWithRelative | null;
    paymentDates: DateTimeRangeWithRelative | null;
    marketplacePaymentState: MarketplacePaymentState | null;
    paymentReferenceId: string | null;
    listingInsertBy: string | null;
    dayOfWeek: number | null;
    quantityWasted: NumericRange | null;
    insertBy: string | null;
    listingNoteIds: number[] | null;
    originatedFromListingIdContains: string | null;
    seatContains: string | null;
    listingTagName: string | null;
    listingTagValue: string | null;
    purchaseOrderTagName: string | null;
    purchaseOrderTagValue: string | null;
    originatedFromListingTagName: string | null;
    originatedFromListingTagValue: string | null;
    ticketType: TicketType | null;
    pricerSellerUserId: string | null;
    totalCostLow: number | null;
    totalCostHigh: number | null;
}

export interface UIReportV2SaleQuery extends ReportV2SaleQuery {
    viewMode: InventoryViewMode | null;
    isSortDescending: boolean | null;
}

export interface ReportV2ConfigOfPurchaseReportV2RequestAndReportWidgetTypesNone {
    schemaVersion: string;
    reportName: string;
    widgets: ReportWidgetTypesNone[] | null;
    request: PurchaseReportV2Request;
    reportId: number | null;
    ownerDisplayName: string | null;
    isOwner: boolean;
    globalReportTypeId: number | null;
    roleIdsToShare: number[];
    sellerUserIdsToShare: string[];
    hasMetricsOverride: boolean | null;
    hiddenFilterItemIds: string[] | null;
    viewableFilterItemIds: string[] | null;
    editableFilterItemIds: string[] | null;
    requiredRowGroupingNames: string[] | null;
    livePagePath: string | null;
    lastRefreshTime: string | null;
    originReportId: number | null;
}

export interface ReportBaseRequestOfUIReportV2PurchaseQuery {
    rowGroupings: ReportColumn[] | null;
    columnGroupings: ReportColumn[] | null;
    aggregations: ReportColumn[] | null;
    orderBy: string | null;
    orderByAsc: boolean;
    pageNumber: number;
    filters: UIReportV2PurchaseQuery;
    snapshotTime: string | null;
    useAccountCurrency: boolean | null;
    metadata: ReportRequestMetadata | null;
    useRealtimeQuery: boolean | null;
}

export interface PurchaseReportV2Request extends ReportBaseRequestOfUIReportV2PurchaseQuery {
}

export interface ReportV2PurchaseQuery extends ReportEntityWithTicketsQuery {
    paymentMethod: PurchasePaymentMethodType | null;
    paymentStatus: PurchasePaymentStatus | null;
    purchaseOrderState: PurchaseOrderState | null;
}

export interface UIReportV2PurchaseQuery extends ReportV2PurchaseQuery {
    viewMode: InventoryViewMode | null;
    isSortDescending: boolean | null;
}

export interface ReportV2ConfigOfSaleLineItemReportV2RequestAndReportWidgetTypesNone {
    schemaVersion: string;
    reportName: string;
    widgets: ReportWidgetTypesNone[] | null;
    request: SaleLineItemReportV2Request;
    reportId: number | null;
    ownerDisplayName: string | null;
    isOwner: boolean;
    globalReportTypeId: number | null;
    roleIdsToShare: number[];
    sellerUserIdsToShare: string[];
    hasMetricsOverride: boolean | null;
    hiddenFilterItemIds: string[] | null;
    viewableFilterItemIds: string[] | null;
    editableFilterItemIds: string[] | null;
    requiredRowGroupingNames: string[] | null;
    livePagePath: string | null;
    lastRefreshTime: string | null;
    originReportId: number | null;
}

export interface ReportBaseRequestOfUIReportV2SaleLineItemQuery {
    rowGroupings: ReportColumn[] | null;
    columnGroupings: ReportColumn[] | null;
    aggregations: ReportColumn[] | null;
    orderBy: string | null;
    orderByAsc: boolean;
    pageNumber: number;
    filters: UIReportV2SaleLineItemQuery;
    snapshotTime: string | null;
    useAccountCurrency: boolean | null;
    metadata: ReportRequestMetadata | null;
    useRealtimeQuery: boolean | null;
}

export interface SaleLineItemReportV2Request extends ReportBaseRequestOfUIReportV2SaleLineItemQuery {
}

export interface ReportV2SaleLineItemQuery extends ReportEntityWithTicketsQuery {
    isNoFulfill: boolean | null;
    saleDates: DateTimeRangeWithRelative | null;
    saleStatuses: PointOfSaleSaleStatus[] | null;
    soldOnMarketplace: Marketplace | null;
    cancellationDates: DateTimeRangeWithRelative | null;
    fulfillerSellerUserId: string | null;
    fulfillmentDates: DateTimeRangeWithRelative | null;
    paymentDates: DateTimeRangeWithRelative | null;
    marketplacePaymentState: MarketplacePaymentState | null;
    paymentReferenceId: string | null;
    listingInsertBy: string | null;
    dayOfWeek: number | null;
    quantityWasted: NumericRange | null;
    insertBy: string | null;
    listingNoteIds: number[] | null;
    originatedFromListingIdContains: string | null;
    seatContains: string | null;
    ticketType: TicketType | null;
    pricerSellerUserId: string | null;
    totalCostLow: number | null;
    totalCostHigh: number | null;
    costDates: DateTimeRangeWithRelative | null;
    saleCostTypeId: SaleCostType | null;
    paymentReceived: boolean | null;
}

export interface UIReportV2SaleLineItemQuery extends ReportV2SaleLineItemQuery {
    viewMode: InventoryViewMode | null;
    isSortDescending: boolean | null;
}

export interface ReportV2ConfigOfPurchaseOrderLineItemReportV2RequestAndReportWidgetTypesNone {
    schemaVersion: string;
    reportName: string;
    widgets: ReportWidgetTypesNone[] | null;
    request: PurchaseOrderLineItemReportV2Request;
    reportId: number | null;
    ownerDisplayName: string | null;
    isOwner: boolean;
    globalReportTypeId: number | null;
    roleIdsToShare: number[];
    sellerUserIdsToShare: string[];
    hasMetricsOverride: boolean | null;
    hiddenFilterItemIds: string[] | null;
    viewableFilterItemIds: string[] | null;
    editableFilterItemIds: string[] | null;
    requiredRowGroupingNames: string[] | null;
    livePagePath: string | null;
    lastRefreshTime: string | null;
    originReportId: number | null;
}

export interface ReportBaseRequestOfUIReportV2PurchaseOrderLineItemQuery {
    rowGroupings: ReportColumn[] | null;
    columnGroupings: ReportColumn[] | null;
    aggregations: ReportColumn[] | null;
    orderBy: string | null;
    orderByAsc: boolean;
    pageNumber: number;
    filters: UIReportV2PurchaseOrderLineItemQuery;
    snapshotTime: string | null;
    useAccountCurrency: boolean | null;
    metadata: ReportRequestMetadata | null;
    useRealtimeQuery: boolean | null;
}

export interface PurchaseOrderLineItemReportV2Request extends ReportBaseRequestOfUIReportV2PurchaseOrderLineItemQuery {
}

export interface ReportV2PurchaseOrderLineItemQuery extends ReportEntityWithTicketsQuery {
    purchaseOrderCostTypeId: number | null;
    purchaseOrderState: PurchaseOrderState | null;
    purchasePaymentStatus: PurchasePaymentStatus | null;
}

export interface UIReportV2PurchaseOrderLineItemQuery extends ReportV2PurchaseOrderLineItemQuery {
    viewMode: InventoryViewMode | null;
    isSortDescending: boolean | null;
}

export interface ReportV2ConfigOfSoldTicketReportV2RequestAndReportWidgetTypesNone {
    schemaVersion: string;
    reportName: string;
    widgets: ReportWidgetTypesNone[] | null;
    request: SoldTicketReportV2Request;
    reportId: number | null;
    ownerDisplayName: string | null;
    isOwner: boolean;
    globalReportTypeId: number | null;
    roleIdsToShare: number[];
    sellerUserIdsToShare: string[];
    hasMetricsOverride: boolean | null;
    hiddenFilterItemIds: string[] | null;
    viewableFilterItemIds: string[] | null;
    editableFilterItemIds: string[] | null;
    requiredRowGroupingNames: string[] | null;
    livePagePath: string | null;
    lastRefreshTime: string | null;
    originReportId: number | null;
}

export interface ReportBaseRequestOfUIReportV2SoldTicketQuery {
    rowGroupings: ReportColumn[] | null;
    columnGroupings: ReportColumn[] | null;
    aggregations: ReportColumn[] | null;
    orderBy: string | null;
    orderByAsc: boolean;
    pageNumber: number;
    filters: UIReportV2SoldTicketQuery;
    snapshotTime: string | null;
    useAccountCurrency: boolean | null;
    metadata: ReportRequestMetadata | null;
    useRealtimeQuery: boolean | null;
}

export interface SoldTicketReportV2Request extends ReportBaseRequestOfUIReportV2SoldTicketQuery {
}

export interface ReportV2SoldTicketQuery extends ReportEntityWithTicketsQuery {
    isNoFulfill: boolean | null;
    saleDates: DateTimeRangeWithRelative | null;
    saleStatuses: PointOfSaleSaleStatus[] | null;
    soldOnMarketplace: Marketplace | null;
    cancellationDates: DateTimeRangeWithRelative | null;
    fulfillerSellerUserId: string | null;
    fulfillmentDates: DateTimeRangeWithRelative | null;
    paymentDates: DateTimeRangeWithRelative | null;
    marketplacePaymentState: MarketplacePaymentState | null;
    dayOfWeek: number | null;
}

export interface UIReportV2SoldTicketQuery extends ReportV2SoldTicketQuery {
    viewMode: InventoryViewMode | null;
    isSortDescending: boolean | null;
}

export interface ReportV2ConfigOfCommissionReportV2RequestAndReportWidgetTypesNone {
    schemaVersion: string;
    reportName: string;
    widgets: ReportWidgetTypesNone[] | null;
    request: CommissionReportV2Request;
    reportId: number | null;
    ownerDisplayName: string | null;
    isOwner: boolean;
    globalReportTypeId: number | null;
    roleIdsToShare: number[];
    sellerUserIdsToShare: string[];
    hasMetricsOverride: boolean | null;
    hiddenFilterItemIds: string[] | null;
    viewableFilterItemIds: string[] | null;
    editableFilterItemIds: string[] | null;
    requiredRowGroupingNames: string[] | null;
    livePagePath: string | null;
    lastRefreshTime: string | null;
    originReportId: number | null;
}

export interface ReportBaseRequestOfUIReportCommissionQuery {
    rowGroupings: ReportColumn[] | null;
    columnGroupings: ReportColumn[] | null;
    aggregations: ReportColumn[] | null;
    orderBy: string | null;
    orderByAsc: boolean;
    pageNumber: number;
    filters: UIReportCommissionQuery;
    snapshotTime: string | null;
    useAccountCurrency: boolean | null;
    metadata: ReportRequestMetadata | null;
    useRealtimeQuery: boolean | null;
}

export interface CommissionReportV2Request extends ReportBaseRequestOfUIReportCommissionQuery {
}

export interface ReportCommissionQuery {
    eventDates: DateTimeRangeWithRelative | null;
    eventTimeFrameFilter: EventTimeFrameFilter | null;
    saleDates: DateTimeRangeWithRelative | null;
    saleStatuses: PointOfSaleSaleStatus[] | null;
    soldOnMarketplace: Marketplace | null;
    paymentDates: DateTimeRangeWithRelative | null;
    fulfillmentDates: DateTimeRangeWithRelative | null;
    purchaseCommissionUserId: string | null;
    isCommissionEligible: boolean | null;
    commissionEligibilityDates: DateTimeRangeWithRelative | null;
    timezoneOffsetMins: number | null;
}

export interface UIReportCommissionQuery extends ReportCommissionQuery {
    viewMode: InventoryViewMode | null;
    isSortDescending: boolean | null;
}

export interface ReportV2ConfigOfCostOfGoodsSoldReportV2RequestAndReportWidgetTypesNone {
    schemaVersion: string;
    reportName: string;
    widgets: ReportWidgetTypesNone[] | null;
    request: CostOfGoodsSoldReportV2Request;
    reportId: number | null;
    ownerDisplayName: string | null;
    isOwner: boolean;
    globalReportTypeId: number | null;
    roleIdsToShare: number[];
    sellerUserIdsToShare: string[];
    hasMetricsOverride: boolean | null;
    hiddenFilterItemIds: string[] | null;
    viewableFilterItemIds: string[] | null;
    editableFilterItemIds: string[] | null;
    requiredRowGroupingNames: string[] | null;
    livePagePath: string | null;
    lastRefreshTime: string | null;
    originReportId: number | null;
}

export interface ReportBaseRequestOfUIReportV2CostOfGoodsSoldQuery {
    rowGroupings: ReportColumn[] | null;
    columnGroupings: ReportColumn[] | null;
    aggregations: ReportColumn[] | null;
    orderBy: string | null;
    orderByAsc: boolean;
    pageNumber: number;
    filters: UIReportV2CostOfGoodsSoldQuery;
    snapshotTime: string | null;
    useAccountCurrency: boolean | null;
    metadata: ReportRequestMetadata | null;
    useRealtimeQuery: boolean | null;
}

export interface CostOfGoodsSoldReportV2Request extends ReportBaseRequestOfUIReportV2CostOfGoodsSoldQuery {
}

export interface ReportV2CostOfGoodsSoldQuery extends ReportEntityWithTicketsQuery {
    adjustmentsSinceDate: DateTimeRangeWithRelative | null;
    adjustmentType: string | null;
    isActive: boolean | null;
}

export interface UIReportV2CostOfGoodsSoldQuery extends ReportV2CostOfGoodsSoldQuery {
    viewMode: InventoryViewMode | null;
    isSortDescending: boolean | null;
}

export interface ReportV2ConfigOfSaleTotalCostAdjustmentReportV2RequestAndReportWidgetTypesNone {
    schemaVersion: string;
    reportName: string;
    widgets: ReportWidgetTypesNone[] | null;
    request: SaleTotalCostAdjustmentReportV2Request;
    reportId: number | null;
    ownerDisplayName: string | null;
    isOwner: boolean;
    globalReportTypeId: number | null;
    roleIdsToShare: number[];
    sellerUserIdsToShare: string[];
    hasMetricsOverride: boolean | null;
    hiddenFilterItemIds: string[] | null;
    viewableFilterItemIds: string[] | null;
    editableFilterItemIds: string[] | null;
    requiredRowGroupingNames: string[] | null;
    livePagePath: string | null;
    lastRefreshTime: string | null;
    originReportId: number | null;
}

export interface ReportBaseRequestOfUIReportV2SaleTotalCostAdjustmentsQuery {
    rowGroupings: ReportColumn[] | null;
    columnGroupings: ReportColumn[] | null;
    aggregations: ReportColumn[] | null;
    orderBy: string | null;
    orderByAsc: boolean;
    pageNumber: number;
    filters: UIReportV2SaleTotalCostAdjustmentsQuery;
    snapshotTime: string | null;
    useAccountCurrency: boolean | null;
    metadata: ReportRequestMetadata | null;
    useRealtimeQuery: boolean | null;
}

export interface SaleTotalCostAdjustmentReportV2Request extends ReportBaseRequestOfUIReportV2SaleTotalCostAdjustmentsQuery {
}

export interface ReportV2SaleTotalCostAdjustmentsQuery extends ReportEntityWithTicketsQuery {
    adjustmentsSinceDate: DateTimeRangeWithRelative | null;
    adjustmentType: string | null;
}

export interface UIReportV2SaleTotalCostAdjustmentsQuery extends ReportV2SaleTotalCostAdjustmentsQuery {
    viewMode: InventoryViewMode | null;
    isSortDescending: boolean | null;
}

export interface ReportV2ConfigOfTicketGroupReportV2RequestAndReportWidgetTypesNone {
    schemaVersion: string;
    reportName: string;
    widgets: ReportWidgetTypesNone[] | null;
    request: TicketGroupReportV2Request;
    reportId: number | null;
    ownerDisplayName: string | null;
    isOwner: boolean;
    globalReportTypeId: number | null;
    roleIdsToShare: number[];
    sellerUserIdsToShare: string[];
    hasMetricsOverride: boolean | null;
    hiddenFilterItemIds: string[] | null;
    viewableFilterItemIds: string[] | null;
    editableFilterItemIds: string[] | null;
    requiredRowGroupingNames: string[] | null;
    livePagePath: string | null;
    lastRefreshTime: string | null;
    originReportId: number | null;
}

export interface ReportBaseRequestOfUIReportV2TicketGroupQuery {
    rowGroupings: ReportColumn[] | null;
    columnGroupings: ReportColumn[] | null;
    aggregations: ReportColumn[] | null;
    orderBy: string | null;
    orderByAsc: boolean;
    pageNumber: number;
    filters: UIReportV2TicketGroupQuery;
    snapshotTime: string | null;
    useAccountCurrency: boolean | null;
    metadata: ReportRequestMetadata | null;
    useRealtimeQuery: boolean | null;
}

export interface TicketGroupReportV2Request extends ReportBaseRequestOfUIReportV2TicketGroupQuery {
}

export interface ReportV2TicketGroupQuery extends ReportEntityWithTicketsQuery {
    paymentMethod: PurchasePaymentMethodType | null;
    paymentStatus: PurchasePaymentStatus | null;
    purchaseOrderState: PurchaseOrderState | null;
    isMapped: boolean | null;
    isConsignment: boolean | null;
    deliveryType: DeliveryType | null;
    ticketStatuses: string[] | null;
}

export interface UIReportV2TicketGroupQuery extends ReportV2TicketGroupQuery {
    viewMode: InventoryViewMode | null;
    isSortDescending: boolean | null;
}

export interface ReportV2ConfigOverride {
    schemaVersion: string;
    request: ReportOverrideRequest;
}

export interface ReportOverrideRequest {
    rowGroupings: ReportColumn[] | null;
    columnGroupings: ReportColumn[] | null;
    aggregations: ReportColumn[] | null;
}

export interface ReportMetricsV2 {
    rows: { [key: string]: any; }[];
    valueTypes: { [key: string]: ReportValueType; };
}

export enum ReportValueType {
    None = "None",
    Guid = "Guid",
    Integer = "Integer",
    Money = "Money",
    DateTime = "DateTime",
    String = "String",
    User = "User",
    Decimal = "Decimal",
    Boolean = "Boolean",
    DateTimeList = "DateTimeList",
    IntegerList = "IntegerList",
    GuidList = "GuidList",
    UserList = "UserList",
    StringList = "StringList",
    BooleanList = "BooleanList",
}

export interface ReportMetricsSummaryV2 {
    row: { [key: string]: any; };
    valueTypes: { [key: string]: ReportValueType; };
}

export interface FileExportResult {
    fileName: string | null;
    fileUri: string | null;
    errorMessage: string | null;
    isSuccess: boolean;
}

export interface FileExportProgress {
    percentage: number;
}

export interface BuyerDetailDto {
    buyerEmail: string;
    externalId: string | null;
    buyerName: string | null;
    buyerPhoneNumber: string | null;
    internalNotes: string | null;
    insertDate: string;
    updateDate: string;
    lastRetailActivityDate: string | null;
    billingAddress: GenericAddressDto | null;
    shippingAddress: GenericAddressDto | null;
    activePaymentMethod: BuyerPaymentMethodDto | null;
}

export interface GenericAddressDto {
    genericAddressId: number;
    addressLine1: string | null;
    addressLine2: string | null;
    city: string | null;
    state: string | null;
    zipCode: string | null;
    country: string | null;
}

export interface BuyerPaymentMethodDto {
    buyerPaymentMethodId: number;
    buyerEmail: string;
    paymentProvider: string | null;
    storedPaymentMethodId: string | null;
    shopperReference: string | null;
    cardBrand: string | null;
    cardSummary: string | null;
    expiryMonth: number | null;
    expiryYear: number | null;
    isDefault: boolean;
    isActive: boolean;
}

export interface PagedSellerBuyersWithSalesResult {
    totalCount: number;
    items: BuyerWithSalesDto[];
}

export interface BuyerWithPaymentMethodDto {
    buyerEmail: string;
    externalId: string | null;
    buyerName: string | null;
    buyerPhoneNumber: string | null;
    internalNotes: string | null;
    lastRetailActivityDate: string | null;
    billingAddressLine1: string | null;
    billingAddressLine2: string | null;
    billingCity: string | null;
    billingState: string | null;
    billingZipCode: string | null;
    billingCountry: string | null;
    shippingAddressLine1: string | null;
    shippingAddressLine2: string | null;
    shippingCity: string | null;
    shippingState: string | null;
    shippingZipCode: string | null;
    shippingCountry: string | null;
    cardBrand: string | null;
    cardSummary: string | null;
    expiryMonth: number | null;
    expiryYear: number | null;
    retailCreditBalance: number;
    creditCurrencyCode: string | null;
}

export interface BuyerWithSalesDto extends BuyerWithPaymentMethodDto {
    saleIds: number[] | null;
    salesGroupIds: string[] | null;
}

export enum SellerBuyersOrderBy {
    BuyerEmail = "BuyerEmail",
    BuyerName = "BuyerName",
    BuyerPhoneNumber = "BuyerPhoneNumber",
    LastRetailActivityDate = "LastRetailActivityDate",
}

export enum SortDirection {
    Ascending = "Ascending",
    Descending = "Descending",
}

export interface BuyerPaymentMethodsResponse {
    storedPaymentMethodId: string;
    cardBrand: string | null;
    cardSummary: string | null;
    expiryMonth: number | null;
    expiryYear: number | null;
    holderName: string | null;
    isDefault: boolean;
}

export interface BuyerUpsertDto {
    buyerEmail: string;
    buyerName: string | null;
    buyerPhoneNumber: string | null;
    internalNotes: string | null;
    lastRetailActivityDate: string | null;
    billingAddress: GenericAddressDto | null;
    shippingAddress: GenericAddressDto | null;
    externalId: string | null;
}

export interface BuyerCreditDto {
    buyerEmail: string;
    balance: number;
    currencyCode: string;
    notes: string | null;
    lastUpdateDate: string | null;
}

export interface AdjustBalanceResult {
    balance: number;
    currencyCode: string;
    lastUpdateDate: string;
}

export interface AdjustBuyerCreditInput {
    buyerEmail: string;
    delta: number;
    notes: string | null;
}

export interface EntitiesWithSummaryOfSale {
    items: Sale[];
    summary: Sale | null;
}

export interface EntitySearchResultOfIDictionaryOfStringAndEntitiesWithSummaryOfSaleWithCatalogData {
    entities: { [key: string]: EntitiesWithSummaryOfSaleWithCatalogData; };
    pitId: string | null;
    totalItemsCount: number | null;
    maxResultWindow: number | null;
    searchAfter: any[] | null;
    sortedGroupIds: string[] | null;
    sortedItemIds: number[] | null;
}

export interface EntitiesWithSummaryOfSaleWithCatalogData {
    items: SaleWithCatalogData[];
    summary: SaleWithCatalogData | null;
}

export interface SaleWithCatalogData extends Sale {
    entityCatalogData: EntityCatalogData | null;
}

export interface SaleQueryV2 extends SaleQuery {
    soldOnMarketplaces: Marketplace[] | null;
    marketplacePaymentStates: MarketplacePaymentState[] | null;
    ticketTypes: TicketType[] | null;
    fulfillerSellerUserIds: string[] | null;
    listingInsertBys: string[] | null;
    operations: SaleQueryOperations | null;
    searchOptions: UISearchOptions | null;
}

export interface SaleQueryOperations extends EntityWithTicketsQueryOperations {
    soldOnMarketplaceOp: FilterOperationType | null;
    saleStatusesOp: FilterOperationType | null;
    fulfillmentStatesOp: FilterOperationType | null;
    paymentStateOp: FilterOperationType | null;
    marketplacePaymentStateOp: FilterOperationType | null;
    paymentReceivedOp: FilterOperationType | null;
    paymentReferenceIdOp: FilterOperationType | null;
    paymentDatesOp: FilterOperationType | null;
    fulfillmentDatesOp: FilterOperationType | null;
    cancellationDatesOp: FilterOperationType | null;
    saleDatesOp: FilterOperationType | null;
    ticketTypeOp: FilterOperationType | null;
    fulfillerSellerUserIdOp: FilterOperationType | null;
    listingInsertByOp: FilterOperationType | null;
    isNoFulfillOp: FilterOperationType | null;
    unitCostHighOp: FilterOperationType | null;
    unitCostLowOp: FilterOperationType | null;
}

export interface ValueTupleOfIEnumerableOfSaleAndUInt64 {
    item1: Sale[];
    item2: number;
}

export interface SaleDetails extends Sale {
    salesGroupId: string | null;
    tickets: Ticket[];
    ticketGroupInfos: SaleTicketGroupInfo[];
    poInfos: UiPurchaseInfo[];
    isMarketplacePaymentLocked: boolean | null;
    transSrc: TicketTransferInfo[] | null;
    transDest: TicketTransferInfo | null;
    transferUrls: string[] | null;
    transferProofDocs: UserDocumentLinks[] | null;
    transferProofId: string | null;
    availArtTypes: ArtifactType[];
    lineItems: SaleLineItem[];
    mkpLines: MarketplaceSaleLineItem[];
    mkpLinesTotal: UiMoney;
    mkpSeating: Seating | null;
    mkpSaleTtlNetProcs: UiMoney | null;
    commissionOverride: Commission[] | null;
    purchaseOrderCommissions: PurchaseOrderCommissions[] | null;
    mkpPmtTerm: MarketplacePaymentTerm | null;
    showCrossOfficeAllocationWarning: boolean;
    supportsAutoPoManagedTransfer: boolean;
}

export interface PurchaseOrderInfo {
    purchaseOrderId: number;
    purchaseOrderDate: string | null;
    ticketGroupId: number;
    buyerCommissionPercent: number | null;
    ticketCount: number;
    buyerUserId: string | null;
    vendor: PurchaseVendorInfo | null;
    vendorAccount: PurchaseVendorAccountInfo | null;
    createdBy: string | null;
    internalNotes: string | null;
}

export interface SaleTicketGroupInfo extends PurchaseOrderInfo {
    seating: Seating;
    vendorOrderId: string | null;
}

export interface TicketTransferInfo {
    name: string;
    email: string;
    app: string | null;
    appId: number;
    phoneNumber: string | null;
}

export interface MarketplaceSaleLineItem {
    posPmtId: number;
    id: number;
    extPmtId: string;
    lineExtPmtId: string | null;
    extLineId: string;
    extSaleId: string;
    saleId: number | null;
    state: MarketplacePaymentState;
    date: string | null;
    recvDate: string | null;
    isCred: boolean;
    amt: UiMoney;
    type: MarketplacePaymentLineType;
    isLocked: boolean | null;
    pmtRefId: string | null;
    extPmtMethodType: ExternalPaymentMethodType | null;
    extPmtNote: string | null;
    extCustomPmtTypeName: string | null;
}

export interface PurchaseOrderCommissions {
    purchaseOrderId: number;
    orderId: string;
    commissions: Commission[];
}

export interface SalesGroupDetails {
    salesGroupId: string;
    salesGroupName: string;
    insertDate: string;
    sales: Sale[];
    aggregatedPaymentLines: MarketplaceSaleLineItem[];
    totalProceeds: UiMoney | null;
    currencyCode: string | null;
    subtotal: UiMoney | null;
    totalCost: UiMoney | null;
    totalPaymentReceived: UiMoney | null;
    unsettledPaymentAmount: number;
    balanceDue: UiMoney | null;
    pandL: UiMoney | null;
    ticketRows: SalesGroupTicketRow[];
    earningLines: SalesGroupEarningLine[];
    paymentTerm: MarketplacePaymentTerm | null;
    buyer: TicketTransferInfo | null;
}

export interface SalesGroupTicketRow {
    saleId: number;
    marketplaceSaleId: string | null;
    viagogoVirtualId: string | null;
    section: string | null;
    row: string | null;
    seats: string | null;
    qty: number;
    cost: UiMoney | null;
    proceed: UiMoney | null;
    poId: number | null;
    isCancelled: boolean;
}

export interface SalesGroupEarningLine {
    saleId: number;
    description: string | null;
    costType: SaleCostType;
    isCredit: boolean;
    amount: UiMoney | null;
}

export interface TicketTransferRequest {
    saleId: number;
    transferType: TransferTicketType;
    acceptanceUrls: string[] | null;
    uploadProofDocuments: UserDocument[] | null;
    transferProofId: string | null;
    barcodes: TicketBarcode[] | null;
}

export enum TransferTicketType {
    None = "None",
    ImageProof = "ImageProof",
    URL = "URL",
    IdProof = "IdProof",
    ApiTransferTicketmaster = "ApiTransferTicketmaster",
    ApiTransfer1Ticket = "ApiTransfer1Ticket",
    AutoPoManaged = "AutoPoManaged",
}

export interface SaleAvailableSeatings {
    hasMoreAllocations: boolean;
    possibleSeatings: SeatingForAlloc[];
}

export interface SeatingForAlloc extends Seating {
    tktsForAlloc: TicketInfoForAllocation[];
    recAlloc: boolean | null;
    nonConsecSeats: boolean | null;
}

export interface TicketInfoForAllocation {
    id: number;
    row: string | null;
    seat: string;
    listingId: number | null;
    listingOrd: number | null;
    ticketOrd: number;
    purchasedBy: string | null;
    vendorId: number | null;
    vendorName: string | null;
    vendorAccId: string | null;
    vendorAccEmail: string | null;
    vendorAccName: string | null;
    isListingOnAdminHold: boolean | null;
    officeId: number | null;
}

export interface ValueTupleOfLongAndNullableBoolean {
    item1: number;
    item2: boolean | null;
}

export interface PosManagedMarketplaceSaleInput {
    listingId: number;
    saleId: number | null;
    marketplaceSaleId: PosFieldOfString | null;
    posEventId: string;
    viagogoEventId: number | null;
    eventMappingId: string | null;
    venueId: number | null;
    saleDate: PosFieldOfNullableDateTime | null;
    currencyCode: PosFieldOfString | null;
    totalNetProceeds: PosFieldOfNullableDecimal | null;
    inHandDate: PosFieldOfNullableDateTime | null;
    quantitySold: PosFieldOfNullableInteger | null;
    section: PosFieldOfString | null;
    row: PosFieldOfString | null;
    seatFrom: PosFieldOfString | null;
    seatTo: PosFieldOfString | null;
    ticketType: PosFieldOfNullableTicketType | null;
    buyerName: PosFieldOfString | null;
    buyerEmail: PosFieldOfString | null;
    buyerPhone: PosFieldOfString | null;
    listingNotes: PosFieldArrayOfListingNote | null;
    saleStatus: PosFieldOfNullablePointOfSaleSaleStatus | null;
    paymentState: PosFieldOfNullablePointOfSalePaymentState | null;
    fulfillerSellerUserId: PosFieldOfNullableGuid | null;
    internalNotes: PosFieldOfString | null;
}

export interface PosFieldOfNullablePointOfSaleSaleStatus {
    value: PointOfSaleSaleStatus | null;
    hasChanged: boolean;
}

export interface PosFieldOfNullablePointOfSalePaymentState {
    value: PointOfSalePaymentState | null;
    hasChanged: boolean;
}

export interface CreateRetailSaleGroupResponse {
    salesGroupId: string | null;
    sales: CreateRetailSaleWithPaymentResponse[];
    success: boolean;
    message: string | null;
}

export interface CreateRetailSaleWithPaymentResponse {
    saleId: number;
    salesGroupId: string;
    marketplacePaymentId: number | null;
    merchantReference: string | null;
    paymentMapped: boolean;
    message: string | null;
}

export interface CreateRetailSaleGroupInput {
    ticketIds: number[];
    placeholderSelections: RetailSalePlaceholderSelection[] | null;
    salesGroupName: string | null;
    saleDate: string | null;
    currencyCode: string | null;
    inHandDate: string | null;
    ticketType: TicketType | null;
    buyerName: string | null;
    buyerEmail: string | null;
    buyerPhone: string | null;
    internalNotes: string | null;
    saleStatus: PointOfSaleSaleStatus | null;
    totalNetProceeds: number | null;
    lineItems: RetailSaleLineItemInput[] | null;
    externalPaymentMethodType: ExternalPaymentMethodType | null;
    externalPaymentNote: string | null;
    customPaymentTypeName: string | null;
    externalPaymentAmount: number | null;
    externalPaymentDate: string | null;
    isNoFulfill: boolean | null;
}

export interface RetailSalePlaceholderSelection {
    listingId: number;
    quantitySold: number;
}

export interface RetailSaleLineItemInput {
    paymentLineType: MarketplacePaymentLineType;
    amount: number;
    ratePercent: number | null;
    reference: string | null;
    description: string | null;
    saleLineItemChargeReason: SaleLineItemChargeReason | null;
    saleLineItemCreditReason: SaleLineItemCreditReason | null;
}

export interface CreateRetailSaleInput {
    listingId: number;
    ticketIds: number[];
    quantitySold: number | null;
    saleDate: string | null;
    currencyCode: string | null;
    inHandDate: string | null;
    ticketType: TicketType | null;
    buyerName: string | null;
    buyerEmail: string | null;
    buyerPhone: string | null;
    internalNotes: string | null;
    saleStatus: PointOfSaleSaleStatus | null;
    totalNetProceeds: number | null;
    lineItems: RetailSaleLineItemInput[] | null;
    externalPaymentMethodType: ExternalPaymentMethodType | null;
    externalPaymentNote: string | null;
    customPaymentTypeName: string | null;
    externalPaymentAmount: number | null;
    externalPaymentDate: string | null;
    marketplaceSaleId: string | null;
    isNoFulfill: boolean | null;
}

export interface MarketplaceSaleInput {
    listingId: number;
    saleId: number | null;
    marketplace: Marketplace;
    marketplaceSaleId: PosFieldOfString | null;
    posEventId: string;
    viagogoEventId: number | null;
    eventMappingId: string | null;
    venueId: number | null;
    saleDate: PosFieldOfNullableDateTime | null;
    currencyCode: PosFieldOfString | null;
    totalNetProceeds: PosFieldOfNullableDecimal | null;
    inHandDate: PosFieldOfNullableDateTime | null;
    quantitySold: PosFieldOfNullableInteger | null;
    section: PosFieldOfString | null;
    row: PosFieldOfString | null;
    seatFrom: PosFieldOfString | null;
    seatTo: PosFieldOfString | null;
    ticketType: PosFieldOfNullableTicketType | null;
    buyerName: PosFieldOfString | null;
    buyerEmail: PosFieldOfString | null;
    buyerPhone: PosFieldOfString | null;
    listingNotes: PosFieldArrayOfListingNote | null;
    saleStatus: PosFieldOfNullablePointOfSaleSaleStatus | null;
    paymentState: PosFieldOfNullablePointOfSalePaymentState | null;
    fulfillerSellerUserId: PosFieldOfNullableGuid | null;
    internalNotes: PosFieldOfString | null;
}

export interface BuyerInfo {
    email: string;
    name: string;
    phone: string;
    billingAddressJson: string | null;
    cardSummary: string | null;
}

export interface WasteListingTicketsInput {
    listingId: number;
}

export interface UnwasteSaleInput {
    saleId: number;
}

export interface AggregatedSaleMetric {
    dateTime: string;
    marketplaceId: number;
    totalQuantity: number;
    totalRevenue: number;
    totalPnL: number;
    totalNetProceeds: number;
    totalFees: number;
    maxSaleTimestamp: string;
}

export enum AggregateMetricsTimePeriod {
    UnspecifiedAggregatedSaleMetricsTimePeriod = "UnspecifiedAggregatedSaleMetricsTimePeriod",
    Today = "Today",
    LastWeek = "LastWeek",
    LastMonth = "LastMonth",
    LastThreeMonths = "LastThreeMonths",
    LastSixMonths = "LastSixMonths",
    Ytd = "Ytd",
    LastYear = "LastYear",
    LastFiveYears = "LastFiveYears",
    All = "All",
}

export interface ApplyExternalPaymentGroupResponse {
    salesGroupId: string | null;
    saleId: number | null;
    marketplacePaymentState: MarketplacePaymentState;
    pointOfSalePaymentState: PointOfSalePaymentState;
}

export interface ApplyExternalPaymentInput {
    externalPaymentMethodType: ExternalPaymentMethodType;
    externalPaymentNote: string | null;
    customPaymentTypeName: string | null;
    externalPaymentAmount: number | null;
    externalPaymentDate: string | null;
    coverages: SaleLineItemCoverage[] | null;
}

export interface ApplyExternalPaymentResponse {
    saleId: number;
    marketplacePaymentState: MarketplacePaymentState;
    pointOfSalePaymentState: PointOfSalePaymentState;
}

export interface RefundSaleToCreditInput {
    saleId: number;
    amount: number;
    notes: string | null;
}

export interface SaleAggregationResponse {
    summary: SaleAggregationSummary;
    byOriginalCurrency: SaleCurrencyBreakdown[] | null;
    metadata: AggregationResponseMetadata;
}

export interface SaleAggregationSummary {
    totalTickets: number;
    totalQuantityWasted: number;
    totalNetProceeds: UiMoney | null;
    totalSoldTicketCost: UiMoney | null;
    totalProfitAndLoss: UiMoney | null;
    averageMargin: number | null;
    totalCharges: UiMoney | null;
    totalCredits: UiMoney | null;
    totalPayment: UiMoney | null;
    totalConvertedPayment: UiMoney | null;
    totalPaymentAmountReceived: UiMoney | null;
    currency: string;
    saleCount: number;
}

export interface SaleCurrencyBreakdown {
    currency: string;
    documentCount: number;
    summary: SaleAggregationSummary;
}

export interface MultiCurrencyAggregationRequestOfSaleSearchRequestV2AndSaleFilterQueryV2 {
    request: SaleSearchRequestV2;
    targetCurrency: string;
    includeCurrencyBreakdown: boolean;
}

export interface OpenSearchRequestOfSaleFilterQueryV2 {
    filter: SaleFilterQueryV2;
    options: SearchOptions | null;
    allowedFields: string[] | null;
    appliedSecurityFilters: string[] | null;
    dataIsolationContext: { [key: string]: any; } | null;
}

export interface SaleSearchRequestV2 extends OpenSearchRequestOfSaleFilterQueryV2 {
}

export interface SaleFilterQueryV2 {
    eventIds: FieldFilter | null;
    eventDates: FieldFilter | null;
    eventTimeFrameFilters: FieldFilter | null;
    clientTimezoneOffsetMins: number | null;
    eventStatuses: FieldFilter | null;
    topLevelCategories: FieldFilter | null;
    parentCategories: FieldFilter | null;
    lastSaleDates: FieldFilter | null;
    numberOfAvailableTickets: FieldFilter | null;
    eventHasUnsoldTickets: FieldFilter | null;
    eventOrMappingIds: FieldFilter | null;
    oldPosEventIds: FieldFilter | null;
    performerIds: FieldFilter | null;
    venueIds: FieldFilter | null;
    countryCodes: FieldFilter | null;
    stateProvinceIds: FieldFilter | null;
    cityIds: FieldFilter | null;
    fulfillmentStates: FieldFilter | null;
    inHandDates: FieldFilter | null;
    ticketTypes: FieldFilter | null;
    fulfilledBySellerIds: FieldFilter | null;
    isPlaceholder: FieldFilter | null;
    fulfillmentDates: FieldFilter | null;
    isNoFulfill: FieldFilter | null;
    cancellationDates: FieldFilter | null;
    soldOnMarketplace: FieldFilter | null;
    saleDates: FieldFilter | null;
    listingInsertBy: FieldFilter | null;
    paymentStates: FieldFilter | null;
    marketplacePaymentStates: FieldFilter | null;
    paymentReferenceIds: FieldFilter | null;
    paymentDates: FieldFilter | null;
    isPaymentReceived: FieldFilter | null;
    currencyCodes: FieldFilter | null;
    sections: FieldFilter | null;
    rows: FieldFilter | null;
    internalNotes: FieldFilter | null;
    tagPairs: TagPairFilter | null;
    eventTagPairs: TagPairFilter | null;
    listingTagPairs: TagPairFilter | null;
    purchaseOrderTagPairs: TagPairFilter | null;
    purchaseOrdersFilter: PurchaseOrderNestedFilter | null;
    isSeatSaver: FieldFilter | null;
    saleStatuses: FieldFilter | null;
    marketplaceFulfillmentState: FieldFilter | null;
    marketplaceContractState: FieldFilter | null;
    saleIds: FieldFilter | null;
    listingIds: FieldFilter | null;
    prices: FieldFilter | null;
    unitCosts: FieldFilter | null;
    quantitySold: FieldFilter | null;
    quantityWasted: FieldFilter | null;
    and: SaleFilterQueryV2[] | null;
    or: SaleFilterQueryV2[] | null;
    orConditions: SaleFilterQueryV2[] | null;
    not: boolean | null;
    orFulfillerSellerUserId: string | null;
    orFulfillerSellerUserIds: string[] | null;
    orPricerSellerUserId: string | null;
    orPricerSellerUserIds: string[] | null;
    orPurchaseBuyerId: string | null;
    orPurchaseBuyerIds: string[] | null;
}

export interface SecureSalesSearchMappedResult {
    sales: SaleWithCatalogData[];
    total: number;
    took: number;
    maxScore: number | null;
    timedOut: boolean;
    appliedSecurityFilters: string[] | null;
    allowedFieldCount: number;
    aggregations: { [key: string]: AggregationResult; } | null;
    pitId: string | null;
    searchAfter: any[] | null;
    hasNextPage: boolean;
}

export interface SearchResult {
    name: string | null;
    id: string | null;
    ownerUserId: string | null;
    count: number | null;
    entityIds: number[] | null;
    lastFetchDate: string | null;
}

export interface PurchaseSearchResult extends SearchResult {
    query: PurchaseOrderQuery | null;
    queryV2: PurchaseOrderQueryV2 | null;
}

export interface SaleSearchResult extends SearchResult {
    query: SaleQuery | null;
    queryV2: SaleQueryV2 | null;
}

export interface InventorySearchResult extends SearchResult {
    query: ListingQuery | null;
    queryV2: ListingQueryV2 | null;
}

export interface SellerUserAccountInfo {
    userId: string;
    consigneeSellerAccountId: string | null;
    displayName: string;
    email: string;
    isDeactivated: boolean;
    isTeam: boolean;
    roles: number[];
    userGroupIds: number[];
    teamSellerUserIds: string[] | null;
}

export interface SellerRoleInfo {
    id: number;
    consigneeSellerAccountId: string | null;
    prefinedRole: Role | null;
    name: string;
    details: string | null;
    isDeleted: boolean;
    permissions: Permission[];
}

export enum Role {
    Owner = "Owner",
    Buyer = "Buyer",
    FinanceAPI = "FinanceAPI",
    Fulfillment = "Fulfillment",
    Pricer = "Pricer",
    Processor = "Processor",
    AutoPO = "AutoPO",
    AutoFulfill = "AutoFulfill",
    AutoPricer = "AutoPricer",
    Reporter = "Reporter",
    Finance = "Finance",
}

export interface SellerPermissionInfo {
    name: string;
    permission: Permission;
    area: PermissionAccessArea;
    details: string;
}

export enum PermissionAccessArea {
    General = "General",
    Inventory = "Inventory",
    Sales = "Sales",
    Purchases = "Purchases",
    Events = "Events",
    Account = "Account",
    Reporting = "Reporting",
    Messages = "Messages",
    Accounting = "Accounting",
    AdPlatform = "AdPlatform",
}

export interface SellerUserInput {
    sellerUserId: string;
    consigneeSellerAccountId: string | null;
    displayName: string;
    roles: number[];
    userGroupIds: number[];
    teamSellerUserIds: string[] | null;
}

export interface SellerUser {
    sellerUserId: string;
    stubHubLoginId: string;
    sellerDisplayName: string;
    sellerUserName: string;
    email: string;
    deleteDate: string | null;
}

export interface SellerUserRolesInput {
    sellerUserId: string;
    consigneeSellerAccountId: string | null;
    roles: number[];
}

export interface SellerUserAccountInput {
    sellerUserId: string;
    consigneeSellerAccountId: string | null;
}

export interface SyncCenterSettings {
    defaultSplitType: SplitType | null;
    defaultSplitTypeForSeatSaver: SplitType | null;
    ticketTypeRules: TicketTypeRule[] | null;
    inHandDatePaddingInDays: number | null;
    defaultHideSeatNumbers: boolean | null;
    priceFloor: number | null;
    defaultMaxQuantityDisplay: number | null;
    marketplaceSettings: MarketplaceAccountSettingInput[] | null;
    adminHoldIndefinitelyForCancelledSales: boolean | null;
    inHandDaysBeforeEvent: number | null;
    placeholderInHandDaysBeforeEvent: number | null;
    isAutoPoQualityControlled: boolean | null;
    isAutoAddCancelledProceedsEnabled: boolean | null;
    isAutoLinkSaleLineItemEnabled: boolean | null;
    enableListingSplitOnDiscontinuousOrdinal: boolean | null;
    defaultManualMaxDisplayQuantity: number | null;
    showUnbroadcastListingsInComps: boolean | null;
    excludeParkingEventsFromEventSearch: boolean | null;
    includeOverPaymentForUnitCost: boolean | null;
    defaultFloorPercentOfMarketPrice: number | null;
}

export interface TicketTypeRule {
    deliveryType: DeliveryType;
    ticketTypePriorityOrders: TicketTypePriorityOrder[];
}

export interface TicketTypePriorityOrder {
    ticketType: TicketType;
    priorityOrder: number | null;
    blocked: boolean | null;
}

export interface MarketplaceAccountSettingInput {
    marketplace: Marketplace;
    isEnabled: boolean;
    markup: number | null;
    sellerFee: number | null;
    userName: string | null;
    tokenVersion: number | null;
    paymentTerm: MarketplacePaymentTerm;
    broadcastHoldDurationInDays: number | null;
    maxHoldDurationInHours: number | null;
}

export interface AccountAutoPricingSettingsInputs extends AutoPricingInputs {
    defaultCompListingQuantityFilters: CompListingQuantityFiltersCollection | null;
    compRowOffsetMode: CompRowOffsetMode | null;
    autoPricingPauseType: AutoPricingPauseType | null;
    compFailureActionType: AutoPricingCompFailureActionType | null;
}

export interface CompListingQuantityFiltersCollection {
    exactMatchQuantityFilters: CompListingQuantityFilters[] | null;
    greaterThanOrEqualToQuantityFilter: CompListingQuantityFilters | null;
}

export interface CompListingQuantityFilters {
    posListingQuantity: number;
    compQuantityFilters: CompListingQuantity;
}

export enum AutoPricingPauseType {
    PriceDecreases = "PriceDecreases",
    AllPriceUpdates = "AllPriceUpdates",
}

export enum AutoPricingCompFailureActionType {
    DontChangePrice = "DontChangePrice",
    SetPriceToCeiling = "SetPriceToCeiling",
}

export interface AutoCurrencyConversionSettings {
    enabled: boolean;
    defaultCurrencyCode: string | null;
    ignoredCurrencyCodes: string[] | null;
}

export interface TimezoneInfo {
    value: string;
    timezoneOffsetMins: number;
}

export interface SellerRoleInput {
    id: number;
    consigneeSellerAccountId: string | null;
    name: string | null;
    details: string | null;
    permissions: Permission[] | null;
    userIds: string[] | null;
}

export interface TradeDeskPasswordResetInput {
    username: string;
    oldPassword: string | null;
    newPassword: string;
    code: string;
}

export interface RevealMarketExternalPosSyncConfig {
    overrideRevealSyncDateRelativeStartSecs: number | null;
    overrideRevealSyncDateRelativeEndSecs: number | null;
    overrideRevealSyncDateStart: string | null;
    overrideRevealSyncDateEnd: string | null;
    overrideRevealSyncDateRoundingMode: RelativeTimeRoundingMode | null;

    [key: string]: any;
}

export interface RevealSyncConfigOverrideInput {
    syncDateOverride: DateTimeRangeWithRelative;
}

export interface ConfirmationDialogSettingsResponse {
    settings: { [key in keyof typeof ConfirmationDialogType]?: ConfirmationDialogSettingItem; };
    metadata: ConfirmationDialogMetadata[];
}

export enum ConfirmationDialogType {
    FloorCeilingViolation = "FloorCeilingViolation",
    SuspiciousPriceChange = "SuspiciousPriceChange",
    AutoPricingDisable = "AutoPricingDisable",
    AbsolutePriceDrop = "AbsolutePriceDrop",
    RelativePriceDrop = "RelativePriceDrop",
    RelativeFloorPriceDrop = "RelativeFloorPriceDrop",
    PriceStaggerFloorPriceDrop = "PriceStaggerFloorPriceDrop",
}

export interface ConfirmationDialogSettingItem {
    isActive: boolean;
    absoluteThreshold: number | null;
    relativeThreshold: number | null;
}

export interface ConfirmationDialogMetadata {
    dialogType: ConfirmationDialogType;
    thresholdType: ConfirmationDialogThresholdType;
}

export enum ConfirmationDialogThresholdType {
    None = "None",
    Absolute = "Absolute",
    Relative = "Relative",
    Both = "Both",
}

export interface ConfirmationDialogSettingRequest {
    settings: ConfirmationDialogSettingRequestItem[];
}

export interface ConfirmationDialogSettingRequestItem {
    confirmationDialogType: ConfirmationDialogType;
    isActive: boolean;
    absoluteThreshold: number | null;
    relativeThreshold: number | null;
}

export interface PurchaseOrderSettings {
    isAutoGeneratedVendorOrderIdEnabled: boolean | null;
    vendorOrderIdPrefix: string | null;
    excludeParkingEventsFromEventSearch: boolean | null;
}

export interface ListingGroupSettings {
    defaultExcludeFullySoldInGroup: boolean | null;
    defaultCollapseListingGroups: boolean | null;
    desiredActiveListings: number | null;
    pricingSettingsJson: string | null;
    deprioritizedQuantities: string | null;
    defaultSectionSplitTypeId: number | null;
    defaultRowSplits: string | null;
    defaultSortId: number | null;
}

export interface AutoBroadcastSettings {
    autoBroadcastManuallyPricedListings: boolean | null;
}

export interface UnbroadcastOnRescheduleSettings {
    unbroadcastOnReschedule: boolean | null;
}

export interface SeatSaverDefaultSettings {
    defaultQuantityForSeatSaver: number | null;
    defaultManualMaxDisplayQuantityForSeatSaver: number | null;
}

export interface ExternalPaymentType {
    id: number;
    name: string;
}

export interface SellerAccountFulfillmentRuleDto {
    sellerAccountFulfillmentRuleId: number;
    fulfillerSellerUserId: string;
    fulfillmentRuleTargetType: FulfillmentRuleTargetType;
    viagogoEventId: number | null;
    eventMappingId: string | null;
    purchaseOrderVendorId: number | null;
    purchaseOrderId: number | null;
    viagogoVenueId: number | null;
}

export enum FulfillmentRuleTargetType {
    Event = "Event",
    Vendor = "Vendor",
    Venue = "Venue",
    PurchaseOrder = "PurchaseOrder",
}

export interface SellerAccountFulfillmentRulesInput {
    sellerAccountFulfillmentRulesId: number | null;
    fulfillerSellerUserId: string;
    fulfillmentRuleTargetTypeId: number;
    viagogoEventId: number | null;
    eventMappingId: string | null;
    purchaseOrderVendorId: number | null;
    purchaseOrderId: number | null;
    viagogoVenueId: number | null;
}

export interface SellerAccountFulfillmentRule {
    sellerAccountFulfillmentRuleId: number;
    fulfillerSellerUserId: string;
    fulfillmentRuleTargetType: FulfillmentRuleTargetType;
    viagogoEventId: number | null;
    eventMappingId: string | null;
    eventName: string | null;
    purchaseOrderVendorId: number | null;
    purchaseOrderId: number | null;
    viagogoVenueId: number | null;
    venueName: string | null;
}

export interface SellerUserSetting {
    userSetting: UserSetting;
    userSettingValue: string;
}

export enum UserSetting {
    QuickFiltersStateInventory = "QuickFiltersStateInventory",
    QuickFiltersCustomInventory = "QuickFiltersCustomInventory",
    QuickFiltersStateSales = "QuickFiltersStateSales",
    QuickFiltersCustomSales = "QuickFiltersCustomSales",
    QuickFiltersStatePurchases = "QuickFiltersStatePurchases",
    QuickFiltersCustomPurchases = "QuickFiltersCustomPurchases",
    SalesViewSelected = "SalesViewSelected",
    SuspiciousPriceChange = "SuspiciousPriceChange",
    InternationalCompliance = "InternationalCompliance",
    InventoryPageViewMode = "InventoryPageViewMode",
    InventoryColumnOrder = "InventoryColumnOrder",
    InventoryColumnNumberPrecision = "InventoryColumnNumberPrecision",
    InventoryColumnWidths = "InventoryColumnWidths",
    InventoryCustomColumns = "InventoryCustomColumns",
    InventoryColumnEditability = "InventoryColumnEditability",
    SaleColumnOrder = "SaleColumnOrder",
    SaleCustomColumns = "SaleCustomColumns",
    SaleColumnEditability = "SaleColumnEditability",
    SaleColumnNumberPrecision = "SaleColumnNumberPrecision",
    ReportConfigInventory = "ReportConfigInventory",
    ReportConfigSale = "ReportConfigSale",
    EventsColumnOrder = "EventsColumnOrder",
    EventsCustomColumns = "EventsCustomColumns",
    EventsColumnEditability = "EventsColumnEditability",
    EventsColumnNumberPrecision = "EventsColumnNumberPrecision",
    SiteTheme = "SiteTheme",
    ReportingColumnLimit = "ReportingColumnLimit",
    PriceFloorCeilingMode = "PriceFloorCeilingMode",
    ReleaseNoteIdsRead = "ReleaseNoteIdsRead",
    EventsColumnsEnabled = "EventsColumnsEnabled",
    InventoryColumnsEnabled = "InventoryColumnsEnabled",
    SaleColumnsEnabled = "SaleColumnsEnabled",
    SiteZoom = "SiteZoom",
    InventoryDefaultTab = "InventoryDefaultTab",
    PurchaseColumnOrder = "PurchaseColumnOrder",
    PurchaseCustomColumns = "PurchaseCustomColumns",
    PurchaseColumnEditability = "PurchaseColumnEditability",
    PurchaseColumnNumberPrecision = "PurchaseColumnNumberPrecision",
    PurchaseColumnsEnabled = "PurchaseColumnsEnabled",
    InventoryFlattenedColumnOrder = "InventoryFlattenedColumnOrder",
    InventoryFlattenedColumnsEnabled = "InventoryFlattenedColumnsEnabled",
    InventoryFlattenedColumnEditability = "InventoryFlattenedColumnEditability",
    InventoryFlattenedColumnNumberPrecision = "InventoryFlattenedColumnNumberPrecision",
    SaleFlattenedColumnOrder = "SaleFlattenedColumnOrder",
    SaleFlattenedColumnsEnabled = "SaleFlattenedColumnsEnabled",
    SaleFlattenedColumnEditability = "SaleFlattenedColumnEditability",
    SaleFlattenedColumnNumberPrecision = "SaleFlattenedColumnNumberPrecision",
    SaleColumnWidths = "SaleColumnWidths",
    PurchaseColumnWidths = "PurchaseColumnWidths",
    InventoryV2DefaultTab = "InventoryV2DefaultTab",
    SalePageViewMode = "SalePageViewMode",
    PurchasePageViewMode = "PurchasePageViewMode",
    InventoryReportColumnWidths = "InventoryReportColumnWidths",
    SaleReportColumnWidths = "SaleReportColumnWidths",
    EventsColumnWidths = "EventsColumnWidths",
    PurchaseEventColumnOrder = "PurchaseEventColumnOrder",
    PurchaseEventColumnsEnabled = "PurchaseEventColumnsEnabled",
    PurchaseEventColumnEditability = "PurchaseEventColumnEditability",
    PurchaseEventColumnNumberPrecision = "PurchaseEventColumnNumberPrecision",
    PurchaseEventColumnWidths = "PurchaseEventColumnWidths",
    SidePanelWidths = "SidePanelWidths",
    SalesDefaultTab = "SalesDefaultTab",
    PurchasesDefaultTab = "PurchasesDefaultTab",
    SalesSideTableColumnOrder = "SalesSideTableColumnOrder",
    SalesSideTableColumnsEnabled = "SalesSideTableColumnsEnabled",
    SalesSideTableColumnEditability = "SalesSideTableColumnEditability",
    SalesSideTableColumnNumberPrecision = "SalesSideTableColumnNumberPrecision",
    PurchaseSideTableColumnOrder = "PurchaseSideTableColumnOrder",
    PurchaseSideTableColumnsEnabled = "PurchaseSideTableColumnsEnabled",
    PurchaseSideTableColumnEditability = "PurchaseSideTableColumnEditability",
    PurchaseSideTableColumnNumberPrecision = "PurchaseSideTableColumnNumberPrecision",
    InventorySideTableColumnOrder = "InventorySideTableColumnOrder",
    InventorySideTableColumnsEnabled = "InventorySideTableColumnsEnabled",
    InventorySideTableColumnEditability = "InventorySideTableColumnEditability",
    InventorySideTableColumnNumberPrecision = "InventorySideTableColumnNumberPrecision",
    MarketplacePaymentsTableColumnOrder = "MarketplacePaymentsTableColumnOrder",
    MarketplacePaymentsCustomColumns = "MarketplacePaymentsCustomColumns",
    MarketplacePaymentsTableColumnsEnabled = "MarketplacePaymentsTableColumnsEnabled",
    MarketplacePaymentsColumnNumberPrecision = "MarketplacePaymentsColumnNumberPrecision",
    MarketplacePaymentsColumnEditability = "MarketplacePaymentsColumnEditability",
    MarketplacePaymentsColumnsWidth = "MarketplacePaymentsColumnsWidth",
    QuickFloorPromptDismissal = "QuickFloorPromptDismissal",
    QuickFiltersCustomMarketplacePayments = "QuickFiltersCustomMarketplacePayments",
    QuickFiltersStateMarketplacePayments = "QuickFiltersStateMarketplacePayments",
    QuickFiltersStateOnSaleEvent = "QuickFiltersStateOnSaleEvent",
    QuickFiltersCustomOnSaleEvent = "QuickFiltersCustomOnSaleEvent",
    OnSaleEventColumnsOrder = "OnSaleEventColumnsOrder",
    OnSaleEventColumnsWidths = "OnSaleEventColumnsWidths",
    OnSaleEventColumnNumberPrecision = "OnSaleEventColumnNumberPrecision",
    OnSaleEventCustomColumns = "OnSaleEventCustomColumns",
    OnSaleEventColumnEditability = "OnSaleEventColumnEditability",
    OnSaleEventColumnsEnabled = "OnSaleEventColumnsEnabled",
    FirstTimeFeaturesViewed = "FirstTimeFeaturesViewed",
    InventoryMenuTabFavorite = "InventoryMenuTabFavorite",
    SaleMenuTabFavorite = "SaleMenuTabFavorite",
    PurchaseMenuTabFavorite = "PurchaseMenuTabFavorite",
    RecentSalesTableColumnsWidths = "RecentSalesTableColumnsWidths",
    RecentSalesTableColumnsOrder = "RecentSalesTableColumnsOrder",
    RecentSalesTableColumnsEnabled = "RecentSalesTableColumnsEnabled",
    RecentSalesTableColumnNumberPrecision = "RecentSalesTableColumnNumberPrecision",
    RecentSalesTableColumnEditability = "RecentSalesTableColumnEditability",
    ReportCustomColumnInventory = "ReportCustomColumnInventory",
    ReportCustomColumnSales = "ReportCustomColumnSales",
    ReportCustomColumnSaleLineItem = "ReportCustomColumnSaleLineItem",
    ReportCustomColumnSoldTicket = "ReportCustomColumnSoldTicket",
    ReportCustomColumnPurchase = "ReportCustomColumnPurchase",
    ReportCustomColumnCommission = "ReportCustomColumnCommission",
    ReportV2InventoryColumnWidths = "ReportV2InventoryColumnWidths",
    ReportV2SaleColumnWidths = "ReportV2SaleColumnWidths",
    ReportV2CommissionColumnWidths = "ReportV2CommissionColumnWidths",
    ReportV2PurchaseColumnWidths = "ReportV2PurchaseColumnWidths",
    ReportV2SaleLineItemColumnWidths = "ReportV2SaleLineItemColumnWidths",
    ReportV2SoldTicketColumnWidths = "ReportV2SoldTicketColumnWidths",
    ReportV2PurchaseOrderLineItemColumnWidths = "ReportV2PurchaseOrderLineItemColumnWidths",
    ReportV2ColumnNumberPrecision = "ReportV2ColumnNumberPrecision",
    ReportCustomColumnCostOfGoodsSold = "ReportCustomColumnCostOfGoodsSold",
    ReportCostOfGoodsSoldColumnWidths = "ReportCostOfGoodsSoldColumnWidths",
    ReportCustomColumnSaleCostAdjustments = "ReportCustomColumnSaleCostAdjustments",
    ReportSaleCostAdjustmentsColumnWidths = "ReportSaleCostAdjustmentsColumnWidths",
    EnableSelectionByDefault = "EnableSelectionByDefault",
    GroupInventoryEventView = "GroupInventoryEventView",
    FavoriteVendorIds = "FavoriteVendorIds",
    EnableNotifications = "EnableNotifications",
    ReportCustomColumnTicketGroup = "ReportCustomColumnTicketGroup",
    ReportTicketGroupColumnWidths = "ReportTicketGroupColumnWidths",
    InventoryPortfolioColumnSort = "InventoryPortfolioColumnSort",
    InventoryEventColumnSort = "InventoryEventColumnSort",
    PurchasePortfolioColumnSort = "PurchasePortfolioColumnSort",
    PurchaseEventColumnSort = "PurchaseEventColumnSort",
    SalePortfolioColumnSort = "SalePortfolioColumnSort",
    SaleEventColumnSort = "SaleEventColumnSort",
    InventorySearchColumnSort = "InventorySearchColumnSort",
    PurchaseSearchColumnSort = "PurchaseSearchColumnSort",
    SaleSearchColumnSort = "SaleSearchColumnSort",
    SaleSearchPageSize = "SaleSearchPageSize",
    ListingSearchPageSize = "ListingSearchPageSize",
    PurchaseSearchPageSize = "PurchaseSearchPageSize",
    HasCreatedAdCampaign = "HasCreatedAdCampaign",
    FavoriteQuickFilterInventory = "FavoriteQuickFilterInventory",
    RetailTableColumnsWidths = "RetailTableColumnsWidths",
    RetailTableColumnsOrder = "RetailTableColumnsOrder",
    RetailTableColumnsEnabled = "RetailTableColumnsEnabled",
    RetailTableColumnNumberPrecision = "RetailTableColumnNumberPrecision",
    RetailTableColumnEditability = "RetailTableColumnEditability",
    CustomTabs = "CustomTabs",
    CampaignsCustomColumns = "CampaignsCustomColumns",
    CampaignsColumnNumberPrecision = "CampaignsColumnNumberPrecision",
    CampaignsColumnEditability = "CampaignsColumnEditability",
    CampaignsColumnOrder = "CampaignsColumnOrder",
    CampaignsColumnsEnabled = "CampaignsColumnsEnabled",
    FlightsCustomColumns = "FlightsCustomColumns",
    FlightsColumnNumberPrecision = "FlightsColumnNumberPrecision",
    FlightsColumnEditability = "FlightsColumnEditability",
    FlightsColumnOrder = "FlightsColumnOrder",
    FlightsColumnsEnabled = "FlightsColumnsEnabled",
}

export interface CustomQuickFilterOfListingQuery {
    schemaVersion: string;
    id: string;
    name: string;
    data: ListingQuery;
}

export interface CustomQuickFilterOfOnSaleEventQuery {
    schemaVersion: string;
    id: string;
    name: string;
    data: OnSaleEventQuery;
}

export interface CustomQuickFilterOfSaleQuery {
    schemaVersion: string;
    id: string;
    name: string;
    data: SaleQuery;
}

export interface CustomQuickFilterOfPurchaseOrderQuery {
    schemaVersion: string;
    id: string;
    name: string;
    data: PurchaseOrderQuery;
}

export interface CustomQuickFilterOfMarketplacePaymentQuery {
    schemaVersion: string;
    id: string;
    name: string;
    data: MarketplacePaymentQuery;
}

export interface ReleaseNote {
    id: number;
    title: string;
    releaseNoteType: ReleaseNoteType;
    descriptionHtml: string | null;
    releaseNoteGetAccessDate: string;
}

export enum ReleaseNoteType {
    NewFeature = "NewFeature",
    BugFix = "BugFix",
}

export interface TutorialItem {
    tutorialItemId: number;
    title: string;
    titleContentId: number | null;
    parentTutorialItemId: number | null;
    tutorialItemType: TutorialItemType;
}

export enum TutorialItemType {
    Folder = "Folder",
    Document = "Document",
}

export interface TutorialItemContent {
    tutorialItemId: number;
    tutorialItemContentId: number | null;
    contentHtml: string;
}

export interface SellerEventConfirmationDialogSuppression {
    eventVirtualId: string;
    confirmationDialogType: ConfirmationDialogType;
    startDate: string;
    endDate: string;
}

export interface PosActionResult {
    succeeded: boolean;
    errorStatusCode: number | null;
    errorMessage: string | null;
}

export interface InsertSellerEventConfirmationDialogSuppressionRequest {
    viagogoVirtualId: string;
    confirmationDialogType: ConfirmationDialogType;
    durationHours: number;
}

export interface TeamInfo {
    teamSellerUserId: string;
    teamName: string;
    isDeactivated: boolean;
    sellerUserIds: string[];
}

export interface TeamMemberDto {
    sellerUserId: string;
    displayName: string;
    email: string;
    teamName: string;
}

export interface TeamInput {
    teamName: string;
    memberSellerUserIds: string[] | null;
}

export interface TeamUpdateInput {
    teamSellerUserId: string;
    teamName: string;
    memberSellerUserIds: string[] | null;
}

export interface TeamAccountInput {
    teamSellerUserId: string;
}

export interface DeliveryTypeTicketTypeMapping {
    deliveryType: DeliveryType;
    ticketTypes: { [key in keyof typeof TicketType]?: number[]; };
}

export interface TicketGroupMergeInput {
    intentions: TicketGroupIntention[];
    purchaseOrderId: number;
    ticketGroups: TicketGroupInput[];
    updateSalesOfListings: boolean | null;
    deallocateSales: boolean | null;
    updatePredeliveryETicketArtifacts: boolean | null;
}

export interface TicketGroupIntention {
    ticketGroupId: number;
    reason: TicketGroupEditReason;
    additionalInfo: string;
}

export enum TicketGroupEditReason {
    AmendTickets = "Amend Tickets",
    CancelTickets = "Cancel Tickets",
    AddTickets = "Add Tickets",
    ExchangeTickets = "Exchange Tickets",
    EditEvent = "Edit Event",
}

export interface UserGroup {
    userGroupId: number;
    userGroupName: string;
    userGroupDescription: string | null;
    sellerUserIds: string[];
    consigneeSellerAccountId: string | null;
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}



